import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values.BigInt can represent values between -(2^53) + 1 and 2^53 - 1. */
  BigInt: any;
  /** Used to pass pagination cursors to the frontend */
  Cursor: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  MigrateDateTime: any;
  /**
   * An identifier composed of two parts: ${collection} and ${id}:
   * - serialized to the frontend as a string `${collection}-${id}
   * - parsed in the backend as Ref(Collection(${collection}), ${id})
   */
  MigrateID: string;
  /** Used to pass set references to the frontend for streaming */
  SetRef: any;
  /** A specialised version of MigrateID, whose ${collection} refers to file metadata */
  UploadToken: any;
};

export type AcceptJobInviteInput = {
  jobInviteId: Scalars['MigrateID'];
};

export type AcceptJobInvitePayload = {
  __typename?: 'AcceptJobInvitePayload';
  application: Application;
  jobInvite: JobInvite;
};

export type Account = Createable & Entity & Updateable & WithId & {
  __typename?: 'Account';
  createdAt: Scalars['MigrateDateTime'];
  email: Scalars['String'];
  id: Scalars['MigrateID'];
  lastLoggedIn?: Maybe<Scalars['MigrateDateTime']>;
  principalId?: Maybe<Scalars['MigrateID']>;
  updatedAt: Scalars['MigrateDateTime'];
  verified: Scalars['Boolean'];
};

export type AccountManager = Createable & Entity & Updateable & User & WithId & WithPersonName & {
  __typename?: 'AccountManager';
  account?: Maybe<Account>;
  createdAt: Scalars['MigrateDateTime'];
  displayName: Scalars['String'];
  email: Scalars['String'];
  forenames: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['MigrateID'];
  isActive: Scalars['Boolean'];
  lastActiveAt?: Maybe<Scalars['MigrateDateTime']>;
  notificationsMutedUntil?: Maybe<Scalars['MigrateDateTime']>;
  /** Returns the current organisation being impersonated by the account manager */
  organisation: Organisation;
  organisationIds: Array<Scalars['MigrateID']>;
  organisations: Array<Organisation>;
  phoneNumber?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  pushToken?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  updatedAt: Scalars['MigrateDateTime'];
};

export type AddApplicationCommentInput = {
  applicationId: Scalars['MigrateID'];
  comment: Scalars['String'];
};

export type AddCandidateToJobInput = {
  candidateId: Scalars['MigrateID'];
  jobId: Scalars['MigrateID'];
};

export type AddChannelMembersInput = {
  channelId: Scalars['MigrateID'];
  userIds: Array<Scalars['MigrateID']>;
};

export type AddHiringStageInput = {
  checksTemplateId?: InputMaybe<Scalars['MigrateID']>;
  jobId: Scalars['MigrateID'];
  name: Scalars['String'];
  requiresCandidateFeedbackFrom?: InputMaybe<Scalars['Boolean']>;
  requiresCandidateFeedbackTo?: InputMaybe<Scalars['Boolean']>;
  type: HiringStageType;
};

export type AddNewCandidateApplicationInput = {
  country?: InputMaybe<Scalars['String']>;
  countryOfQualification?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  forenames: Scalars['String'];
  hiringStage: AddNewCandidateHiringStageInput;
  jobId: Scalars['MigrateID'];
  languageStatus?: InputMaybe<UpdateLanguageStatusInput>;
  photoUrl?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  pushToken?: InputMaybe<Scalars['String']>;
  registrationDetails?: InputMaybe<Array<RegistrationDetailInput>>;
  source: HirerCandidateSourceInput;
  surname: Scalars['String'];
};

export type AddNewCandidateHiringStageInput = {
  /** When adding candidate to successful stage - the proposed arrival date of the applicant. It must be in the future. */
  arrivalDate?: InputMaybe<Scalars['MigrateDateTime']>;
  /** When adding candidate to interview stage - duration in minutes */
  duration?: InputMaybe<Scalars['Int']>;
  id: Scalars['MigrateID'];
  /** When adding candidate to interview stage - the URL for the meeting link */
  meetingLink?: InputMaybe<Scalars['String']>;
  /** When adding candidate to interview stage - the interview start date. It must be in the future. */
  startDatetime?: InputMaybe<Scalars['MigrateDateTime']>;
  zoomMeetingId?: InputMaybe<Scalars['String']>;
  zoomPasscode?: InputMaybe<Scalars['String']>;
};

export type Answer = Createable & Entity & Updateable & WithId & {
  __typename?: 'Answer';
  author: User;
  content: Scalars['String'];
  createdAt: Scalars['MigrateDateTime'];
  downvotes: Scalars['Int'];
  id: Scalars['MigrateID'];
  myVoteType?: Maybe<VoteType>;
  question?: Maybe<Question>;
  updatedAt: Scalars['MigrateDateTime'];
  upvotes: Scalars['Int'];
};

export type AnswerApplicationQuestionInput = {
  matchResponseId: Scalars['MigrateID'];
  response: Scalars['String'];
};

export type AnswerPage = Page & {
  __typename?: 'AnswerPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<Answer>;
  pageCount: Scalars['Int'];
};

export type AnswerQuestionInput = {
  content: Scalars['String'];
  questionId: Scalars['MigrateID'];
};

export type AnswerVote = Createable & Entity & Updateable & WithId & {
  __typename?: 'AnswerVote';
  answer: Answer;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  type: VoteType;
  updatedAt: Scalars['MigrateDateTime'];
  user: User;
};

/** Used to sort Answers */
export enum AnswersOrderBy {
  CreatedatDesc = 'CREATEDAT_DESC'
}

export type AnswersWhereInput = {
  and?: InputMaybe<Array<AnswersWhereInput>>;
  author?: InputMaybe<MigrateIdFilterInput>;
  not?: InputMaybe<Array<AnswersWhereInput>>;
  or?: InputMaybe<Array<AnswersWhereInput>>;
  question?: InputMaybe<MigrateIdFilterInput>;
};

export type Applicant = {
  applications: ApplicationPage;
  country?: Maybe<Scalars['String']>;
  countryInfo?: Maybe<CountryInfo>;
  countryOfQualification?: Maybe<Scalars['String']>;
  countryOfQualificationInfo?: Maybe<CountryInfo>;
  createdAt: Scalars['MigrateDateTime'];
  cv?: Maybe<Document>;
  documents: DocumentPage;
  email: Scalars['String'];
  forenames: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['MigrateID'];
  languageStatus?: Maybe<LanguageStatus>;
  profession?: Maybe<Profession>;
  registrationDetails?: Maybe<Array<RegistrationDetail>>;
  relocationTimeframe?: Maybe<RelocationTimeframe>;
  source: CandidateSource;
  surname: Scalars['String'];
  ukRegistrationStatus: UkRegistrationStatus;
  updatedAt: Scalars['MigrateDateTime'];
};


export type ApplicantApplicationsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ApplicationsOrderBy>;
  where?: InputMaybe<CandidateApplicationsWhereInput>;
};


export type ApplicantDocumentsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};

export type ApplicantPage = Page & {
  __typename?: 'ApplicantPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<Applicant>;
  pageCount: Scalars['Int'];
};

export type ApplicantsReportData = {
  __typename?: 'ApplicantsReportData';
  applicationsReport: ApplicationsReportData;
  count: Scalars['Int'];
  countryCounts: CountryFieldAggregate;
  countryOfQualificationCounts: CountryFieldAggregate;
  professionCounts: ProfessionFieldAggregate;
  relocationTimeframeCounts: StringFieldAggregate;
  sourceCounts: StringFieldAggregate;
};


export type ApplicantsReportDataApplicationsReportArgs = {
  where?: InputMaybe<ApplicationsReportWhereInput>;
};

export type Application = Createable & Entity & Updateable & WithId & {
  __typename?: 'Application';
  arrivalDate?: Maybe<Scalars['MigrateDateTime']>;
  candidate: ApplicationCandidate;
  channel: ApplicationDmChannel;
  checks: Array<ApplicationCheck>;
  createdAt: Scalars['MigrateDateTime'];
  events: ApplicationEventPage;
  files?: Maybe<Array<ApplicationFile>>;
  hiringStage: HiringStage;
  id: Scalars['MigrateID'];
  interview?: Maybe<Interview>;
  job: Job;
  matchResponse?: Maybe<ApplicationApprovedMatchResponse>;
  nextHiringStage?: Maybe<HiringStage>;
  notes: Scalars['String'];
  previousChecks: Array<ApplicationCheck>;
  previousHiringStage?: Maybe<HiringStage>;
  updatedAt: Scalars['MigrateDateTime'];
};


export type ApplicationEventsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ApplicationEventsOrderBy>;
  where?: InputMaybe<ResolvedApplicationEventsWhereInput>;
};

export type ApplicationApprovedMatchResponse = Createable & Entity & MatchResponse & Updateable & WithId & {
  __typename?: 'ApplicationApprovedMatchResponse';
  application: Application;
  applicationQuestion: ApplicationQuestion;
  candidate: CandidateV2;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  job: Job;
  type: MatchResponseType;
  updatedAt: Scalars['MigrateDateTime'];
};

export type ApplicationArrivalsReport = {
  __typename?: 'ApplicationArrivalsReport';
  avg: Scalars['Float'];
  data: Array<ApplicationArrivalsReportPeriod>;
  period: ReportPeriodInterval;
};

export type ApplicationArrivalsReportData = {
  __typename?: 'ApplicationArrivalsReportData';
  count: Scalars['Int'];
};

export type ApplicationArrivalsReportPeriod = {
  __typename?: 'ApplicationArrivalsReportPeriod';
  data: ApplicationArrivalsReportData;
  period: ReportPeriodInterval;
};

export type ApplicationCandidate = Candidate | CandidateV2 | ExternalCandidate;

export type ApplicationCheck = Createable & Entity & Updateable & WithId & WithName & {
  __typename?: 'ApplicationCheck';
  completedOn?: Maybe<Scalars['MigrateDateTime']>;
  createdAt: Scalars['MigrateDateTime'];
  hiringStage: HiringStage;
  id: Scalars['MigrateID'];
  isChecked: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['MigrateDateTime'];
  updatedBy?: Maybe<User>;
};

/** To demonstrate which parts of the Application are completed */
export enum ApplicationCompletion {
  HasApplicationQuestion = 'HAS_APPLICATION_QUESTION',
  HasEducationHistory = 'HAS_EDUCATION_HISTORY',
  HasLanguageResults = 'HAS_LANGUAGE_RESULTS',
  HasPassport = 'HAS_PASSPORT',
  HasRegistrationDetails = 'HAS_REGISTRATION_DETAILS',
  HasWorkExperience = 'HAS_WORK_EXPERIENCE'
}

export type ApplicationDmChannel = Channel & Createable & DmChannel & Entity & Updateable & WithId & {
  __typename?: 'ApplicationDMChannel';
  application: Application;
  archivedAt?: Maybe<Scalars['MigrateDateTime']>;
  canReact: Scalars['Boolean'];
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  isMember: Scalars['Boolean'];
  lastMessage?: Maybe<Message>;
  members: UserPage;
  messages: MessagePage;
  mutedUntil?: Maybe<Scalars['MigrateDateTime']>;
  myChannelMember?: Maybe<ChannelMember>;
  type: ChannelType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
};


export type ApplicationDmChannelMembersArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UsersOrderBy>;
};


export type ApplicationDmChannelMessagesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MessagesOrderBy>;
  where?: InputMaybe<ResolvedMessagesWhereInput>;
};

export type ApplicationDmChannelPage = Page & {
  __typename?: 'ApplicationDMChannelPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<ApplicationDmChannel>;
  pageCount: Scalars['Int'];
};

export type ApplicationEvent = {
  actionedBy: User;
  application: Application;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  type: ApplicationEventType;
  updatedAt: Scalars['MigrateDateTime'];
};

export type ApplicationEventPage = Page & {
  __typename?: 'ApplicationEventPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<ApplicationEvent>;
  pageCount: Scalars['Int'];
};

/** The type of application event */
export enum ApplicationEventType {
  Comment = 'COMMENT',
  New = 'NEW',
  StageChange = 'STAGE_CHANGE'
}

/** Used to sort application events */
export enum ApplicationEventsOrderBy {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC'
}

export type ApplicationEventsWhereInput = {
  and?: InputMaybe<Array<ApplicationEventsWhereInput>>;
  application?: InputMaybe<MigrateIdFilterInput>;
  not?: InputMaybe<Array<ApplicationEventsWhereInput>>;
  or?: InputMaybe<Array<ApplicationEventsWhereInput>>;
};

export type ApplicationFile = Createable & Updateable & {
  __typename?: 'ApplicationFile';
  createdAt: Scalars['MigrateDateTime'];
  filename: Scalars['String'];
  id: Scalars['UploadToken'];
  owner: User;
  size?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['MigrateDateTime'];
  uploadConfirmedAt: Scalars['MigrateDateTime'];
  uploadedBy: User;
  url: Scalars['String'];
};

export type ApplicationPage = Page & {
  __typename?: 'ApplicationPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<Application>;
  pageCount: Scalars['Int'];
};

export type ApplicationQuestion = {
  __typename?: 'ApplicationQuestion';
  question: Scalars['String'];
  response?: Maybe<Scalars['String']>;
};

export type ApplicationStartMatchResponse = Createable & Entity & MatchResponse & Updateable & WithId & {
  __typename?: 'ApplicationStartMatchResponse';
  applicationCompletion: Array<ApplicationCompletion>;
  applicationQuestion: ApplicationQuestion;
  applicationQuestionResponse?: Maybe<Scalars['String']>;
  candidate: CandidateV2;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  job: Job;
  type: MatchResponseType;
  updatedAt: Scalars['MigrateDateTime'];
};

/** Sort order for applications */
export enum ApplicationsOrderBy {
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ApplicationsReportData = {
  __typename?: 'ApplicationsReportData';
  applicantsReport: ApplicantsReportData;
  count: Scalars['Int'];
  createdAtToArrivalDateInMsAvg?: Maybe<Scalars['Float']>;
  createdAtToArrivalDateInMsMax?: Maybe<Scalars['BigInt']>;
  createdAtToArrivalDateInMsMin?: Maybe<Scalars['BigInt']>;
  hasInterviewCounts: BooleanFieldAggregate;
  hiringStageCounts: HiringStageFieldAggregate;
  hiringStageTypeCounts: HiringStageTypeFieldAggregate;
};


export type ApplicationsReportDataApplicantsReportArgs = {
  where?: InputMaybe<CandidatesWhereInput>;
};

export type ApplicationsReportWhereInput = {
  and?: InputMaybe<Array<ApplicationsReportWhereInput>>;
  arrivalDate?: InputMaybe<DateFilterInput>;
  hiringStageType?: InputMaybe<HiringStageTypeFilterInput>;
  job?: InputMaybe<MigrateIdFilterInput>;
  not?: InputMaybe<Array<ApplicationsReportWhereInput>>;
  or?: InputMaybe<Array<ApplicationsReportWhereInput>>;
  organisation?: InputMaybe<MigrateIdFilterInput>;
};

export type ApplicationsWhereInput = {
  and?: InputMaybe<Array<ApplicationsWhereInput>>;
  candidate?: InputMaybe<MigrateIdFilterInput>;
  hiringStage?: InputMaybe<MigrateIdFilterInput>;
  id?: InputMaybe<MigrateIdFilterInput>;
  job?: InputMaybe<MigrateIdFilterInput>;
  not?: InputMaybe<Array<ApplicationsWhereInput>>;
  or?: InputMaybe<Array<ApplicationsWhereInput>>;
  organisation?: InputMaybe<MigrateIdFilterInput>;
};

export type ApplyForJobInput = {
  jobId: Scalars['MigrateID'];
};

export type ApplyMatchResponse = Createable & Entity & MatchResponse & Updateable & WithId & {
  __typename?: 'ApplyMatchResponse';
  applicationCompletion: Array<ApplicationCompletion>;
  applicationQuestion: ApplicationQuestion;
  candidate: CandidateV2;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  job: Job;
  type: MatchResponseType;
  updatedAt: Scalars['MigrateDateTime'];
};

export type ApproveMatchApplicationInput = {
  candidateId: Scalars['MigrateID'];
  jobId: Scalars['MigrateID'];
};

export type ApproveMatchApplicationPayload = {
  __typename?: 'ApproveMatchApplicationPayload';
  application: Application;
  applicationApprovedMatchResponse: MatchResponse;
  applicationDMChannel: ApplicationDmChannel;
  applicationEvent: SystemApplicationEvent;
};

export type ArchiveChannelInput = {
  channelId: Scalars['MigrateID'];
};

export type AskQuestionInput = {
  title: Scalars['String'];
  topicIds: Array<Scalars['MigrateID']>;
};

export type Attachment = Createable & Entity & File & Updateable & WithId & {
  __typename?: 'Attachment';
  canDelete: Scalars['Boolean'];
  canRestore: Scalars['Boolean'];
  createdAt: Scalars['MigrateDateTime'];
  fileMetadata: FileMetadata;
  filename: Scalars['String'];
  id: Scalars['MigrateID'];
  isUploading: Scalars['Boolean'];
  localFile?: Maybe<FileFromFilesystem>;
  message: Message;
  owner: User;
  updatedAt: Scalars['MigrateDateTime'];
  uploadedBy: User;
  url: Scalars['String'];
};

/** The awarding body of a language certificate */
export enum AwardingBody {
  Ielts = 'IELTS',
  Oet = 'OET'
}

export type BooleanFieldAggregate = FieldAggregate & {
  __typename?: 'BooleanFieldAggregate';
  counts: Array<BooleanFieldAggregateItem>;
  /** The total number of items aggregated. These may be different from the set count as undefined items are not included in the count. */
  totalCount: Scalars['Int'];
};

export type BooleanFieldAggregateItem = FieldAggregateItem & {
  __typename?: 'BooleanFieldAggregateItem';
  count: Scalars['Int'];
  value: Scalars['Boolean'];
};

export type BooleanFilterInput = {
  in: Array<Scalars['Boolean']>;
};

export type Candidate = Applicant & Createable & Entity & Updateable & User & WithId & WithOptionalCountry & WithOptionalCountryOfQualification & WithPersonName & {
  __typename?: 'Candidate';
  account?: Maybe<Account>;
  applications: ApplicationPage;
  basicDocumentsVerified: Scalars['Boolean'];
  country?: Maybe<Scalars['String']>;
  countryInfo?: Maybe<CountryInfo>;
  countryOfQualification?: Maybe<Scalars['String']>;
  countryOfQualificationInfo?: Maybe<CountryInfo>;
  createdAt: Scalars['MigrateDateTime'];
  cv?: Maybe<Document>;
  displayName: Scalars['String'];
  documents: DocumentPage;
  email: Scalars['String'];
  forenames: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['MigrateID'];
  isActive: Scalars['Boolean'];
  isEligible: Scalars['Boolean'];
  jobPreferences?: Maybe<JobPreferences>;
  languageStatus?: Maybe<LanguageStatus>;
  lastActiveAt?: Maybe<Scalars['MigrateDateTime']>;
  marketingChannelInfo: MarketingChannelInfo;
  notificationsMutedUntil?: Maybe<Scalars['MigrateDateTime']>;
  phoneNumber?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profession?: Maybe<Profession>;
  pushToken?: Maybe<Scalars['String']>;
  registrationDetails?: Maybe<Array<RegistrationDetail>>;
  relocationTimeframe?: Maybe<RelocationTimeframe>;
  signedUpToMailingList: Scalars['Boolean'];
  source: MigrateCandidateSource;
  surname: Scalars['String'];
  ukRegistrationStatus: UkRegistrationStatus;
  updatedAt: Scalars['MigrateDateTime'];
  workExperiences?: Maybe<Array<Maybe<WorkExperience>>>;
};


export type CandidateApplicationsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ApplicationsOrderBy>;
  where?: InputMaybe<CandidateApplicationsWhereInput>;
};


export type CandidateDocumentsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};

export type CandidateApplicationMatchResponse = {
  applicationQuestionResponse: Scalars['String'];
  candidate: CandidateV2;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  job: Job;
  type: MatchResponseType;
  updatedAt: Scalars['MigrateDateTime'];
};

export type CandidateApplicationMatchResponsePage = Page & {
  __typename?: 'CandidateApplicationMatchResponsePage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<CandidateApplicationMatchResponse>;
  pageCount: Scalars['Int'];
};

export type CandidateApplicationRejectedNotification = Createable & Entity & Notification & Updateable & WithId & WithMatchResponse & {
  __typename?: 'CandidateApplicationRejectedNotification';
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  matchResponse: MatchResponse;
  status: NotificationStatus;
  type: NotificationType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
  user?: Maybe<User>;
};

export type CandidateApplicationsWhereInput = {
  and?: InputMaybe<Array<ApplicationsWhereInput>>;
  hiringStage?: InputMaybe<MigrateIdFilterInput>;
  id?: InputMaybe<MigrateIdFilterInput>;
  job?: InputMaybe<MigrateIdFilterInput>;
  not?: InputMaybe<Array<ApplicationsWhereInput>>;
  or?: InputMaybe<Array<ApplicationsWhereInput>>;
  organisation?: InputMaybe<MigrateIdFilterInput>;
};

export type CandidateCanReapplyNotification = Createable & Entity & Notification & Updateable & WithId & WithJob & {
  __typename?: 'CandidateCanReapplyNotification';
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  job: Job;
  status: NotificationStatus;
  type: NotificationType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
  user?: Maybe<User>;
};

export type CandidateCompleteApplicationReminderNotification = Createable & Entity & Notification & Updateable & WithId & WithMatchResponse & {
  __typename?: 'CandidateCompleteApplicationReminderNotification';
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  matchResponse: MatchResponse;
  status: NotificationStatus;
  type: NotificationType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
  user?: Maybe<User>;
};

export type CandidateCompleteProfileReminderNotification = Createable & Entity & Notification & Updateable & WithId & WithMatchResponse & {
  __typename?: 'CandidateCompleteProfileReminderNotification';
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  matchResponse: MatchResponse;
  status: NotificationStatus;
  type: NotificationType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
  user?: Maybe<User>;
};

export type CandidateInterviewInviteNotification = Createable & Entity & Notification & Updateable & WithId & WithInterview & {
  __typename?: 'CandidateInterviewInviteNotification';
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  interview: Interview;
  status: NotificationStatus;
  type: NotificationType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
  user?: Maybe<User>;
};

export type CandidateInterviewUpdatedNotification = Createable & Entity & Notification & Updateable & WithId & WithInterview & {
  __typename?: 'CandidateInterviewUpdatedNotification';
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  interview: Interview;
  status: NotificationStatus;
  type: NotificationType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
  user?: Maybe<User>;
};

export type CandidatePage = Page & {
  __typename?: 'CandidatePage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<Candidate>;
  pageCount: Scalars['Int'];
};

export type CandidateQuestionAnsweredNotification = Createable & Entity & Notification & Updateable & WithAnswer & WithId & {
  __typename?: 'CandidateQuestionAnsweredNotification';
  answer: Answer;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  status: NotificationStatus;
  type: NotificationType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
  user?: Maybe<User>;
};

export type CandidateSource = {
  type: CandidateSourceType;
};

/** To reflect the type of a candidate */
export enum CandidateSourceType {
  External = 'EXTERNAL',
  Indeed = 'INDEED',
  MigrateUser = 'MIGRATE_USER'
}

export type CandidateSourceTypeInput = {
  in: Array<CandidateSourceType>;
};

export type CandidateV2 = Createable & Entity & Updateable & User & WithId & WithOptionalCountry & WithPersonName & {
  __typename?: 'CandidateV2';
  account?: Maybe<Account>;
  applicationsRemaining: Scalars['Int'];
  basicDocumentsVerified: Scalars['Boolean'];
  /** Caches candidate V1 fields so that they can be used for existing applications */
  cachedV1Fields?: Maybe<Candidate>;
  canApply: Scalars['Boolean'];
  careerExperiences?: Maybe<Array<CareerExperience>>;
  careerQuizResult?: Maybe<CareerQuizResult>;
  coreDocuments?: Maybe<CoreDocuments>;
  country?: Maybe<Scalars['String']>;
  countryInfo?: Maybe<CountryInfo>;
  createdAt: Scalars['MigrateDateTime'];
  cv?: Maybe<Document>;
  displayName: Scalars['String'];
  documents: DocumentPage;
  educationExperiences?: Maybe<Array<EducationExperience>>;
  email: Scalars['String'];
  forenames: Scalars['String'];
  fullName: Scalars['String'];
  hasCompletedProfile: Scalars['Boolean'];
  hasSetPreferences: Scalars['Boolean'];
  id: Scalars['MigrateID'];
  isActive: Scalars['Boolean'];
  isExemptFromLanguageTest: Scalars['Boolean'];
  languageResults?: Maybe<Array<LanguageResult>>;
  lastActiveAt?: Maybe<Scalars['MigrateDateTime']>;
  locationPreferences: Array<Location>;
  meetsLanguageRequirements: Scalars['Boolean'];
  notificationsMutedUntil?: Maybe<Scalars['MigrateDateTime']>;
  numInProgressApplications: Scalars['Int'];
  phoneNumber?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profession?: Maybe<Profession>;
  profileCompletion: Array<ProfileCompletion>;
  pushToken?: Maybe<Scalars['String']>;
  questionResponses?: Maybe<Array<QuestionResponse>>;
  registrationDetails?: Maybe<Array<RegistrationDetailV2>>;
  searchStage?: Maybe<SearchStage>;
  surname: Scalars['String'];
  tagPreferences: Array<Tag>;
  ukRegistrationStatus: UkRegistrationStatus;
  updatedAt: Scalars['MigrateDateTime'];
};


export type CandidateV2DocumentsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};

/** Used to sort candidates */
export enum CandidatesOrderBy {
  CountryAsc = 'country_ASC',
  CountryDesc = 'country_DESC',
  CountryOfQualificationAsc = 'country_of_qualification_ASC',
  CountryOfQualificationDesc = 'country_of_qualification_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  SurnameAsc = 'surname_ASC',
  SurnameDesc = 'surname_DESC'
}

export type CandidatesWhereInput = {
  and?: InputMaybe<Array<CandidatesWhereInput>>;
  country?: InputMaybe<StringFilterInput>;
  countryOfQualification?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<TermFilterInput>;
  not?: InputMaybe<Array<CandidatesWhereInput>>;
  or?: InputMaybe<Array<CandidatesWhereInput>>;
  profession?: InputMaybe<MigrateIdFilterInput>;
  searchTerm?: InputMaybe<StringFilterInput>;
  sourceType?: InputMaybe<CandidateSourceTypeInput>;
};

export type CareerBreak = {
  __typename?: 'CareerBreak';
  description: Array<TextBlock>;
  endDate?: Maybe<Scalars['MigrateDateTime']>;
  id: Scalars['String'];
  reason: Scalars['String'];
  startDate: Scalars['MigrateDateTime'];
  type: CareerExperienceType;
  updatedAt: Scalars['MigrateDateTime'];
};

export type CareerExperience = CareerBreak | WorkExperience;

export enum CareerExperienceType {
  CareerBreak = 'CAREER_BREAK',
  WorkExperience = 'WORK_EXPERIENCE'
}

/** Reflects the stage of the candidate's career */
export enum CareerQuizResult {
  PassedLanguage = 'PASSED_LANGUAGE',
  Qualified = 'QUALIFIED',
  Registered = 'REGISTERED',
  Unqualified = 'UNQUALIFIED'
}

export type ChangeApplicationHiringStageInput = {
  applicationId: Scalars['MigrateID'];
  candidateFeedbackMessage?: InputMaybe<Scalars['String']>;
  hiringStageId: Scalars['MigrateID'];
};

export type ChangeApplicationHiringStagePayload = {
  __typename?: 'ChangeApplicationHiringStagePayload';
  application: Application;
  candidateFeedbackMessage?: Maybe<Message>;
  newHiringStage: HiringStage;
  previousHiringStage: HiringStage;
};

export type ChangeApplicationHiringStageToSuccessfulInput = {
  applicationId: Scalars['MigrateID'];
  /** The proposed arrival date of the applicant. It must be in the future. */
  arrivalDate: Scalars['MigrateDateTime'];
  candidateFeedbackMessage?: InputMaybe<Scalars['String']>;
  hiringStageId: Scalars['MigrateID'];
};

export type ChangeApplicationHiringStageToUnsuccessfulInput = {
  applicationId: Scalars['MigrateID'];
  candidateFeedbackMessage: Scalars['String'];
  hiringStageId: Scalars['MigrateID'];
};

export type Channel = {
  archivedAt?: Maybe<Scalars['MigrateDateTime']>;
  canReact: Scalars['Boolean'];
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  isMember: Scalars['Boolean'];
  lastMessage?: Maybe<Message>;
  members: UserPage;
  messages: MessagePage;
  mutedUntil?: Maybe<Scalars['MigrateDateTime']>;
  myChannelMember?: Maybe<ChannelMember>;
  type: ChannelType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
};


export type ChannelMembersArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UsersOrderBy>;
};


export type ChannelMessagesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MessagesOrderBy>;
  where?: InputMaybe<ResolvedMessagesWhereInput>;
};

/** Used to sort channel categories */
export enum ChannelCategoriesOrderBy {
  NameAsc = 'NAME_ASC'
}

export type ChannelCategory = Createable & Entity & Updateable & WithId & WithName & {
  __typename?: 'ChannelCategory';
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  name: Scalars['String'];
  updatedAt: Scalars['MigrateDateTime'];
};

export type ChannelCategoryPage = {
  __typename?: 'ChannelCategoryPage';
  data: Array<ChannelCategory>;
};

export type ChannelInvite = Createable & Entity & Invite & Updateable & WithId & {
  __typename?: 'ChannelInvite';
  createdAt: Scalars['MigrateDateTime'];
  email: Scalars['String'];
  id: Scalars['MigrateID'];
  status: InviteStatus;
  updatedAt: Scalars['MigrateDateTime'];
};

export type ChannelMember = Createable & Entity & Updateable & WithId & {
  __typename?: 'ChannelMember';
  channel: Channel;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  lastRead?: Maybe<Scalars['MigrateDateTime']>;
  updatedAt: Scalars['MigrateDateTime'];
  user: User;
};

export type ChannelPage = Page & {
  __typename?: 'ChannelPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<Channel>;
  pageCount: Scalars['Int'];
};

/** The channel type */
export enum ChannelType {
  ApplicationDm = 'APPLICATION_DM',
  Community = 'COMMUNITY',
  Dm = 'DM',
  OrganisationPrivate = 'ORGANISATION_PRIVATE'
}

export type ChannelTypeFilterInput = {
  in: Array<ChannelType>;
};

/** Used to sort channels */
export enum ChannelsOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type ChannelsWhereInput = {
  deleted?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<ChannelsWhereInput>;
  organisation?: InputMaybe<Scalars['MigrateID']>;
  type?: InputMaybe<ChannelType>;
  user?: InputMaybe<Scalars['MigrateID']>;
};

export type ChannelsWhereInputV2 = {
  and?: InputMaybe<Array<ChannelsWhereInputV2>>;
  category?: InputMaybe<MigrateIdFilterInput>;
  deleted?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<Array<ChannelsWhereInputV2>>;
  or?: InputMaybe<Array<ChannelsWhereInputV2>>;
  organisation?: InputMaybe<MigrateIdFilterInput>;
  type?: InputMaybe<ChannelTypeFilterInput>;
  user?: InputMaybe<MigrateIdFilterInput>;
};

export type ChecksTemplate = Createable & Entity & Updateable & WithId & WithName & {
  __typename?: 'ChecksTemplate';
  /** Returns null if added by Migrate */
  addedBy?: Maybe<User>;
  canDelete: Scalars['Boolean'];
  checks: Array<Scalars['String']>;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  name: Scalars['String'];
  organisation: Organisation;
  updatedAt: Scalars['MigrateDateTime'];
};

export type ChecksTemplatePage = Page & {
  __typename?: 'ChecksTemplatePage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<ChecksTemplate>;
  pageCount: Scalars['Int'];
};

export type CommentApplicationEvent = ApplicationEvent & Createable & Entity & Updateable & WithId & {
  __typename?: 'CommentApplicationEvent';
  actionedBy: User;
  application: Application;
  comment: Scalars['String'];
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  mentions: Array<TeamMember>;
  type: ApplicationEventType;
  updatedAt: Scalars['MigrateDateTime'];
};

export type CommunityActivity = {
  __typename?: 'CommunityActivity';
  answerCount: Scalars['Int'];
  questionCount: Scalars['Int'];
  upvoteCount: Scalars['Int'];
};

export type CommunityPublicChannel = Channel & Createable & Entity & PublicChannel & Updateable & WithId & WithName & {
  __typename?: 'CommunityPublicChannel';
  archivedAt?: Maybe<Scalars['MigrateDateTime']>;
  canReact: Scalars['Boolean'];
  categories: Array<ChannelCategory>;
  createdAt: Scalars['MigrateDateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['MigrateID'];
  isMember: Scalars['Boolean'];
  lastMessage?: Maybe<Message>;
  members: UserPage;
  messages: MessagePage;
  mutedUntil?: Maybe<Scalars['MigrateDateTime']>;
  myChannelMember?: Maybe<ChannelMember>;
  name: Scalars['String'];
  type: ChannelType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
};


export type CommunityPublicChannelMembersArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UsersOrderBy>;
};


export type CommunityPublicChannelMessagesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MessagesOrderBy>;
  where?: InputMaybe<ResolvedMessagesWhereInput>;
};

export type CommunityPublicChannelPage = Page & {
  __typename?: 'CommunityPublicChannelPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<CommunityPublicChannel>;
  pageCount: Scalars['Int'];
};

export type CommunityPublicChannelsWhereInput = {
  and?: InputMaybe<Array<CommunityPublicChannelsWhereInput>>;
  category?: InputMaybe<MigrateIdFilterInput>;
  not?: InputMaybe<Array<CommunityPublicChannelsWhereInput>>;
  or?: InputMaybe<Array<CommunityPublicChannelsWhereInput>>;
  user?: InputMaybe<MigrateIdFilterInput>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export type CoordinatesInput = {
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export type CoreDocuments = {
  __typename?: 'CoreDocuments';
  languageCertificate: Array<Document>;
  passport: Array<Document>;
  qualification: Array<Document>;
};

/** Reflects the country a job is in */
export enum Country {
  Australia = 'AUSTRALIA',
  Uk = 'UK'
}

export type CountryFieldAggregate = FieldAggregate & {
  __typename?: 'CountryFieldAggregate';
  counts: Array<CountryFieldAggregateItem>;
  /** The total number of items aggregated. These may be different from the set count as undefined items are not included in the count. */
  totalCount: Scalars['Int'];
};

export type CountryFieldAggregateItem = FieldAggregateItem & {
  __typename?: 'CountryFieldAggregateItem';
  count: Scalars['Int'];
  /** Null indicates an aggregate of items with an undefined field */
  value?: Maybe<CountryInfo>;
};

export type CountryInfo = {
  __typename?: 'CountryInfo';
  /** The country's alias name */
  alias?: Maybe<Scalars['String']>;
  /** All names that a country goes by */
  allNames: Array<Scalars['String']>;
  /** The ISO 3166-1 alpha-2 country code */
  alpha2Code: Scalars['String'];
  /** The ISO 3166-1 alpha-3 country code */
  alpha3Code: Scalars['String'];
  emoji: Scalars['String'];
  /** The official name of the country */
  name: Scalars['String'];
  /** The ISO 3166-1 numeric country code */
  numericCode: Scalars['String'];
};

export type CreateCareerBreakInput = {
  description: Array<TextBlockInput>;
  endDate?: InputMaybe<Scalars['MigrateDateTime']>;
  reason: Scalars['String'];
  startDate: Scalars['MigrateDateTime'];
};

export type CreateChannelCategoryInput = {
  name: Scalars['String'];
};

export type CreateChannelInviteInput = {
  channelId: Scalars['MigrateID'];
  email: Scalars['String'];
};

export type CreateChecksTemplateInput = {
  checks: Array<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateEducationExperienceInput = {
  description: Array<TextBlockInput>;
  endDate?: InputMaybe<Scalars['MigrateDateTime']>;
  grade?: InputMaybe<Scalars['String']>;
  institutionName: Scalars['String'];
  qualification: Scalars['String'];
  startDate: Scalars['MigrateDateTime'];
};

export type CreateJobCategoryInput = {
  name: Scalars['String'];
};

export type CreateJobInput = {
  candidatesRequired: Scalars['Int'];
  title: Scalars['String'];
};

export type CreateLanguageResultInput = {
  awardingBody: LanguageResultAwardingBody;
  date: Scalars['MigrateDateTime'];
  listening: Scalars['String'];
  reading: Scalars['String'];
  speaking: Scalars['String'];
  writing: Scalars['String'];
};

export type CreateLocationInput = {
  description: Scalars['String'];
  name: Scalars['String'];
};

export type CreateMessageInput = {
  attachmentToken?: InputMaybe<Scalars['UploadToken']>;
  channelId: Scalars['MigrateID'];
  content?: InputMaybe<Scalars['String']>;
  referencedMessageId?: InputMaybe<Scalars['MigrateID']>;
};

export type CreateMessageReactionInput = {
  emoji: Scalars['String'];
  messageId: Scalars['MigrateID'];
};

export type CreateMessageTemplateInput = {
  name: Scalars['String'];
  template: Scalars['String'];
  type: MessageTemplateType;
};

export type CreateOrganisationInput = {
  accountManagerIds: Array<Scalars['MigrateID']>;
  organisation: CreateOrganisationOrganisationInput;
  owner: CreateOrganisationOwnerInput;
};

export type CreateOrganisationOrganisationInput = {
  isTrial: Scalars['Boolean'];
  name: Scalars['String'];
  type: OrganisationType;
  url: Scalars['String'];
};

export type CreateOrganisationOwnerInput = {
  email: Scalars['String'];
  forenames: Scalars['String'];
  password: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  pushToken?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
};

export type CreateOrganisationPayload = {
  __typename?: 'CreateOrganisationPayload';
  defaultChecksTemplates: Array<ChecksTemplate>;
  defaultMessageTemplates: Array<MessageTemplate>;
  organisation: Organisation;
  owner: TeamMember;
};

export type CreateOrganisationPrivateChannelInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateProfessionInput = {
  name: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateProfessionPayload = {
  __typename?: 'CreateProfessionPayload';
  profession: Profession;
  tags: Array<Tag>;
};

export type CreateQuestionResponseInput = {
  question: Scalars['String'];
  response: Scalars['String'];
};

export type CreateQuestionTopicInput = {
  name: Scalars['String'];
};

export type CreateRegistrationDetailInput = {
  country: Scalars['String'];
  referenceNumber?: InputMaybe<Scalars['String']>;
};

export type CreateWorkExperienceInput = {
  country?: InputMaybe<Scalars['String']>;
  description: Array<TextBlockInput>;
  endDate?: InputMaybe<Scalars['MigrateDateTime']>;
  organisationName: Scalars['String'];
  startDate: Scalars['MigrateDateTime'];
  title: Scalars['String'];
};

export type Createable = {
  createdAt: Scalars['MigrateDateTime'];
};

export type DmChannel = {
  archivedAt?: Maybe<Scalars['MigrateDateTime']>;
  canReact: Scalars['Boolean'];
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  isMember: Scalars['Boolean'];
  lastMessage?: Maybe<Message>;
  members: UserPage;
  messages: MessagePage;
  mutedUntil?: Maybe<Scalars['MigrateDateTime']>;
  myChannelMember?: Maybe<ChannelMember>;
  type: ChannelType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
};


export type DmChannelMembersArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UsersOrderBy>;
};


export type DmChannelMessagesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MessagesOrderBy>;
  where?: InputMaybe<ResolvedMessagesWhereInput>;
};

export type DailyIntervalInput = {
  between: IntervalInput;
  step?: InputMaybe<Scalars['Int']>;
};

export type DateFilterInput = {
  between?: InputMaybe<DateRangeFilterInput>;
};

export type DateRangeFilterInput = {
  max?: InputMaybe<Scalars['MigrateDateTime']>;
  min?: InputMaybe<Scalars['MigrateDateTime']>;
};

export type DeclineJobInviteInput = {
  jobInviteId: Scalars['MigrateID'];
};

export type DeclineJobInvitePayload = {
  __typename?: 'DeclineJobInvitePayload';
  jobInvite: JobInvite;
};

export type DeleteAnswerInput = {
  id: Scalars['MigrateID'];
};

export type DeleteCareerExperienceInput = {
  /** The ID of the career experience to be deleted */
  id: Scalars['String'];
};

export type DeleteEducationExperienceInput = {
  /** The ID of the education experience to be deleted */
  id: Scalars['String'];
};

export type DeleteLanguageResultInput = {
  /** The ID of the language result to be deleted */
  id: Scalars['String'];
};

export type DeleteMessageInput = {
  id: Scalars['MigrateID'];
};

export type DeleteMessagePayload = {
  __typename?: 'DeleteMessagePayload';
  message: Message;
};

export type DeleteMessageReactionInput = {
  id: Scalars['MigrateID'];
};

export type DeleteQuestionInput = {
  id: Scalars['MigrateID'];
};

export type DeleteQuestionResponseInput = {
  /** The ID of the question response to be deleted */
  id: Scalars['String'];
};

export type DeleteRegistrationDetailInput = {
  /** The ID of the registration detail to be deleted */
  id: Scalars['String'];
};

export type DescriptionBlock = TextBlock;

export type DescriptionBlockInput = {
  content?: InputMaybe<Scalars['String']>;
  type: DescriptionBlockType;
};

export enum DescriptionBlockType {
  Text = 'TEXT'
}

export type Document = Createable & Entity & File & Updateable & WithId & WithVerified & {
  __typename?: 'Document';
  canDelete: Scalars['Boolean'];
  canRestore: Scalars['Boolean'];
  canUpdate: Scalars['Boolean'];
  createdAt: Scalars['MigrateDateTime'];
  fileMetadata: FileMetadata;
  filename: Scalars['String'];
  id: Scalars['MigrateID'];
  owner: User;
  type: DocumentType;
  typeProps: DocumentTypeProps;
  updatedAt: Scalars['MigrateDateTime'];
  uploadedBy: User;
  url: Scalars['String'];
  /** @deprecated owner resolved field should now be used */
  userId: Scalars['MigrateID'];
  verified?: Maybe<Scalars['Boolean']>;
};

export type DocumentPage = Page & {
  __typename?: 'DocumentPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<Document>;
  pageCount: Scalars['Int'];
};

/** A document type */
export enum DocumentType {
  Cbt = 'CBT',
  Cos = 'COS',
  Cv = 'CV',
  DriversLicense = 'DRIVERS_LICENSE',
  LanguageCertificate = 'LANGUAGE_CERTIFICATE',
  Misc = 'MISC',
  NaricCertificate = 'NARIC_CERTIFICATE',
  NmcScreenshot = 'NMC_SCREENSHOT',
  NmcTestOfCompetence = 'NMC_TEST_OF_COMPETENCE',
  Passport = 'PASSPORT',
  PhotographicId = 'PHOTOGRAPHIC_ID',
  Plab = 'PLAB',
  PoliceClearanceCertificate = 'POLICE_CLEARANCE_CERTIFICATE',
  ProfessionalRegistration = 'PROFESSIONAL_REGISTRATION',
  ProofOfAddress = 'PROOF_OF_ADDRESS',
  Qualification = 'QUALIFICATION',
  VaccinationCertificateCovid = 'VACCINATION_CERTIFICATE_COVID'
}

export type DocumentTypeProps = WithName & {
  __typename?: 'DocumentTypeProps';
  name: Scalars['String'];
  type: DocumentType;
};

export type DuplicateChecksTemplateInput = {
  id: Scalars['MigrateID'];
};

export type DuplicateChecksTemplatePayload = {
  __typename?: 'DuplicateChecksTemplatePayload';
  checksTemplate: ChecksTemplate;
};

export type DuplicateJobInput = {
  id: Scalars['MigrateID'];
};

export type DuplicateJobPayload = {
  __typename?: 'DuplicateJobPayload';
  job: Job;
};

export type EducationExperience = {
  __typename?: 'EducationExperience';
  description: Array<TextBlock>;
  endDate?: Maybe<Scalars['MigrateDateTime']>;
  grade?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  institutionName: Scalars['String'];
  qualification: Scalars['String'];
  startDate: Scalars['MigrateDateTime'];
  updatedAt: Scalars['MigrateDateTime'];
};

export type Entity = {
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  updatedAt: Scalars['MigrateDateTime'];
};

export type ExternalCandidate = Applicant & Createable & Entity & Updateable & WithId & WithOptionalCountry & WithOptionalCountryOfQualification & WithPersonName & {
  __typename?: 'ExternalCandidate';
  applications: ApplicationPage;
  country?: Maybe<Scalars['String']>;
  countryInfo?: Maybe<CountryInfo>;
  countryOfQualification?: Maybe<Scalars['String']>;
  countryOfQualificationInfo?: Maybe<CountryInfo>;
  createdAt: Scalars['MigrateDateTime'];
  cv?: Maybe<Document>;
  documents: DocumentPage;
  email: Scalars['String'];
  forenames: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['MigrateID'];
  languageStatus?: Maybe<LanguageStatus>;
  profession?: Maybe<Profession>;
  registrationDetails?: Maybe<Array<RegistrationDetail>>;
  relocationTimeframe?: Maybe<RelocationTimeframe>;
  source: HirerCandidateSource;
  surname: Scalars['String'];
  ukRegistrationStatus: UkRegistrationStatus;
  updatedAt: Scalars['MigrateDateTime'];
};


export type ExternalCandidateApplicationsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ApplicationsOrderBy>;
  where?: InputMaybe<CandidateApplicationsWhereInput>;
};


export type ExternalCandidateDocumentsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};

export type ExternalJobInvite = Createable & Entity & Invite & JobInvite & Updateable & WithId & {
  __typename?: 'ExternalJobInvite';
  createdAt: Scalars['MigrateDateTime'];
  email: Scalars['String'];
  id: Scalars['MigrateID'];
  job: Job;
  status: InviteStatus;
  updatedAt: Scalars['MigrateDateTime'];
};

export type FaunaStreamConfig = {
  __typename?: 'FaunaStreamConfig';
  setRef: Scalars['SetRef'];
  type: StreamConfigType;
};

export type FieldAggregate = {
  /** The total number of items aggregated. These may be different from the set count as undefined items are not included in the count. */
  totalCount: Scalars['Int'];
};

export type FieldAggregateItem = {
  count: Scalars['Int'];
};

export type File = {
  canDelete: Scalars['Boolean'];
  canRestore: Scalars['Boolean'];
  createdAt: Scalars['MigrateDateTime'];
  fileMetadata: FileMetadata;
  filename: Scalars['String'];
  id: Scalars['MigrateID'];
  owner: User;
  updatedAt: Scalars['MigrateDateTime'];
  uploadedBy: User;
  url: Scalars['String'];
};

export type FileFromFilesystem = {
  __typename?: 'FileFromFilesystem';
  name?: Maybe<Scalars['String']>;
  uri: Scalars['String'];
};

export type FileInput = {
  token: Scalars['UploadToken'];
};

export type FileMetadata = Createable & Updateable & {
  __typename?: 'FileMetadata';
  createdAt: Scalars['MigrateDateTime'];
  filename: Scalars['String'];
  id: Scalars['UploadToken'];
  owner: User;
  size?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['MigrateDateTime'];
  uploadConfirmedAt: Scalars['MigrateDateTime'];
  uploadedBy: User;
  url: Scalars['String'];
};

export type FileMetadataInput = {
  /** Used to display a pretty name in UI, though the actual filename will be the date it was stored. */
  filename?: InputMaybe<Scalars['String']>;
  /** Used when a document is uploaded on behalf of another user */
  ownerId?: InputMaybe<Scalars['MigrateID']>;
};

export type FileUploadPayload = {
  __typename?: 'FileUploadPayload';
  token: Scalars['UploadToken'];
  url: Scalars['String'];
};

export type GenerateApplicationDmChannelTemplateMessageInput = {
  applicationId: Scalars['MigrateID'];
  messageTemplateId: Scalars['MigrateID'];
};

export type GenerateTemplateMessagePayload = {
  __typename?: 'GenerateTemplateMessagePayload';
  text: Scalars['String'];
};

export type GenericMatchResponse = Createable & Entity & MatchResponse & Updateable & WithId & {
  __typename?: 'GenericMatchResponse';
  candidate: CandidateV2;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  job: Job;
  type: MatchResponseType;
  updatedAt: Scalars['MigrateDateTime'];
};

export type GenericMatchResponseInput = {
  jobId: Scalars['MigrateID'];
};

export type GetApplicationFileUploadTokenInput = {
  applicationId: Scalars['MigrateID'];
  filename?: InputMaybe<Scalars['String']>;
};

export type GetAttachmentUploadTokenInput = {
  channelId: Scalars['MigrateID'];
  /** Used to display a pretty name in UI, though the actual filename will be the date it was stored. */
  filename?: InputMaybe<Scalars['String']>;
};

export type GetBulkAttachmentUploadTokenInput = {
  /** Used to display a pretty name in UI, though the actual filename will be the date it was stored. */
  filename?: InputMaybe<Scalars['String']>;
  hiringStageId: Scalars['MigrateID'];
};

export type GetJobFileUploadTokenInput = {
  filename?: InputMaybe<Scalars['String']>;
  jobId: Scalars['MigrateID'];
};

export type HirerCandidateSource = CandidateSource & {
  __typename?: 'HirerCandidateSource';
  addedBy: Scalars['MigrateID'];
  organisationId: Scalars['MigrateID'];
  type: CandidateSourceType;
};

export type HirerCandidateSourceInput = {
  type: CandidateSourceType;
};

export type HiringStage = Createable & Entity & Updateable & WithId & WithName & {
  __typename?: 'HiringStage';
  applications: ApplicationPage;
  checksTemplate?: Maybe<ChecksTemplate>;
  checksTemplateId?: Maybe<Scalars['MigrateID']>;
  count: Scalars['Int'];
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  name: Scalars['String'];
  position: Scalars['Int'];
  requiresCandidateFeedbackFrom: Scalars['Boolean'];
  requiresCandidateFeedbackTo: Scalars['Boolean'];
  type: HiringStageType;
  updatedAt: Scalars['MigrateDateTime'];
};


export type HiringStageApplicationsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ApplicationsOrderBy>;
};

export type HiringStageFieldAggregate = FieldAggregate & {
  __typename?: 'HiringStageFieldAggregate';
  counts: Array<HiringStageFieldAggregateItem>;
  /** The total number of items aggregated. These may be different from the set count as undefined items are not included in the count. */
  totalCount: Scalars['Int'];
};

export type HiringStageFieldAggregateItem = FieldAggregateItem & {
  __typename?: 'HiringStageFieldAggregateItem';
  count: Scalars['Int'];
  value: HiringStage;
};

/** To reflect the type of a hiring stage */
export enum HiringStageType {
  Applied = 'APPLIED',
  /** @deprecated Legacy, but required for parsing report history data */
  Archived = 'ARCHIVED',
  Compliance = 'COMPLIANCE',
  /** @deprecated Legacy, but required for parsing report history data */
  Generic = 'GENERIC',
  Interview = 'INTERVIEW',
  Offer = 'OFFER',
  Shortlist = 'SHORTLIST',
  Successful = 'SUCCESSFUL',
  Unsuccessful = 'UNSUCCESSFUL',
  Withdrawn = 'WITHDRAWN'
}

export type HiringStageTypeFieldAggregate = FieldAggregate & {
  __typename?: 'HiringStageTypeFieldAggregate';
  counts: Array<HiringStageTypeFieldAggregateItem>;
  /** The total number of items aggregated. These may be different from the set count as undefined items are not included in the count. */
  totalCount: Scalars['Int'];
};

export type HiringStageTypeFieldAggregateItem = FieldAggregateItem & {
  __typename?: 'HiringStageTypeFieldAggregateItem';
  count: Scalars['Int'];
  value: HiringStageType;
};

export type HiringStageTypeFilterInput = {
  in: Array<HiringStageType>;
};

export type HistoryReport = {
  __typename?: 'HistoryReport';
  data: Array<HistoryReportAt>;
  period: ReportPeriodInterval;
};

export type HistoryReportAt = {
  __typename?: 'HistoryReportAt';
  data: HistoryReportData;
  period: ReportPeriodAt;
};

export type HistoryReportData = {
  __typename?: 'HistoryReportData';
  applicantsReport: ApplicantsReportData;
  applicationsReport: ApplicationsReportData;
  jobsReport: JobsReportData;
};


export type HistoryReportDataApplicantsReportArgs = {
  where?: InputMaybe<CandidatesWhereInput>;
};


export type HistoryReportDataApplicationsReportArgs = {
  where?: InputMaybe<ApplicationsReportWhereInput>;
};


export type HistoryReportDataJobsReportArgs = {
  where?: InputMaybe<JobsReportWhereInput>;
};

export type HourlyIntervalInput = {
  between: IntervalInput;
  step?: InputMaybe<Scalars['Int']>;
};

export type IntFieldAggregate = FieldAggregate & {
  __typename?: 'IntFieldAggregate';
  counts: Array<IntFieldAggregateItem>;
  /** The total number of items aggregated. These may be different from the set count as undefined items are not included in the count. */
  totalCount: Scalars['Int'];
};

export type IntFieldAggregateItem = FieldAggregateItem & {
  __typename?: 'IntFieldAggregateItem';
  count: Scalars['Int'];
  value: Scalars['Int'];
};

export type InternalJobInvite = Createable & Entity & Invite & JobInvite & Updateable & WithId & {
  __typename?: 'InternalJobInvite';
  createdAt: Scalars['MigrateDateTime'];
  email: Scalars['String'];
  id: Scalars['MigrateID'];
  job: Job;
  status: InviteStatus;
  updatedAt: Scalars['MigrateDateTime'];
};

export type IntervalInput = {
  end: Scalars['MigrateDateTime'];
  start: Scalars['MigrateDateTime'];
};

export type Interview = Createable & Entity & Updateable & WithId & {
  __typename?: 'Interview';
  application: Application;
  candidate: Candidate;
  createdAt: Scalars['MigrateDateTime'];
  endDatetime: Scalars['MigrateDateTime'];
  hiringStage: HiringStage;
  id: Scalars['MigrateID'];
  meetingLink?: Maybe<Scalars['String']>;
  organisation: Organisation;
  startDatetime: Scalars['MigrateDateTime'];
  status: InterviewStatus;
  updatedAt: Scalars['MigrateDateTime'];
  zoomMeetingId?: Maybe<Scalars['String']>;
  zoomPasscode?: Maybe<Scalars['String']>;
};

export type InterviewPage = Page & {
  __typename?: 'InterviewPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<Interview>;
  pageCount: Scalars['Int'];
};

/** Shows the state of an interview. If an interview   is pending an action, it means the interview has yet to take place.   If an interview is actioned, it means a stage change has occurred   following the interview. If it is cancelled, it means a stage change   occurred before the interview (implying the candidate must be informed) */
export enum InterviewStatus {
  Actioned = 'ACTIONED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING'
}

/** Used to sort interviews */
export enum InterviewsOrderBy {
  StartDatetimeDesc = 'START_DATETIME_DESC'
}

export type InterviewsWhereInput = {
  and?: InputMaybe<Array<InterviewsWhereInput>>;
  application?: InputMaybe<MigrateIdFilterInput>;
  candidate?: InputMaybe<MigrateIdFilterInput>;
  not?: InputMaybe<Array<InterviewsWhereInput>>;
  or?: InputMaybe<Array<InterviewsWhereInput>>;
};

export type Invite = {
  createdAt: Scalars['MigrateDateTime'];
  email: Scalars['String'];
  id: Scalars['MigrateID'];
  status: InviteStatus;
  updatedAt: Scalars['MigrateDateTime'];
};

export type InviteCandidateToJobInput = {
  email: Scalars['String'];
  hiringStageId: Scalars['MigrateID'];
};

export type InviteCandidateToJobPayload = {
  __typename?: 'InviteCandidateToJobPayload';
  application: Application;
  jobInvite: JobInvite;
};

/** Shows the state of an invite */
export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type InviteTeamMemberInput = {
  email: Scalars['String'];
  role: TeamMemberInviteRole;
};

export type Job = Createable & Entity & Updateable & WithId & {
  __typename?: 'Job';
  /** If accessed as a candidate, will return their corresponding application       for a job if it exists, otherwise null. Will fail for non-candidate users. */
  application?: Maybe<Application>;
  candidatesRequired: Scalars['Int'];
  category?: Maybe<JobCategory>;
  city?: Maybe<Scalars['String']>;
  country: Country;
  createdAt: Scalars['MigrateDateTime'];
  /** @deprecated Use detailed description instead */
  description?: Maybe<Scalars['String']>;
  descriptionAttachment?: Maybe<JobFile>;
  detailedDescription?: Maybe<Array<DescriptionBlock>>;
  excludeCountries?: Maybe<Array<Scalars['String']>>;
  files?: Maybe<Array<JobFile>>;
  highlights?: Maybe<Array<Scalars['String']>>;
  hiringStages: Array<HiringStage>;
  hiringTeam: Array<TeamMember>;
  id: Scalars['MigrateID'];
  location?: Maybe<Location>;
  mapLocation?: Maybe<MapLocation>;
  myMatchResponse?: Maybe<MatchResponse>;
  organisation: Organisation;
  organisationAlias?: Maybe<Scalars['String']>;
  organisationName: Scalars['String'];
  pipeline: Pipeline;
  profession?: Maybe<Profession>;
  requiresLanguagePass: Scalars['Boolean'];
  salary?: Maybe<Array<Scalars['Int']>>;
  status: PublicationStatus;
  tags: Array<Tag>;
  targetCountries?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt: Scalars['MigrateDateTime'];
  userHasSaved: Scalars['Boolean'];
};

export type JobCategory = Createable & Entity & Updateable & WithId & WithName & {
  __typename?: 'JobCategory';
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  name: Scalars['String'];
  updatedAt: Scalars['MigrateDateTime'];
};

export type JobFile = Createable & Updateable & {
  __typename?: 'JobFile';
  createdAt: Scalars['MigrateDateTime'];
  filename: Scalars['String'];
  id: Scalars['UploadToken'];
  owner: User;
  size?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['MigrateDateTime'];
  uploadConfirmedAt: Scalars['MigrateDateTime'];
  uploadedBy: User;
  url: Scalars['String'];
};

export type JobInvite = {
  createdAt: Scalars['MigrateDateTime'];
  email: Scalars['String'];
  id: Scalars['MigrateID'];
  job: Job;
  status: InviteStatus;
  updatedAt: Scalars['MigrateDateTime'];
};

export type JobInvitePage = Page & {
  __typename?: 'JobInvitePage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<JobInvite>;
  pageCount: Scalars['Int'];
};

export type JobPage = Page & {
  __typename?: 'JobPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<Job>;
  pageCount: Scalars['Int'];
};

export type JobPreferences = {
  __typename?: 'JobPreferences';
  country?: Maybe<Country>;
  mapLocation?: Maybe<MapLocation>;
  tags: Array<Tag>;
};

export type JobPreferencesInput = {
  country?: InputMaybe<Country>;
  mapLocation?: InputMaybe<MapLocationInput>;
  tagIds: Array<Scalars['MigrateID']>;
};

export type JobsByOrganisationWhereInput = {
  and?: InputMaybe<Array<JobsByOrganisationWhereInput>>;
  not?: InputMaybe<Array<JobsByOrganisationWhereInput>>;
  or?: InputMaybe<Array<JobsByOrganisationWhereInput>>;
  profession?: InputMaybe<MigrateIdFilterInput>;
  status?: InputMaybe<PublicationStatusFilterInput>;
};

/** Used to sort jobs */
export enum JobsOrderBy {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  StatusWeightedAsc = 'STATUS_WEIGHTED_ASC',
  StatusWeightedDesc = 'STATUS_WEIGHTED_DESC'
}

export type JobsReportData = {
  __typename?: 'JobsReportData';
  applicantsReport: ApplicantsReportData;
  applicationsReport: ApplicationsReportData;
  candidatesRequiredAvg?: Maybe<Scalars['Float']>;
  candidatesRequiredCounts: IntFieldAggregate;
  candidatesRequiredMax?: Maybe<Scalars['Int']>;
  candidatesRequiredMin?: Maybe<Scalars['Int']>;
  candidatesRequiredSum?: Maybe<Scalars['Int']>;
  count: Scalars['Int'];
  organisationCounts: OrganisationFieldAggregate;
  professionCounts: ProfessionFieldAggregate;
  statusCounts: StringFieldAggregate;
};


export type JobsReportDataApplicantsReportArgs = {
  where?: InputMaybe<CandidatesWhereInput>;
};


export type JobsReportDataApplicationsReportArgs = {
  where?: InputMaybe<ApplicationsReportWhereInput>;
};

export type JobsReportWhereInput = {
  and?: InputMaybe<Array<JobsReportWhereInput>>;
  hiringTeamMember?: InputMaybe<MigrateIdFilterInput>;
  id?: InputMaybe<MigrateIdFilterInput>;
  not?: InputMaybe<Array<JobsReportWhereInput>>;
  or?: InputMaybe<Array<JobsReportWhereInput>>;
  organisation?: InputMaybe<MigrateIdFilterInput>;
  profession?: InputMaybe<MigrateIdFilterInput>;
  status?: InputMaybe<PublicationStatusFilterInput>;
  tag?: InputMaybe<MigrateIdFilterInput>;
};

export type JoinChannelInput = {
  channelId: Scalars['MigrateID'];
};

export type JoinedChannelsWhereInput = {
  deleted?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<ChannelsWhereInput>;
  organisation?: InputMaybe<Scalars['MigrateID']>;
  type?: InputMaybe<ChannelType>;
};

export type LanguageResult = {
  __typename?: 'LanguageResult';
  awardingBody: LanguageResultAwardingBody;
  date: Scalars['MigrateDateTime'];
  id: Scalars['String'];
  listening: Scalars['String'];
  reading: Scalars['String'];
  speaking: Scalars['String'];
  updatedAt: Scalars['MigrateDateTime'];
  writing: Scalars['String'];
};

/** The awarding body of a language result */
export enum LanguageResultAwardingBody {
  Ielts = 'IELTS',
  Oet = 'OET'
}

export type LanguageResultSchema = {
  __typename?: 'LanguageResultSchema';
  IELTS: Array<Scalars['String']>;
  OET: Array<Scalars['String']>;
};

export type LanguageResults = {
  __typename?: 'LanguageResults';
  listening: Scalars['String'];
  reading: Scalars['String'];
  speaking: Scalars['String'];
  writing: Scalars['String'];
};

export type LanguageResultsInput = {
  listening: Scalars['String'];
  reading: Scalars['String'];
  speaking: Scalars['String'];
  writing: Scalars['String'];
};

export type LanguageStatus = {
  __typename?: 'LanguageStatus';
  awardingBody?: Maybe<AwardingBody>;
  certificate?: Maybe<Document>;
  meetsRegistrationRequirements: Scalars['Boolean'];
  results?: Maybe<LanguageResults>;
  testExemptionCountry?: Maybe<Scalars['String']>;
  testExemptionCountryInfo?: Maybe<CountryInfo>;
};

export type LeaveChannelInput = {
  channelId: Scalars['MigrateID'];
};

export type Location = Createable & Entity & Updateable & WithId & WithName & {
  __typename?: 'Location';
  createdAt: Scalars['MigrateDateTime'];
  description: Scalars['String'];
  id: Scalars['MigrateID'];
  name: Scalars['String'];
  updatedAt: Scalars['MigrateDateTime'];
};

export type MapLocation = WithName & {
  __typename?: 'MapLocation';
  location: Coordinates;
  name: Scalars['String'];
};

export type MapLocationInput = {
  location: CoordinatesInput;
  name: Scalars['String'];
};

export type MarkChannelInput = {
  channelId: Scalars['MigrateID'];
};

/** Where the candidate learnt about Migrate */
export enum MarketingChannel {
  Advertisement = 'ADVERTISEMENT',
  AroraMedicalEducation = 'ARORA_MEDICAL_EDUCATION',
  Linkedin = 'LINKEDIN',
  MarketingEmail = 'MARKETING_EMAIL',
  Other = 'OTHER',
  ReferredByFriend = 'REFERRED_BY_FRIEND',
  SearchEngine = 'SEARCH_ENGINE'
}

export type MarketingChannelInfo = {
  __typename?: 'MarketingChannelInfo';
  channel: MarketingChannel;
  detail?: Maybe<Scalars['String']>;
};

export type MatchResponse = {
  candidate: CandidateV2;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  job: Job;
  type: MatchResponseType;
  updatedAt: Scalars['MigrateDateTime'];
};

export type MatchResponsePage = Page & {
  __typename?: 'MatchResponsePage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<MatchResponse>;
  pageCount: Scalars['Int'];
};

/** Reflects the type of a match response */
export enum MatchResponseType {
  ApplicationApproved = 'APPLICATION_APPROVED',
  ApplicationStart = 'APPLICATION_START',
  Apply = 'APPLY',
  Hide = 'HIDE',
  Rejected = 'REJECTED',
  Save = 'SAVE'
}

export type MatchResponseTypeFilterInput = {
  in: Array<MatchResponseType>;
};

/** Used to sort match responses */
export enum MatchResponsesOrderBy {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC'
}

export type MatchResponsesWhereInput = {
  and?: InputMaybe<Array<MatchResponsesWhereInput>>;
  candidate?: InputMaybe<MigrateIdFilterInput>;
  candidateName?: InputMaybe<TermFilterInput>;
  not?: InputMaybe<Array<MatchResponsesWhereInput>>;
  or?: InputMaybe<Array<MatchResponsesWhereInput>>;
  type?: InputMaybe<MatchResponseTypeFilterInput>;
};

export type Message = Createable & Entity & Updateable & WithId & {
  __typename?: 'Message';
  attachment?: Maybe<Attachment>;
  author?: Maybe<User>;
  channel: Channel;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['MigrateDateTime'];
  deletedAt?: Maybe<Scalars['MigrateDateTime']>;
  id: Scalars['MigrateID'];
  /** always true whenever a message is returned from the backend, used to update the UI */
  isSent: Scalars['Boolean'];
  reactionInfo: Array<MessageReactionInfo>;
  referencedMessage?: Maybe<Message>;
  sendError: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
};

export type MessagePage = Page & {
  __typename?: 'MessagePage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<Message>;
  pageCount: Scalars['Int'];
};

export type MessageReaction = Createable & Entity & Updateable & WithId & {
  __typename?: 'MessageReaction';
  createdAt: Scalars['MigrateDateTime'];
  emoji: Scalars['String'];
  id: Scalars['MigrateID'];
  updatedAt: Scalars['MigrateDateTime'];
  userId: Scalars['MigrateID'];
};

export type MessageReactionInfo = {
  __typename?: 'MessageReactionInfo';
  containsMe: Scalars['Boolean'];
  count: Scalars['Int'];
  emoji: Scalars['String'];
  messageReactions: Array<MessageReaction>;
};

export type MessageTemplate = Createable & Entity & Updateable & WithId & WithName & {
  __typename?: 'MessageTemplate';
  /** Returns null if added by Migrate */
  addedBy?: Maybe<User>;
  canDelete: Scalars['Boolean'];
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  name: Scalars['String'];
  organisation: Organisation;
  tags: Array<MessageTemplateTag>;
  template: Scalars['String'];
  type: MessageTemplateType;
  updatedAt: Scalars['MigrateDateTime'];
};

export type MessageTemplatePage = Page & {
  __typename?: 'MessageTemplatePage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<MessageTemplate>;
  pageCount: Scalars['Int'];
};

export type MessageTemplateTag = WithName & {
  __typename?: 'MessageTemplateTag';
  description: Scalars['String'];
  name: Scalars['String'];
  tag: Scalars['String'];
};

export type MessageTemplateTagsInput = {
  type: MessageTemplateType;
};

/** The context in which the template can be used */
export enum MessageTemplateType {
  ChannelApplicationDm = 'CHANNEL_APPLICATION_DM',
  HiringStageToUnsuccessful = 'HIRING_STAGE_TO_UNSUCCESSFUL'
}

export type MessageTemplateTypeFilterInput = {
  in: Array<MessageTemplateType>;
};

/** Sort order for message templates */
export enum MessageTemplatesOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type MessageTemplatesWhereInput = {
  and?: InputMaybe<Array<MessageTemplatesWhereInput>>;
  name?: InputMaybe<TermFilterInput>;
  not?: InputMaybe<Array<MessageTemplatesWhereInput>>;
  or?: InputMaybe<Array<MessageTemplatesWhereInput>>;
  organisation?: InputMaybe<MigrateIdFilterInput>;
  template?: InputMaybe<TermFilterInput>;
  type?: InputMaybe<MessageTemplateTypeFilterInput>;
};

/** Used to sort messages */
export enum MessagesOrderBy {
  CreatedatDesc = 'CREATEDAT_DESC'
}

export type MessagesWhereInput = {
  and?: InputMaybe<Array<MessagesWhereInput>>;
  channel?: InputMaybe<MigrateIdFilterInput>;
  content?: InputMaybe<TermFilterInput>;
  not?: InputMaybe<Array<MessagesWhereInput>>;
  or?: InputMaybe<Array<MessagesWhereInput>>;
};

export type MigrateCandidateSource = CandidateSource & {
  __typename?: 'MigrateCandidateSource';
  type: CandidateSourceType;
};

export type MigrateIdFilterInput = {
  in: Array<Scalars['MigrateID']>;
};

export type MonthlyIntervalInput = {
  between: IntervalInput;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptJobInvite: AcceptJobInvitePayload;
  addApplicationComment: CommentApplicationEvent;
  addCandidateToJob: Application;
  addChannelMembers: Array<ChannelMember>;
  addHiringStage: Job;
  addNewCandidateApplication: Application;
  addTeamMemberToJob: Job;
  answerApplicationQuestion: ApplicationStartMatchResponse;
  answerQuestion: Answer;
  /** @deprecated Use startMatchApplication / submitMatchApplication flow */
  applyForJob: Application;
  approveMatchApplication: ApproveMatchApplicationPayload;
  archiveChannel: Channel;
  archiveJob: Job;
  askQuestion: Question;
  /** @deprecated Use changeApplicationHiringStageToUnsuccessful in unsuccessful case */
  changeApplicationHiringStage: ChangeApplicationHiringStagePayload;
  changeApplicationHiringStageToSuccessful: ChangeApplicationHiringStagePayload;
  changeApplicationHiringStageToUnsuccessful: ChangeApplicationHiringStagePayload;
  createCareerBreak: CandidateV2;
  /** admin only */
  createChannelCategory: ChannelCategory;
  /** Invites an external user to a channel */
  createChannelInvite: ChannelInvite;
  createChecksTemplate: ChecksTemplate;
  createEducationExperience: CandidateV2;
  createJob: Job;
  createJobCategory: JobCategory;
  createLanguageResult: CandidateV2;
  createLocation: Location;
  createMessage: Message;
  createMessageReaction: MessageReaction;
  createMessageTemplate: MessageTemplate;
  /** Admin only */
  createOrganisation: CreateOrganisationPayload;
  createOrganisationPrivateChannel: OrganisationPrivateChannel;
  createProfession: CreateProfessionPayload;
  createQuestionResponse: CandidateV2;
  createQuestionTopic: QuestionTopic;
  createRegistrationDetail: CandidateV2;
  createWorkExperience: CandidateV2;
  declineJobInvite: DeclineJobInvitePayload;
  deleteAnswer: Answer;
  deleteApplicationComment: CommentApplicationEvent;
  deleteCandidateAccount: User;
  deleteCareerExperience: CandidateV2;
  deleteChecksTemplate: ChecksTemplate;
  deleteDocument: Document;
  deleteEducationExperience: CandidateV2;
  deleteFile: File;
  deleteLanguageResult: CandidateV2;
  deleteMessage: DeleteMessagePayload;
  deleteMessageReaction: MessageReaction;
  deleteMessageTemplate: MessageTemplate;
  deleteQuestion: Question;
  deleteQuestionResponse: CandidateV2;
  deleteRegistrationDetail: CandidateV2;
  dismissAllNotifications: Scalars['Boolean'];
  dismissNotification: Notification;
  duplicateChecksTemplate: DuplicateChecksTemplatePayload;
  duplicateJob: DuplicateJobPayload;
  hideMatch: MatchResponse;
  inviteCandidateToJob: InviteCandidateToJobPayload;
  inviteTeamMember: TeamMemberInvite;
  /** Adds the current user to a channel */
  joinChannel: ChannelMember;
  /** Removes the current user from a channel */
  leaveChannel: ChannelMember;
  /** Sets the read cursor in a channel */
  markChannel: Channel;
  muteAllChannels: User;
  muteChannel: Channel;
  openSupportChannelAndSendMessage: OpenSupportChannelAndSendMessagePayload;
  publishJob: Job;
  readAllNotifications: Scalars['Boolean'];
  readNotification: Notification;
  rejectMatchApplication: RejectedMatchResponse;
  removeApplicationQuestionResponse: ApplicationStartMatchResponse;
  removeChannelMember: ChannelMember;
  removeHiringStage: Job;
  removeJobFile: Job;
  removeMatchResponse: MatchResponse;
  removeTeamMemberFromJob: Job;
  replaceDocument: Document;
  reportMessage: Scalars['Boolean'];
  /** @deprecated Use specific type mutation instead - unable to expand these to handle additional input data */
  respondToMatch: MatchResponse;
  restoreDocument: Document;
  restoreFile: File;
  saveJob: Job;
  saveMatch: MatchResponse;
  scheduleInterview: ChangeApplicationHiringStagePayload;
  sendTemplateMessageToAllHiringStage: SendTemplateMessageToAllHiringStagePayload;
  setPushToken: User;
  signupToMailingList: Scalars['Boolean'];
  startMatchApplication: ApplicationStartMatchResponse;
  submitMatchApplication: MatchResponse;
  toggleAnswerVote: ToggleAnswerVotePayload;
  toggleApplicationCheck: ApplicationCheck;
  undoRejectMatchApplication: ApplicationStartMatchResponse;
  unmuteAllChannels: User;
  unmuteChannel: Channel;
  unpublishJob: Job;
  unsaveJob: Job;
  updateApplicationComment: CommentApplicationEvent;
  /** Currently passing an ID does not affect anything,       as only a logged in candidate can change their own account */
  updateCandidate: Candidate;
  updateCandidateProfession: Candidate;
  updateCareerBreak: CandidateV2;
  /** Updates the career quiz result for the currently authenticated candidate */
  updateCareerQuizResult: CandidateV2;
  updateChecksTemplate: ChecksTemplate;
  /** Updates the currently authenticated candidate */
  updateCurrentCandidate: CandidateV2;
  updateEducationExperience: CandidateV2;
  updateHiringNotes: Application;
  updateHiringStage: HiringStage;
  updateHiringStagePosition: Job;
  updateInterview: Interview;
  updateJob: Job;
  updateJobSearchStatus: Candidate;
  updateLanguageResult: CandidateV2;
  updateLanguageStatus: Candidate;
  updateLocation: Location;
  updateMessage: UpdateMessagePayload;
  updateMessageTemplate: MessageTemplate;
  updateOrganisation: Organisation;
  updateOrganisationPrivateChannel: OrganisationPrivateChannel;
  updateQuestionResponse: CandidateV2;
  updateRegistrationDetail: CandidateV2;
  updateTeamMember: TeamMember;
  updateUser: User;
  updateWorkExperience: CandidateV2;
  uploadApplicationFile: Application;
  uploadDocument: Document;
  uploadDocumentFromAttachment: Document;
  uploadJobFile: Job;
  uploadOrganisationLogo: Organisation;
  uploadProfilePhoto: User;
  verifyDocument: Document;
  verifyRegistrationDetail: Candidate;
};


export type MutationAcceptJobInviteArgs = {
  input: AcceptJobInviteInput;
};


export type MutationAddApplicationCommentArgs = {
  input: AddApplicationCommentInput;
};


export type MutationAddCandidateToJobArgs = {
  input: AddCandidateToJobInput;
};


export type MutationAddChannelMembersArgs = {
  input: AddChannelMembersInput;
};


export type MutationAddHiringStageArgs = {
  input: AddHiringStageInput;
};


export type MutationAddNewCandidateApplicationArgs = {
  input: AddNewCandidateApplicationInput;
};


export type MutationAddTeamMemberToJobArgs = {
  input: UpdateHiringTeamInput;
};


export type MutationAnswerApplicationQuestionArgs = {
  input: AnswerApplicationQuestionInput;
};


export type MutationAnswerQuestionArgs = {
  input: AnswerQuestionInput;
};


export type MutationApplyForJobArgs = {
  input: ApplyForJobInput;
};


export type MutationApproveMatchApplicationArgs = {
  input: ApproveMatchApplicationInput;
};


export type MutationArchiveChannelArgs = {
  input: ArchiveChannelInput;
};


export type MutationArchiveJobArgs = {
  input: UpdatePublicationStatusInput;
};


export type MutationAskQuestionArgs = {
  input: AskQuestionInput;
};


export type MutationChangeApplicationHiringStageArgs = {
  input: ChangeApplicationHiringStageInput;
};


export type MutationChangeApplicationHiringStageToSuccessfulArgs = {
  input: ChangeApplicationHiringStageToSuccessfulInput;
};


export type MutationChangeApplicationHiringStageToUnsuccessfulArgs = {
  input: ChangeApplicationHiringStageToUnsuccessfulInput;
};


export type MutationCreateCareerBreakArgs = {
  input: CreateCareerBreakInput;
};


export type MutationCreateChannelCategoryArgs = {
  input: CreateChannelCategoryInput;
};


export type MutationCreateChannelInviteArgs = {
  input: CreateChannelInviteInput;
};


export type MutationCreateChecksTemplateArgs = {
  input: CreateChecksTemplateInput;
};


export type MutationCreateEducationExperienceArgs = {
  input: CreateEducationExperienceInput;
};


export type MutationCreateJobArgs = {
  input: CreateJobInput;
};


export type MutationCreateJobCategoryArgs = {
  input: CreateJobCategoryInput;
};


export type MutationCreateLanguageResultArgs = {
  input: CreateLanguageResultInput;
};


export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


export type MutationCreateMessageReactionArgs = {
  input: CreateMessageReactionInput;
};


export type MutationCreateMessageTemplateArgs = {
  input: CreateMessageTemplateInput;
};


export type MutationCreateOrganisationArgs = {
  input: CreateOrganisationInput;
};


export type MutationCreateOrganisationPrivateChannelArgs = {
  input: CreateOrganisationPrivateChannelInput;
};


export type MutationCreateProfessionArgs = {
  input: CreateProfessionInput;
};


export type MutationCreateQuestionResponseArgs = {
  input: CreateQuestionResponseInput;
};


export type MutationCreateQuestionTopicArgs = {
  input: CreateQuestionTopicInput;
};


export type MutationCreateRegistrationDetailArgs = {
  input: CreateRegistrationDetailInput;
};


export type MutationCreateWorkExperienceArgs = {
  input: CreateWorkExperienceInput;
};


export type MutationDeclineJobInviteArgs = {
  input: DeclineJobInviteInput;
};


export type MutationDeleteAnswerArgs = {
  input: DeleteAnswerInput;
};


export type MutationDeleteApplicationCommentArgs = {
  id: Scalars['MigrateID'];
};


export type MutationDeleteCareerExperienceArgs = {
  input: DeleteCareerExperienceInput;
};


export type MutationDeleteChecksTemplateArgs = {
  id: Scalars['MigrateID'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['MigrateID'];
};


export type MutationDeleteEducationExperienceArgs = {
  input: DeleteEducationExperienceInput;
};


export type MutationDeleteFileArgs = {
  id: Scalars['MigrateID'];
};


export type MutationDeleteLanguageResultArgs = {
  input: DeleteLanguageResultInput;
};


export type MutationDeleteMessageArgs = {
  input: DeleteMessageInput;
};


export type MutationDeleteMessageReactionArgs = {
  input: DeleteMessageReactionInput;
};


export type MutationDeleteMessageTemplateArgs = {
  id: Scalars['MigrateID'];
};


export type MutationDeleteQuestionArgs = {
  input: DeleteQuestionInput;
};


export type MutationDeleteQuestionResponseArgs = {
  input: DeleteQuestionResponseInput;
};


export type MutationDeleteRegistrationDetailArgs = {
  input: DeleteRegistrationDetailInput;
};


export type MutationDismissAllNotificationsArgs = {
  input?: InputMaybe<NotificationsWhereInput>;
};


export type MutationDismissNotificationArgs = {
  id: Scalars['MigrateID'];
};


export type MutationDuplicateChecksTemplateArgs = {
  input: DuplicateChecksTemplateInput;
};


export type MutationDuplicateJobArgs = {
  input: DuplicateJobInput;
};


export type MutationHideMatchArgs = {
  input: GenericMatchResponseInput;
};


export type MutationInviteCandidateToJobArgs = {
  input: InviteCandidateToJobInput;
};


export type MutationInviteTeamMemberArgs = {
  input: InviteTeamMemberInput;
};


export type MutationJoinChannelArgs = {
  input: JoinChannelInput;
};


export type MutationLeaveChannelArgs = {
  input: LeaveChannelInput;
};


export type MutationMarkChannelArgs = {
  input: MarkChannelInput;
};


export type MutationMuteAllChannelsArgs = {
  input: MuteAllChannelsInput;
};


export type MutationMuteChannelArgs = {
  input: MuteChannelInput;
};


export type MutationOpenSupportChannelAndSendMessageArgs = {
  input: OpenSupportChannelAndSendMessageInput;
};


export type MutationPublishJobArgs = {
  input: UpdatePublicationStatusInput;
};


export type MutationReadAllNotificationsArgs = {
  input?: InputMaybe<NotificationsWhereInput>;
};


export type MutationReadNotificationArgs = {
  id: Scalars['MigrateID'];
};


export type MutationRejectMatchApplicationArgs = {
  input: RejectMatchApplicationInput;
};


export type MutationRemoveApplicationQuestionResponseArgs = {
  input: RemoveApplicationQuestionResponseInput;
};


export type MutationRemoveChannelMemberArgs = {
  input: RemoveChannelMemberInput;
};


export type MutationRemoveHiringStageArgs = {
  input: RemoveHiringStageInput;
};


export type MutationRemoveJobFileArgs = {
  input: RemoveJobFileInput;
};


export type MutationRemoveMatchResponseArgs = {
  input: RemoveMatchResponseInput;
};


export type MutationRemoveTeamMemberFromJobArgs = {
  input: UpdateHiringTeamInput;
};


export type MutationReplaceDocumentArgs = {
  input: ReplaceDocumentInput;
};


export type MutationReportMessageArgs = {
  input: ReportMessageInput;
};


export type MutationRespondToMatchArgs = {
  input: RespondToMatchInput;
};


export type MutationRestoreDocumentArgs = {
  id: Scalars['MigrateID'];
};


export type MutationRestoreFileArgs = {
  id: Scalars['MigrateID'];
};


export type MutationSaveJobArgs = {
  input: SaveJobInput;
};


export type MutationSaveMatchArgs = {
  input: GenericMatchResponseInput;
};


export type MutationScheduleInterviewArgs = {
  input: ScheduleInterviewInput;
};


export type MutationSendTemplateMessageToAllHiringStageArgs = {
  input: SendTemplateMessageToAllHiringStageInput;
};


export type MutationSetPushTokenArgs = {
  input: SetPushTokenInput;
};


export type MutationStartMatchApplicationArgs = {
  input: GenericMatchResponseInput;
};


export type MutationSubmitMatchApplicationArgs = {
  input: GenericMatchResponseInput;
};


export type MutationToggleAnswerVoteArgs = {
  input: ToggleAnswerVoteInput;
};


export type MutationToggleApplicationCheckArgs = {
  input: ToggleApplicationCheckInput;
};


export type MutationUndoRejectMatchApplicationArgs = {
  input: UndoRejectMatchApplicationInput;
};


export type MutationUnmuteChannelArgs = {
  input: UnmuteChannelInput;
};


export type MutationUnpublishJobArgs = {
  input: UpdatePublicationStatusInput;
};


export type MutationUnsaveJobArgs = {
  input: UnsaveJobInput;
};


export type MutationUpdateApplicationCommentArgs = {
  input: UpdateApplicationCommentInput;
};


export type MutationUpdateCandidateArgs = {
  input: UpdateCandidateInput;
};


export type MutationUpdateCandidateProfessionArgs = {
  input: UpdateCandidateProfessionInput;
};


export type MutationUpdateCareerBreakArgs = {
  input: UpdateCareerBreakInput;
};


export type MutationUpdateCareerQuizResultArgs = {
  input: UpdateCareerQuizResultInput;
};


export type MutationUpdateChecksTemplateArgs = {
  input: UpdateChecksTemplateInput;
};


export type MutationUpdateCurrentCandidateArgs = {
  input: UpdateCurrentCandidateInput;
};


export type MutationUpdateEducationExperienceArgs = {
  input: UpdateEducationExperienceInput;
};


export type MutationUpdateHiringNotesArgs = {
  input: UpdateHiringNotesInput;
};


export type MutationUpdateHiringStageArgs = {
  input: UpdateHiringStageInput;
};


export type MutationUpdateHiringStagePositionArgs = {
  input: UpdateHiringStagePositionInput;
};


export type MutationUpdateInterviewArgs = {
  input: UpdateInterviewInput;
};


export type MutationUpdateJobArgs = {
  input: UpdateJobInput;
};


export type MutationUpdateJobSearchStatusArgs = {
  input: UpdateJobSearchStatusInput;
};


export type MutationUpdateLanguageResultArgs = {
  input: UpdateLanguageResultInput;
};


export type MutationUpdateLanguageStatusArgs = {
  input: UpdateLanguageStatusInput;
};


export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
};


export type MutationUpdateMessageArgs = {
  input: UpdateMessageInput;
};


export type MutationUpdateMessageTemplateArgs = {
  input: UpdateMessageTemplateInput;
};


export type MutationUpdateOrganisationArgs = {
  input: UpdateOrganisationInput;
};


export type MutationUpdateOrganisationPrivateChannelArgs = {
  input: UpdateOrganisationPrivateChannelInput;
};


export type MutationUpdateQuestionResponseArgs = {
  input: UpdateQuestionResponseInput;
};


export type MutationUpdateRegistrationDetailArgs = {
  input: UpdateRegistrationDetailInput;
};


export type MutationUpdateTeamMemberArgs = {
  input: UpdateTeamMemberInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateWorkExperienceArgs = {
  input: UpdateWorkExperienceInput;
};


export type MutationUploadApplicationFileArgs = {
  input: UploadApplicationFileInput;
};


export type MutationUploadDocumentArgs = {
  input: UploadDocumentInput;
};


export type MutationUploadDocumentFromAttachmentArgs = {
  input: UploadDocumentFromAttachmentInput;
};


export type MutationUploadJobFileArgs = {
  input: UploadJobFileInput;
};


export type MutationUploadOrganisationLogoArgs = {
  input: UploadOrganisationLogoInput;
};


export type MutationUploadProfilePhotoArgs = {
  input: UploadProfilePhotoInput;
};


export type MutationVerifyDocumentArgs = {
  input: VerifyDocumentInput;
};


export type MutationVerifyRegistrationDetailArgs = {
  input: VerifyRegistrationDetailInput;
};

export type MuteAllChannelsInput = {
  /** Timestamp until which all notifications should be muted - if null then mute indefinitely */
  until?: InputMaybe<Scalars['MigrateDateTime']>;
};

export type MuteChannelInput = {
  channelId: Scalars['MigrateID'];
  /** Timestamp until which chanenl notifications should be muted - if null then mute indefinitely */
  until?: InputMaybe<Scalars['MigrateDateTime']>;
};

export type MyMatchedJobsInput = {
  count?: InputMaybe<Scalars['Int']>;
};

export type NewCandidateNotification = Createable & Entity & Notification & Updateable & WithId & {
  __typename?: 'NewCandidateNotification';
  application: Application;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  status: NotificationStatus;
  type: NotificationType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
  user?: Maybe<User>;
};

export type NewMentionNotification = Createable & Entity & Notification & Updateable & WithId & {
  __typename?: 'NewMentionNotification';
  application: Application;
  commentApplicationEvent: CommentApplicationEvent;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  status: NotificationStatus;
  type: NotificationType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
  user?: Maybe<User>;
};

export type NewMessageNotification = Createable & Entity & Notification & Updateable & WithId & {
  __typename?: 'NewMessageNotification';
  application: Application;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  message?: Maybe<Message>;
  status: NotificationStatus;
  type: NotificationType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
  user?: Maybe<User>;
};

export type Notification = {
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  status: NotificationStatus;
  type: NotificationType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
  user?: Maybe<User>;
};

export type NotificationPage = Page & {
  __typename?: 'NotificationPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<Maybe<Notification>>;
  pageCount: Scalars['Int'];
};

/** Indicates whether notifications have been dismissed */
export enum NotificationStatus {
  Dismissed = 'DISMISSED',
  Inbox = 'INBOX'
}

/** Discriminates different classes of notifications in shared collection */
export enum NotificationType {
  CandidateApplicationRejected = 'CANDIDATE_APPLICATION_REJECTED',
  CandidateCanReapply = 'CANDIDATE_CAN_REAPPLY',
  CandidateCompleteApplicationReminder = 'CANDIDATE_COMPLETE_APPLICATION_REMINDER',
  CandidateCompleteProfileReminder = 'CANDIDATE_COMPLETE_PROFILE_REMINDER',
  CandidateInterviewInvite = 'CANDIDATE_INTERVIEW_INVITE',
  CandidateInterviewUpdated = 'CANDIDATE_INTERVIEW_UPDATED',
  CandidateQuestionAnswered = 'CANDIDATE_QUESTION_ANSWERED',
  NewCandidate = 'NEW_CANDIDATE',
  NewMention = 'NEW_MENTION',
  NewMessage = 'NEW_MESSAGE'
}

export type NotificationTypeFilterInput = {
  in: Array<NotificationType>;
};

/** Used to sort Notifications */
export enum NotificationsOrderBy {
  CreatedatDesc = 'CREATEDAT_DESC'
}

export type NotificationsWhereInput = {
  and?: InputMaybe<Array<NotificationsWhereInput>>;
  job?: InputMaybe<MigrateIdFilterInput>;
  not?: InputMaybe<Array<NotificationsWhereInput>>;
  or?: InputMaybe<Array<NotificationsWhereInput>>;
  type?: InputMaybe<NotificationTypeFilterInput>;
};

export type OpenSupportChannelAndSendMessageInput = {
  candidateId: Scalars['MigrateID'];
  content?: InputMaybe<Scalars['String']>;
};

export type OpenSupportChannelAndSendMessagePayload = {
  __typename?: 'OpenSupportChannelAndSendMessagePayload';
  channel: OrganisationPrivateChannel;
  message: Message;
};

export type Organisation = Createable & Entity & Updateable & WithId & WithName & {
  __typename?: 'Organisation';
  checksTemplates: ChecksTemplatePage;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  /** @deprecated Use type instead */
  isAgency: Scalars['Boolean'];
  isTrial: Scalars['Boolean'];
  name: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  type: OrganisationType;
  updatedAt: Scalars['MigrateDateTime'];
  url: Scalars['String'];
};


export type OrganisationChecksTemplatesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};

export type OrganisationFieldAggregate = FieldAggregate & {
  __typename?: 'OrganisationFieldAggregate';
  counts: Array<OrganisationFieldAggregateItem>;
  /** The total number of items aggregated. These may be different from the set count as undefined items are not included in the count. */
  totalCount: Scalars['Int'];
};

export type OrganisationFieldAggregateItem = FieldAggregateItem & {
  __typename?: 'OrganisationFieldAggregateItem';
  count: Scalars['Int'];
  value: Organisation;
};

export type OrganisationMessageTemplatesWhereInput = {
  and?: InputMaybe<Array<MessageTemplatesWhereInput>>;
  name?: InputMaybe<TermFilterInput>;
  not?: InputMaybe<Array<MessageTemplatesWhereInput>>;
  or?: InputMaybe<Array<MessageTemplatesWhereInput>>;
  template?: InputMaybe<TermFilterInput>;
  type?: InputMaybe<MessageTemplateTypeFilterInput>;
};

export type OrganisationPrivateChannel = Channel & Createable & Entity & PrivateChannel & Updateable & WithId & WithName & {
  __typename?: 'OrganisationPrivateChannel';
  archivedAt?: Maybe<Scalars['MigrateDateTime']>;
  canReact: Scalars['Boolean'];
  createdAt: Scalars['MigrateDateTime'];
  creator: User;
  creatorId: Scalars['MigrateID'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['MigrateID'];
  isMember: Scalars['Boolean'];
  lastMessage?: Maybe<Message>;
  members: UserPage;
  messages: MessagePage;
  mutedUntil?: Maybe<Scalars['MigrateDateTime']>;
  myChannelMember?: Maybe<ChannelMember>;
  name: Scalars['String'];
  organisation: Organisation;
  type: ChannelType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
};


export type OrganisationPrivateChannelMembersArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UsersOrderBy>;
};


export type OrganisationPrivateChannelMessagesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MessagesOrderBy>;
  where?: InputMaybe<ResolvedMessagesWhereInput>;
};

/** The type of organisation */
export enum OrganisationType {
  Agency = 'AGENCY',
  NhsTrust = 'NHS_TRUST',
  PrivateMedicalGroup = 'PRIVATE_MEDICAL_GROUP'
}

export type Page = {
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  pageCount: Scalars['Int'];
};

/** Used for paginating forwards or backwards */
export enum PaginationDirection {
  After = 'AFTER',
  Before = 'BEFORE'
}

export type Pipeline = {
  __typename?: 'Pipeline';
  stages: PipelineStages;
  totalCount: Scalars['Int'];
};

export type PipelineStage = {
  __typename?: 'PipelineStage';
  count: Scalars['Int'];
  hiringStages: Array<HiringStage>;
};

export type PipelineStages = {
  __typename?: 'PipelineStages';
  applied: PipelineStage;
  interview: PipelineStage;
  offer: PipelineStage;
  shortlist: PipelineStage;
  successful: PipelineStage;
  unsuccessful: PipelineStage;
  withdrawn: PipelineStage;
};

export type PrivateChannel = {
  archivedAt?: Maybe<Scalars['MigrateDateTime']>;
  canReact: Scalars['Boolean'];
  createdAt: Scalars['MigrateDateTime'];
  creator: User;
  creatorId: Scalars['MigrateID'];
  id: Scalars['MigrateID'];
  isMember: Scalars['Boolean'];
  lastMessage?: Maybe<Message>;
  members: UserPage;
  messages: MessagePage;
  mutedUntil?: Maybe<Scalars['MigrateDateTime']>;
  myChannelMember?: Maybe<ChannelMember>;
  type: ChannelType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
};


export type PrivateChannelMembersArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UsersOrderBy>;
};


export type PrivateChannelMessagesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MessagesOrderBy>;
  where?: InputMaybe<ResolvedMessagesWhereInput>;
};

export type Profession = WithId & WithName & {
  __typename?: 'Profession';
  id: Scalars['MigrateID'];
  name: Scalars['String'];
  specialties: Array<Tag>;
  tags: Array<Tag>;
};

export type ProfessionFieldAggregate = FieldAggregate & {
  __typename?: 'ProfessionFieldAggregate';
  counts: Array<ProfessionFieldAggregateItem>;
  /** The total number of items aggregated. These may be different from the set count as undefined items are not included in the count. */
  totalCount: Scalars['Int'];
};

export type ProfessionFieldAggregateItem = FieldAggregateItem & {
  __typename?: 'ProfessionFieldAggregateItem';
  count: Scalars['Int'];
  value: Profession;
};

export type ProfessionPage = Page & {
  __typename?: 'ProfessionPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<Profession>;
  pageCount: Scalars['Int'];
};

/** To demonstrate which parts of the profile are completed */
export enum ProfileCompletion {
  HasEducationHistory = 'HAS_EDUCATION_HISTORY',
  HasLanguageResults = 'HAS_LANGUAGE_RESULTS',
  HasMoreAboutYou = 'HAS_MORE_ABOUT_YOU',
  HasPassport = 'HAS_PASSPORT',
  HasRegistrationDetails = 'HAS_REGISTRATION_DETAILS',
  HasWorkExperience = 'HAS_WORK_EXPERIENCE'
}

export type PublicChannel = {
  archivedAt?: Maybe<Scalars['MigrateDateTime']>;
  canReact: Scalars['Boolean'];
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  isMember: Scalars['Boolean'];
  lastMessage?: Maybe<Message>;
  members: UserPage;
  messages: MessagePage;
  mutedUntil?: Maybe<Scalars['MigrateDateTime']>;
  myChannelMember?: Maybe<ChannelMember>;
  type: ChannelType;
  unread: Scalars['Boolean'];
  updatedAt: Scalars['MigrateDateTime'];
};


export type PublicChannelMembersArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UsersOrderBy>;
};


export type PublicChannelMessagesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MessagesOrderBy>;
  where?: InputMaybe<ResolvedMessagesWhereInput>;
};

/** To reflect the status of a job (Draft, Published, Archived) */
export enum PublicationStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type PublicationStatusFilterInput = {
  in: Array<PublicationStatus>;
};

export type QuarterlyIntervalInput = {
  between: IntervalInput;
};

export type Query = {
  __typename?: 'Query';
  /** Returns all jobs by createdAt for the user candidate's profession */
  allJobs: JobPage;
  answer: Answer;
  answers: AnswerPage;
  applicant: Applicant;
  applicants: ApplicantPage;
  applicantsReport: ApplicantsReportData;
  application: Application;
  applicationArrivalsReport: ApplicationArrivalsReport;
  applicationChannel: ApplicationDmChannel;
  applicationChannelTemplateMessageTags: Array<MessageTemplateTag>;
  applicationChannels: ApplicationDmChannelPage;
  applicationEvents: ApplicationEventPage;
  applications: ApplicationPage;
  applicationsByHiringStage: ApplicationPage;
  applicationsReport: ApplicationsReportData;
  archivedJobs: Array<Job>;
  canAddCandidate: Scalars['Boolean'];
  /** @deprecated Subject to breaking changes if attempts to get ExternalCandidate */
  candidate: Candidate;
  candidateApplications: ApplicationPage;
  /** @deprecated Subject to breaking changes if attempts to get ExternalCandidate */
  candidates: CandidatePage;
  channel: Channel;
  channelCategories: ChannelCategoryPage;
  channelCategory: ChannelCategory;
  /** @deprecated Uses outdated filters. Use channelsV2 instead */
  channels: ChannelPage;
  channelsV2: ChannelPage;
  checksTemplate: ChecksTemplate;
  checksTemplatesByOrganisation: ChecksTemplatePage;
  communityActivity: CommunityActivity;
  communityPublicChannel: CommunityPublicChannel;
  communityPublicChannels: CommunityPublicChannelPage;
  displayNameExists: Scalars['Boolean'];
  document: Document;
  documentTypes: Array<DocumentTypeProps>;
  draftJobs: Array<Job>;
  emailExists: Scalars['Boolean'];
  englishSpeakingCountries: Array<Maybe<Scalars['String']>>;
  generateChannelApplicationDMTemplateMessage: GenerateTemplateMessagePayload;
  generateHiringStageToUnsuccessfulMessageTemplate: GenerateTemplateMessagePayload;
  getApplicationFileUploadToken: FileUploadPayload;
  getAttachmentUploadToken: FileUploadPayload;
  getBulkAttachmentUploadToken: FileUploadPayload;
  getDocumentUploadToken: FileUploadPayload;
  /** @deprecated Should use specific entity *UploadToken queries as the actual storage type (public / private / etc.) may be subject to change. E.g. getDocumentUploadToken */
  getFileUploadToken: FileUploadPayload;
  getJobFileUploadToken: FileUploadPayload;
  getOrganisationLogoUploadToken: FileUploadPayload;
  getProfessions: ProfessionPage;
  getProfilePhotoUploadToken: FileUploadPayload;
  /** @deprecated Should use specific entity *UploadToken queries as the actual storage type (public / private / etc.) may be subject to change. E.g. getProfilePhotoUploadToken */
  getPublicFileUploadToken: FileUploadPayload;
  hasUnreadNotifications: Scalars['Boolean'];
  hiringTeamApplicationChannels: ApplicationDmChannelPage;
  historyReport: HistoryReport;
  interviews: InterviewPage;
  interviewsByOrganisation: InterviewPage;
  job: Job;
  /** Returns all job categories for a team member's organisation */
  jobCategories: Array<JobCategory>;
  jobInvite: JobInvite;
  /** Returns pending job invites matching candidate's email */
  jobInvites: JobInvitePage;
  jobsByOrganisation: JobPage;
  jobsReport: JobsReportData;
  /**
   * Returns the channels which the current user has joined
   * @deprecated Uses outdated filters. Use joinedChannelsV2 instead
   */
  joinedChannels: ChannelPage;
  joinedChannelsV2: ChannelPage;
  joinedCommunityPublicChannels: CommunityPublicChannelPage;
  /** Lists possible results for a given awarding body */
  languageResultSchema: LanguageResultSchema;
  /** Returns available job locations */
  locations: Array<Location>;
  matchResponse: MatchResponse;
  matchResponseByJob: MatchResponse;
  matchResponses: MatchResponsePage;
  me: User;
  message: Message;
  messageTemplate: MessageTemplate;
  messageTemplateTags: Array<MessageTemplateTag>;
  messageTemplates: MessageTemplatePage;
  messages: MessagePage;
  myMatchApplications: CandidateApplicationMatchResponsePage;
  myMatchResponses: MatchResponsePage;
  /** returns jobs matching the authed candidate's preferences */
  myMatchedJobs: JobPage;
  notification: Notification;
  notifications: NotificationPage;
  numUnreadMessages: Scalars['Int'];
  /**
   * Returns the channels which the current user has not joined.     This is not return any channels which the user doesn't have privileges to view,     e.g. DM / GROUP_DM channels
   * @deprecated Uses outdated filters. Use otherChannelsV2 instead
   */
  otherChannels: ChannelPage;
  otherChannelsV2: ChannelPage;
  pendingCandidates: JobInvitePage;
  /** Lists possible questions for candidates to respond to */
  profileQuestions: Array<Scalars['String']>;
  publishedJobs: Array<Job>;
  question: Question;
  questionTopics: Array<QuestionTopic>;
  questions: QuestionPage;
  redListCountries: Array<Maybe<Scalars['String']>>;
  savedJobs: Array<Job>;
  searchApplicationsByCandidateName: ApplicationPage;
  searchUsersNotInChannel: UserPage;
  /** Returns top X jobs matching the candidate's jobPreferences */
  selectedJobs: Array<Job>;
  subscribeToNewMessagesStreamConfig: FaunaStreamConfig;
  subscribeToNotificationsStreamConfig: FaunaStreamConfig;
  /** determines whether a support channel exists for a particular candidate */
  supportChannelExistsForCandidate?: Maybe<Scalars['MigrateID']>;
  /** returns support channels for account managers */
  supportChannels: ChannelPage;
  tags: Array<Tag>;
  teamMembersByOrganisation: TeamMemberPage;
  user: User;
  usersByName: UserPage;
};


export type QueryAllJobsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};


export type QueryAnswerArgs = {
  id: Scalars['MigrateID'];
};


export type QueryAnswersArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AnswersOrderBy>;
  where?: InputMaybe<AnswersWhereInput>;
};


export type QueryApplicantArgs = {
  id: Scalars['MigrateID'];
};


export type QueryApplicantsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CandidatesOrderBy>;
  where?: InputMaybe<CandidatesWhereInput>;
};


export type QueryApplicantsReportArgs = {
  where?: InputMaybe<CandidatesWhereInput>;
};


export type QueryApplicationArgs = {
  id: Scalars['MigrateID'];
};


export type QueryApplicationArrivalsReportArgs = {
  date?: InputMaybe<ReportDateInput>;
  where?: InputMaybe<ApplicationsReportWhereInput>;
};


export type QueryApplicationChannelArgs = {
  id: Scalars['MigrateID'];
};


export type QueryApplicationChannelsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};


export type QueryApplicationEventsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ApplicationEventsOrderBy>;
  where: ApplicationEventsWhereInput;
};


export type QueryApplicationsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ApplicationsOrderBy>;
  where?: InputMaybe<ApplicationsWhereInput>;
};


export type QueryApplicationsByHiringStageArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  hiringStageId: Scalars['MigrateID'];
};


export type QueryApplicationsReportArgs = {
  where?: InputMaybe<ApplicationsReportWhereInput>;
};


export type QueryCanAddCandidateArgs = {
  email: Scalars['String'];
};


export type QueryCandidateArgs = {
  id: Scalars['MigrateID'];
};


export type QueryCandidateApplicationsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};


export type QueryCandidatesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CandidatesOrderBy>;
  where?: InputMaybe<CandidatesWhereInput>;
};


export type QueryChannelArgs = {
  id: Scalars['MigrateID'];
};


export type QueryChannelCategoriesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ChannelCategoriesOrderBy>;
};


export type QueryChannelCategoryArgs = {
  id: Scalars['MigrateID'];
};


export type QueryChannelsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<ChannelsOrderBy>;
  where?: InputMaybe<ChannelsWhereInput>;
};


export type QueryChannelsV2Args = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<ChannelsOrderBy>;
  where?: InputMaybe<ChannelsWhereInputV2>;
};


export type QueryChecksTemplateArgs = {
  id: Scalars['MigrateID'];
};


export type QueryChecksTemplatesByOrganisationArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};


export type QueryCommunityPublicChannelArgs = {
  id: Scalars['MigrateID'];
};


export type QueryCommunityPublicChannelsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ChannelsOrderBy>;
  where?: InputMaybe<CommunityPublicChannelsWhereInput>;
};


export type QueryDisplayNameExistsArgs = {
  displayName: Scalars['String'];
};


export type QueryDocumentArgs = {
  id: Scalars['MigrateID'];
};


export type QueryEmailExistsArgs = {
  email: Scalars['String'];
};


export type QueryGenerateChannelApplicationDmTemplateMessageArgs = {
  input: GenerateApplicationDmChannelTemplateMessageInput;
};


export type QueryGenerateHiringStageToUnsuccessfulMessageTemplateArgs = {
  input: GenerateApplicationDmChannelTemplateMessageInput;
};


export type QueryGetApplicationFileUploadTokenArgs = {
  input: GetApplicationFileUploadTokenInput;
};


export type QueryGetAttachmentUploadTokenArgs = {
  input: GetAttachmentUploadTokenInput;
};


export type QueryGetBulkAttachmentUploadTokenArgs = {
  input: GetBulkAttachmentUploadTokenInput;
};


export type QueryGetDocumentUploadTokenArgs = {
  input: FileMetadataInput;
};


export type QueryGetFileUploadTokenArgs = {
  input: FileMetadataInput;
};


export type QueryGetJobFileUploadTokenArgs = {
  input: GetJobFileUploadTokenInput;
};


export type QueryGetProfessionsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};


export type QueryGetPublicFileUploadTokenArgs = {
  input: FileMetadataInput;
};


export type QueryHiringTeamApplicationChannelsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};


export type QueryHistoryReportArgs = {
  date?: InputMaybe<ReportDateInput>;
};


export type QueryInterviewsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<InterviewsOrderBy>;
  where?: InputMaybe<InterviewsWhereInput>;
};


export type QueryInterviewsByOrganisationArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};


export type QueryJobArgs = {
  id: Scalars['MigrateID'];
};


export type QueryJobInviteArgs = {
  id: Scalars['MigrateID'];
};


export type QueryJobInvitesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};


export type QueryJobsByOrganisationArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<JobsOrderBy>;
  where?: InputMaybe<JobsByOrganisationWhereInput>;
};


export type QueryJobsReportArgs = {
  where?: InputMaybe<JobsReportWhereInput>;
};


export type QueryJoinedChannelsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<ChannelsOrderBy>;
  where?: InputMaybe<JoinedChannelsWhereInput>;
};


export type QueryJoinedChannelsV2Args = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<ChannelsOrderBy>;
  where?: InputMaybe<ChannelsWhereInputV2>;
};


export type QueryJoinedCommunityPublicChannelsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ChannelsOrderBy>;
  where?: InputMaybe<CommunityPublicChannelsWhereInput>;
};


export type QueryMatchResponseArgs = {
  id: Scalars['MigrateID'];
};


export type QueryMatchResponseByJobArgs = {
  jobId: Scalars['MigrateID'];
};


export type QueryMatchResponsesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MatchResponsesOrderBy>;
  where?: InputMaybe<MatchResponsesWhereInput>;
};


export type QueryMessageArgs = {
  id: Scalars['MigrateID'];
};


export type QueryMessageTemplateArgs = {
  id: Scalars['MigrateID'];
};


export type QueryMessageTemplateTagsArgs = {
  input: MessageTemplateTagsInput;
};


export type QueryMessageTemplatesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MessageTemplatesOrderBy>;
  where?: InputMaybe<OrganisationMessageTemplatesWhereInput>;
};


export type QueryMessagesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MessagesOrderBy>;
  where: MessagesWhereInput;
};


export type QueryMyMatchApplicationsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MatchResponsesOrderBy>;
  where?: InputMaybe<MatchResponsesWhereInput>;
};


export type QueryMyMatchResponsesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MatchResponsesOrderBy>;
  where?: InputMaybe<MatchResponsesWhereInput>;
};


export type QueryMyMatchedJobsArgs = {
  input?: InputMaybe<MyMatchedJobsInput>;
};


export type QueryNotificationArgs = {
  id: Scalars['MigrateID'];
};


export type QueryNotificationsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<NotificationsOrderBy>;
  where?: InputMaybe<NotificationsWhereInput>;
};


export type QueryOtherChannelsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<ChannelsOrderBy>;
  where?: InputMaybe<JoinedChannelsWhereInput>;
};


export type QueryOtherChannelsV2Args = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<ChannelsOrderBy>;
  where?: InputMaybe<ChannelsWhereInputV2>;
};


export type QueryPendingCandidatesArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  hiringStageId: Scalars['MigrateID'];
};


export type QueryQuestionArgs = {
  id: Scalars['MigrateID'];
};


export type QueryQuestionsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<QuestionsOrderBy>;
  where?: InputMaybe<QuestionsWhereInput>;
};


export type QuerySearchApplicationsByCandidateNameArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  searchTerm: Scalars['String'];
};


export type QuerySearchUsersNotInChannelArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  channelId: Scalars['MigrateID'];
  searchTerm: Scalars['String'];
};


export type QuerySelectedJobsArgs = {
  input?: InputMaybe<SelectedJobsInput>;
};


export type QuerySupportChannelExistsForCandidateArgs = {
  candidateId: Scalars['MigrateID'];
};


export type QuerySupportChannelsArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};


export type QueryTeamMembersByOrganisationArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  id: Scalars['MigrateID'];
};


export type QueryUsersByNameArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  searchTerm: Scalars['String'];
};

export type Question = Createable & Entity & Updateable & WithId & {
  __typename?: 'Question';
  answers: AnswerPage;
  author: User;
  createdAt: Scalars['MigrateDateTime'];
  highlightedAnswer?: Maybe<Answer>;
  id: Scalars['MigrateID'];
  myAnswer?: Maybe<Answer>;
  title: Scalars['String'];
  topics: Array<QuestionTopic>;
  updatedAt: Scalars['MigrateDateTime'];
};


export type QuestionAnswersArgs = {
  _cursor?: InputMaybe<Scalars['String']>;
  _direction?: InputMaybe<PaginationDirection>;
  _size?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AnswersOrderBy>;
  where?: InputMaybe<ResolvedAnswersWhereInput>;
};

export type QuestionPage = Page & {
  __typename?: 'QuestionPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<Question>;
  pageCount: Scalars['Int'];
};

export type QuestionResponse = {
  __typename?: 'QuestionResponse';
  id: Scalars['String'];
  question: Scalars['String'];
  response: Scalars['String'];
  updatedAt: Scalars['MigrateDateTime'];
};

export type QuestionTopic = Createable & Entity & Updateable & WithId & WithName & {
  __typename?: 'QuestionTopic';
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  name: Scalars['String'];
  updatedAt: Scalars['MigrateDateTime'];
};

/** Used to sort Questions */
export enum QuestionsOrderBy {
  CreatedatDesc = 'CREATEDAT_DESC'
}

export type QuestionsWhereInput = {
  and?: InputMaybe<Array<QuestionsWhereInput>>;
  answered?: InputMaybe<BooleanFilterInput>;
  author?: InputMaybe<MigrateIdFilterInput>;
  not?: InputMaybe<Array<QuestionsWhereInput>>;
  or?: InputMaybe<Array<QuestionsWhereInput>>;
  topic?: InputMaybe<MigrateIdFilterInput>;
};

/** A candidate's professional medical registration reference and the country it was awarded in, e.g. GMC or NMC in the UK */
export type RegistrationDetail = {
  __typename?: 'RegistrationDetail';
  country: Scalars['String'];
  number: Scalars['String'];
  verified?: Maybe<Scalars['Boolean']>;
};

export type RegistrationDetailInput = {
  country: Scalars['String'];
  number: Scalars['String'];
};

/** An in progress or complete professional registration for a particular country - includes number if complete. */
export type RegistrationDetailV2 = WithCountry & {
  __typename?: 'RegistrationDetailV2';
  country: Scalars['String'];
  countryInfo: CountryInfo;
  id: Scalars['String'];
  referenceNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['MigrateDateTime'];
};

export type RejectMatchApplicationInput = {
  candidateId: Scalars['MigrateID'];
  jobId: Scalars['MigrateID'];
  reason: Scalars['String'];
};

export type RejectedMatchResponse = Createable & Entity & MatchResponse & Updateable & WithId & {
  __typename?: 'RejectedMatchResponse';
  candidate: CandidateV2;
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  job: Job;
  reason: Scalars['String'];
  type: MatchResponseType;
  updatedAt: Scalars['MigrateDateTime'];
};

export type RelocationTimeframe = {
  __typename?: 'RelocationTimeframe';
  isStale: Scalars['Boolean'];
  maxDate: Scalars['MigrateDateTime'];
  selection: RelocationTimeframeSelection;
  updatedAt: Scalars['MigrateDateTime'];
};

/** An indication of when the candidate would like to relocate */
export enum RelocationTimeframeSelection {
  Asap = 'ASAP',
  SixToTwelveMonths = 'SIX_TO_TWELVE_MONTHS',
  ThreeToSixMonths = 'THREE_TO_SIX_MONTHS',
  TwelveMonthsPlus = 'TWELVE_MONTHS_PLUS'
}

export type RemoveApplicationQuestionResponseInput = {
  matchResponseId: Scalars['MigrateID'];
};

export type RemoveChannelMemberInput = {
  channelId: Scalars['MigrateID'];
  userId: Scalars['MigrateID'];
};

export type RemoveHiringStageInput = {
  hiringStageId: Scalars['MigrateID'];
};

export type RemoveJobFileInput = {
  fileId: Scalars['MigrateID'];
  jobId: Scalars['MigrateID'];
};

export type RemoveMatchResponseInput = {
  id: Scalars['MigrateID'];
};

export type ReplaceDocumentInput = {
  data: FileInput;
  id: Scalars['MigrateID'];
};

export type ReportDateInput = {
  at?: InputMaybe<Scalars['MigrateDateTime']>;
  interval?: InputMaybe<ReportDateIntervalInput>;
};

export type ReportDateIntervalInput = {
  daily?: InputMaybe<DailyIntervalInput>;
  hourly?: InputMaybe<HourlyIntervalInput>;
  monthly?: InputMaybe<MonthlyIntervalInput>;
  quarterly?: InputMaybe<QuarterlyIntervalInput>;
  weekly?: InputMaybe<WeeklyIntervalInput>;
  yearly?: InputMaybe<YearlyIntervalInput>;
};

export type ReportMessageInput = {
  id: Scalars['MigrateID'];
};

export type ReportPeriodAt = {
  __typename?: 'ReportPeriodAt';
  at: Scalars['MigrateDateTime'];
};

export type ReportPeriodInterval = {
  __typename?: 'ReportPeriodInterval';
  end: Scalars['MigrateDateTime'];
  start: Scalars['MigrateDateTime'];
};

export type ResolvedAnswersWhereInput = {
  and?: InputMaybe<Array<ResolvedAnswersWhereInput>>;
  author?: InputMaybe<MigrateIdFilterInput>;
  not?: InputMaybe<Array<ResolvedAnswersWhereInput>>;
  or?: InputMaybe<Array<ResolvedAnswersWhereInput>>;
};

export type ResolvedApplicationEventsWhereInput = {
  and?: InputMaybe<Array<ResolvedApplicationEventsWhereInput>>;
  not?: InputMaybe<Array<ResolvedApplicationEventsWhereInput>>;
  or?: InputMaybe<Array<ResolvedApplicationEventsWhereInput>>;
};

export type ResolvedMessagesWhereInput = {
  and?: InputMaybe<Array<ResolvedMessagesWhereInput>>;
  content?: InputMaybe<TermFilterInput>;
  not?: InputMaybe<Array<ResolvedMessagesWhereInput>>;
  or?: InputMaybe<Array<ResolvedMessagesWhereInput>>;
};

export type RespondToMatchInput = {
  jobId: Scalars['MigrateID'];
  type: MatchResponseType;
};

export type SaveJobInput = {
  id: Scalars['MigrateID'];
};

/** Requires hiringStageId as there may be more than one interview stage */
export type ScheduleInterviewInput = {
  applicationId: Scalars['MigrateID'];
  candidateFeedbackMessage?: InputMaybe<Scalars['String']>;
  /** Duration in minutes */
  duration: Scalars['Int'];
  hiringStageId: Scalars['MigrateID'];
  meetingLink?: InputMaybe<Scalars['String']>;
  /** The interview start date. It must be in the future. */
  startDatetime: Scalars['MigrateDateTime'];
  zoomMeetingId?: InputMaybe<Scalars['String']>;
  zoomPasscode?: InputMaybe<Scalars['String']>;
};

/** Reflects the stage of the candidate's job search */
export enum SearchStage {
  Asap = 'ASAP',
  InTheNextFewMonths = 'IN_THE_NEXT_FEW_MONTHS',
  InTheNextYear = 'IN_THE_NEXT_YEAR',
  JustCurious = 'JUST_CURIOUS'
}

export type SelectedJobsInput = {
  count?: InputMaybe<Scalars['Int']>;
};

export type SendTemplateMessageToAllHiringStageInput = {
  attachmentToken?: InputMaybe<Scalars['UploadToken']>;
  content?: InputMaybe<Scalars['String']>;
  hiringStageId: Scalars['MigrateID'];
};

export type SendTemplateMessageToAllHiringStagePayload = {
  __typename?: 'SendTemplateMessageToAllHiringStagePayload';
  channelIds: Array<Scalars['MigrateID']>;
  messageCount: Scalars['Int'];
};

export type SetPushTokenInput = {
  pushToken: Scalars['String'];
};

export type Staff = Createable & Entity & Updateable & User & WithId & WithPersonName & {
  __typename?: 'Staff';
  account?: Maybe<Account>;
  createdAt: Scalars['MigrateDateTime'];
  displayName: Scalars['String'];
  email: Scalars['String'];
  forenames: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['MigrateID'];
  isActive: Scalars['Boolean'];
  lastActiveAt?: Maybe<Scalars['MigrateDateTime']>;
  notificationsMutedUntil?: Maybe<Scalars['MigrateDateTime']>;
  phoneNumber?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  pushToken?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  updatedAt: Scalars['MigrateDateTime'];
};

/** For configuring client streams */
export enum StreamConfigType {
  Fauna = 'FAUNA'
}

export type StringFieldAggregate = FieldAggregate & {
  __typename?: 'StringFieldAggregate';
  counts: Array<StringFieldAggregateItem>;
  /** The total number of items aggregated. These may be different from the set count as undefined items are not included in the count. */
  totalCount: Scalars['Int'];
};

export type StringFieldAggregateItem = FieldAggregateItem & {
  __typename?: 'StringFieldAggregateItem';
  count: Scalars['Int'];
  value: Scalars['String'];
};

export type StringFilterInput = {
  in: Array<Scalars['String']>;
};

export type SystemApplicationEvent = ApplicationEvent & Createable & Entity & Updateable & WithId & {
  __typename?: 'SystemApplicationEvent';
  actionedBy: User;
  application: Application;
  createdAt: Scalars['MigrateDateTime'];
  hiringStage: HiringStage;
  id: Scalars['MigrateID'];
  type: ApplicationEventType;
  updatedAt: Scalars['MigrateDateTime'];
};

export type Tag = Createable & Entity & Updateable & WithId & WithName & {
  __typename?: 'Tag';
  createdAt: Scalars['MigrateDateTime'];
  id: Scalars['MigrateID'];
  name: Scalars['String'];
  updatedAt: Scalars['MigrateDateTime'];
};

export type TeamMember = Createable & Entity & Updateable & User & WithId & WithPersonName & {
  __typename?: 'TeamMember';
  account?: Maybe<Account>;
  createdAt: Scalars['MigrateDateTime'];
  displayName: Scalars['String'];
  email: Scalars['String'];
  forenames: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['MigrateID'];
  isActive: Scalars['Boolean'];
  lastActiveAt?: Maybe<Scalars['MigrateDateTime']>;
  notificationsMutedUntil?: Maybe<Scalars['MigrateDateTime']>;
  organisation: Organisation;
  phoneNumber?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  pushToken?: Maybe<Scalars['String']>;
  role: TeamMemberRoles;
  surname: Scalars['String'];
  updatedAt: Scalars['MigrateDateTime'];
};

export type TeamMemberInvite = Createable & Entity & Invite & Updateable & WithId & {
  __typename?: 'TeamMemberInvite';
  createdAt: Scalars['MigrateDateTime'];
  email: Scalars['String'];
  id: Scalars['MigrateID'];
  role: TeamMemberInviteRole;
  status: InviteStatus;
  updatedAt: Scalars['MigrateDateTime'];
};

export enum TeamMemberInviteRole {
  Admin = 'ADMIN',
  TeamMember = 'TEAM_MEMBER'
}

export type TeamMemberPage = Page & {
  __typename?: 'TeamMemberPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<TeamMember>;
  pageCount: Scalars['Int'];
};

export enum TeamMemberRoles {
  Admin = 'ADMIN',
  Owner = 'OWNER',
  TeamMember = 'TEAM_MEMBER'
}

export type TermFilterInput = {
  allofterms?: InputMaybe<Scalars['String']>;
  anyofterms?: InputMaybe<Scalars['String']>;
};

export type TextBlock = {
  __typename?: 'TextBlock';
  content: Scalars['String'];
};

export type TextBlockInput = {
  content: Scalars['String'];
};

export type ToggleAnswerVoteInput = {
  answerId: Scalars['MigrateID'];
  type: VoteType;
};

export type ToggleAnswerVotePayload = {
  __typename?: 'ToggleAnswerVotePayload';
  answerVote: AnswerVote;
  deleted?: Maybe<Scalars['Boolean']>;
};

export type ToggleApplicationCheckInput = {
  id: Scalars['MigrateID'];
};

/** An indication of how close the candidate is to holding UK registration */
export enum UkRegistrationStatus {
  InProcess = 'IN_PROCESS',
  NotStarted = 'NOT_STARTED',
  Registered = 'REGISTERED'
}

export type UndoRejectMatchApplicationInput = {
  candidateId: Scalars['MigrateID'];
  jobId: Scalars['MigrateID'];
};

export type UnmuteChannelInput = {
  channelId: Scalars['MigrateID'];
};

export type UnsaveJobInput = {
  id: Scalars['MigrateID'];
};

export type UpdateApplicationCommentInput = {
  comment: Scalars['String'];
  id: Scalars['MigrateID'];
};

export type UpdateCandidateInput = {
  country?: InputMaybe<Scalars['String']>;
  countryOfQualification?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  forenames?: InputMaybe<Scalars['String']>;
  /** Omit to update the currently logged in user */
  id?: InputMaybe<Scalars['MigrateID']>;
  jobPreferences?: InputMaybe<JobPreferencesInput>;
  newPassword?: InputMaybe<Scalars['String']>;
  oldPassword?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['MigrateID']>;
  registrationDetails?: InputMaybe<Array<RegistrationDetailInput>>;
  surname?: InputMaybe<Scalars['String']>;
  uploadPhotoToken?: InputMaybe<Scalars['UploadToken']>;
};

export type UpdateCandidateProfessionInput = {
  candidateId: Scalars['MigrateID'];
  professionId: Scalars['MigrateID'];
};

export type UpdateCareerBreakInput = {
  description?: InputMaybe<Array<TextBlockInput>>;
  endDate?: InputMaybe<Scalars['MigrateDateTime']>;
  /** The ID of the career break to be updated */
  id: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['MigrateDateTime']>;
};

export type UpdateCareerQuizResultInput = {
  careerQuizResult: CareerQuizResult;
};

export type UpdateChecksTemplateInput = {
  checks?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['MigrateID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCurrentCandidateInput = {
  country?: InputMaybe<Scalars['String']>;
  locationPreferenceIds?: InputMaybe<Array<Scalars['MigrateID']>>;
  professionId?: InputMaybe<Scalars['MigrateID']>;
  searchStage?: InputMaybe<SearchStage>;
  tagPreferenceIds?: InputMaybe<Array<Scalars['MigrateID']>>;
};

export type UpdateEducationExperienceInput = {
  description?: InputMaybe<Array<TextBlockInput>>;
  endDate?: InputMaybe<Scalars['MigrateDateTime']>;
  grade?: InputMaybe<Scalars['String']>;
  /** The ID of the education experience to be updated */
  id: Scalars['String'];
  institutionName?: InputMaybe<Scalars['String']>;
  qualification?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['MigrateDateTime']>;
};

export type UpdateHiringNotesInput = {
  applicationId: Scalars['MigrateID'];
  notes: Scalars['String'];
};

export type UpdateHiringStageInput = {
  checksTemplateId?: InputMaybe<Scalars['MigrateID']>;
  hiringStageId: Scalars['MigrateID'];
  name: Scalars['String'];
  requiresCandidateFeedbackFrom?: InputMaybe<Scalars['Boolean']>;
  requiresCandidateFeedbackTo?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateHiringStagePositionInput = {
  hiringStageId: Scalars['MigrateID'];
  newPosition: Scalars['Int'];
};

export type UpdateHiringTeamInput = {
  jobId: Scalars['MigrateID'];
  teamMemberId: Scalars['MigrateID'];
};

export type UpdateInterviewInput = {
  /** Duration in minutes */
  duration?: InputMaybe<Scalars['Int']>;
  id: Scalars['MigrateID'];
  meetingLink?: InputMaybe<Scalars['String']>;
  /** The interview start date. It must be in the future. */
  startDatetime?: InputMaybe<Scalars['MigrateDateTime']>;
  zoomMeetingId?: InputMaybe<Scalars['String']>;
  zoomPasscode?: InputMaybe<Scalars['String']>;
};

export type UpdateJobInput = {
  candidatesRequired?: InputMaybe<Scalars['Int']>;
  categoryId?: InputMaybe<Scalars['MigrateID']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Country>;
  description?: InputMaybe<Scalars['String']>;
  detailedDescription?: InputMaybe<Array<DescriptionBlockInput>>;
  excludeCountries?: InputMaybe<Array<Scalars['String']>>;
  highlights?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['MigrateID'];
  locationId?: InputMaybe<Scalars['MigrateID']>;
  mapLocation?: InputMaybe<MapLocationInput>;
  organisationAlias?: InputMaybe<Scalars['String']>;
  professionId?: InputMaybe<Scalars['MigrateID']>;
  requiresLanguagePass?: InputMaybe<Scalars['Boolean']>;
  salary?: InputMaybe<Array<Scalars['Int']>>;
  tagIds?: InputMaybe<Array<Scalars['MigrateID']>>;
  targetCountries?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateJobSearchStatusInput = {
  relocationTimeframe: RelocationTimeframeSelection;
  ukRegistrationStatus: UkRegistrationStatus;
};

export type UpdateLanguageResultInput = {
  awardingBody?: InputMaybe<LanguageResultAwardingBody>;
  date?: InputMaybe<Scalars['MigrateDateTime']>;
  /** The ID of the language result to be updated */
  id: Scalars['String'];
  listening?: InputMaybe<Scalars['String']>;
  reading?: InputMaybe<Scalars['String']>;
  speaking?: InputMaybe<Scalars['String']>;
  writing?: InputMaybe<Scalars['String']>;
};

/**
 *
 *     Input representing the language status of candidates, contains either
 *       - { awardingBody, results }, or
 *       - { testExemptionCountry }
 *     as the fields are mutually exclusive.
 *
 */
export type UpdateLanguageStatusInput = {
  /** Required with results */
  awardingBody?: InputMaybe<AwardingBody>;
  /** Required with awardingBody */
  results?: InputMaybe<LanguageResultsInput>;
  /** Incomptaible with results/awardingBody */
  testExemptionCountry?: InputMaybe<Scalars['String']>;
};

export type UpdateLocationInput = {
  description: Scalars['String'];
  id: Scalars['MigrateID'];
  name: Scalars['String'];
};

export type UpdateMessageInput = {
  content: Scalars['String'];
  id: Scalars['MigrateID'];
};

export type UpdateMessagePayload = {
  __typename?: 'UpdateMessagePayload';
  message: Message;
};

export type UpdateMessageTemplateInput = {
  id: Scalars['MigrateID'];
  name?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganisationInput = {
  /** The organisation ID. By default this corresponds to the user's organisation. */
  id?: InputMaybe<Scalars['MigrateID']>;
  name?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganisationPrivateChannelInput = {
  channelId: Scalars['MigrateID'];
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdatePublicationStatusInput = {
  id: Scalars['MigrateID'];
};

export type UpdateQuestionResponseInput = {
  /** The ID of the question response to be updated */
  id: Scalars['String'];
  question?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Scalars['String']>;
};

export type UpdateRegistrationDetailInput = {
  country?: InputMaybe<Scalars['String']>;
  /** The ID of the registration detail to be updated */
  id: Scalars['String'];
  referenceNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateTeamMemberInput = {
  displayName?: InputMaybe<Scalars['String']>;
  forenames?: InputMaybe<Scalars['String']>;
  /** Omit to update the currently logged in user */
  id?: InputMaybe<Scalars['MigrateID']>;
  newPassword?: InputMaybe<Scalars['String']>;
  oldPassword?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  role: TeamMemberRoles;
  surname?: InputMaybe<Scalars['String']>;
  uploadPhotoToken?: InputMaybe<Scalars['UploadToken']>;
};

export type UpdateUserInput = {
  displayName?: InputMaybe<Scalars['String']>;
  forenames?: InputMaybe<Scalars['String']>;
  /** Omit to update the currently logged in user */
  id?: InputMaybe<Scalars['MigrateID']>;
  newPassword?: InputMaybe<Scalars['String']>;
  oldPassword?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  uploadPhotoToken?: InputMaybe<Scalars['UploadToken']>;
};

export type UpdateWorkExperienceInput = {
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Array<TextBlockInput>>;
  endDate?: InputMaybe<Scalars['MigrateDateTime']>;
  /** The ID of the work experience to be updated */
  id: Scalars['String'];
  organisationName?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['MigrateDateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Updateable = {
  updatedAt: Scalars['MigrateDateTime'];
};

export type UploadApplicationFileInput = {
  applicationId: Scalars['MigrateID'];
  token: Scalars['UploadToken'];
};

export type UploadDocumentFromAttachmentInput = {
  attachmentId: Scalars['MigrateID'];
  type: DocumentType;
};

export type UploadDocumentInput = {
  token: Scalars['UploadToken'];
  type: DocumentType;
};

export type UploadJobFileInput = {
  isDescriptionAttachment?: InputMaybe<Scalars['Boolean']>;
  jobId: Scalars['MigrateID'];
  token: Scalars['UploadToken'];
};

export type UploadOrganisationLogoInput = {
  token: Scalars['UploadToken'];
};

export type UploadProfilePhotoInput = {
  token: Scalars['UploadToken'];
};

export type User = {
  account?: Maybe<Account>;
  createdAt: Scalars['MigrateDateTime'];
  displayName: Scalars['String'];
  email: Scalars['String'];
  forenames: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['MigrateID'];
  isActive: Scalars['Boolean'];
  lastActiveAt?: Maybe<Scalars['MigrateDateTime']>;
  notificationsMutedUntil?: Maybe<Scalars['MigrateDateTime']>;
  phoneNumber?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  pushToken?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  updatedAt: Scalars['MigrateDateTime'];
};

export type UserPage = Page & {
  __typename?: 'UserPage';
  after?: Maybe<Scalars['Cursor']>;
  before?: Maybe<Scalars['Cursor']>;
  count: Scalars['Int'];
  data: Array<User>;
  pageCount: Scalars['Int'];
};

/** Used to sort users */
export enum UsersOrderBy {
  DisplayNameAsc = 'DISPLAY_NAME_ASC',
  DisplayNameDesc = 'DISPLAY_NAME_DESC'
}

export type VerifyDocumentInput = {
  id: Scalars['MigrateID'];
};

export type VerifyRegistrationDetailInput = {
  candidateId: Scalars['MigrateID'];
  country: Scalars['String'];
};

/** Reflects type of the vote */
export enum VoteType {
  Downvote = 'DOWNVOTE',
  Upvote = 'UPVOTE'
}

export type WeeklyIntervalInput = {
  between: IntervalInput;
  /** 0-6 where 0 - Sunday and 6 - Saturday */
  weekStartsOn?: InputMaybe<Scalars['Int']>;
};

export type WithAnswer = {
  answer: Answer;
};

export type WithCountry = {
  country: Scalars['String'];
  countryInfo: CountryInfo;
};

export type WithId = {
  id: Scalars['MigrateID'];
};

export type WithInterview = {
  interview: Interview;
};

export type WithJob = {
  job: Job;
};

export type WithMatchResponse = {
  matchResponse: MatchResponse;
};

export type WithName = {
  name: Scalars['String'];
};

export type WithOptionalCountry = {
  country?: Maybe<Scalars['String']>;
  countryInfo?: Maybe<CountryInfo>;
};

export type WithOptionalCountryOfQualification = {
  countryOfQualification?: Maybe<Scalars['String']>;
  countryOfQualificationInfo?: Maybe<CountryInfo>;
};

export type WithPersonName = {
  forenames: Scalars['String'];
  fullName: Scalars['String'];
  surname: Scalars['String'];
};

export type WithVerified = {
  verified?: Maybe<Scalars['Boolean']>;
};

export type WorkExperience = {
  __typename?: 'WorkExperience';
  country?: Maybe<Scalars['String']>;
  description: Array<TextBlock>;
  endDate?: Maybe<Scalars['MigrateDateTime']>;
  id: Scalars['String'];
  organisationName: Scalars['String'];
  startDate: Scalars['MigrateDateTime'];
  title: Scalars['String'];
  type: CareerExperienceType;
  updatedAt: Scalars['MigrateDateTime'];
};

export type YearlyIntervalInput = {
  between: IntervalInput;
};

export type SetPushTokenMutationVariables = Exact<{
  input: SetPushTokenInput;
}>;


export type SetPushTokenMutation = { __typename?: 'Mutation', setPushToken: { __typename?: 'AccountManager', id: string, pushToken?: string | null } | { __typename?: 'Candidate', id: string, pushToken?: string | null } | { __typename?: 'CandidateV2', id: string, pushToken?: string | null } | { __typename?: 'Staff', id: string, pushToken?: string | null } | { __typename?: 'TeamMember', id: string, pushToken?: string | null } };

type UserInCache_AccountManager_Fragment = { __typename?: 'AccountManager', id: string };

type UserInCache_Candidate_Fragment = { __typename?: 'Candidate', id: string };

type UserInCache_CandidateV2_Fragment = { __typename?: 'CandidateV2', id: string };

type UserInCache_Staff_Fragment = { __typename?: 'Staff', id: string };

type UserInCache_TeamMember_Fragment = { __typename?: 'TeamMember', id: string };

export type UserInCacheFragment = UserInCache_AccountManager_Fragment | UserInCache_Candidate_Fragment | UserInCache_CandidateV2_Fragment | UserInCache_Staff_Fragment | UserInCache_TeamMember_Fragment;

export type CoreDocumentsFieldsFragment = { __typename?: 'Document', id: string, createdAt: any, url: string, filename: string, typeProps: { __typename?: 'DocumentTypeProps', type: DocumentType, name: string } };

export type UpdateCandidateCoreDocsCacheQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdateCandidateCoreDocsCacheQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', profileCompletion: Array<ProfileCompletion>, id: string, coreDocuments?: { __typename?: 'CoreDocuments', passport: Array<{ __typename?: 'Document', id: string, createdAt: any, url: string, filename: string, typeProps: { __typename?: 'DocumentTypeProps', type: DocumentType, name: string } }>, qualification: Array<{ __typename?: 'Document', id: string, createdAt: any, url: string, filename: string, typeProps: { __typename?: 'DocumentTypeProps', type: DocumentType, name: string } }>, languageCertificate: Array<{ __typename?: 'Document', id: string, createdAt: any, url: string, filename: string, typeProps: { __typename?: 'DocumentTypeProps', type: DocumentType, name: string } }> } | null } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type UpdateCacheAfterVerifyQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdateCacheAfterVerifyQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string, account?: { __typename?: 'Account', id: string, verified: boolean } | null } | { __typename?: 'Candidate', id: string, account?: { __typename?: 'Account', id: string, verified: boolean } | null } | { __typename?: 'CandidateV2', id: string, account?: { __typename?: 'Account', id: string, verified: boolean } | null } | { __typename?: 'Staff', id: string, account?: { __typename?: 'Account', id: string, verified: boolean } | null } | { __typename?: 'TeamMember', id: string, account?: { __typename?: 'Account', id: string, verified: boolean } | null } };

export type MarkChannelMutationVariables = Exact<{
  input: MarkChannelInput;
}>;


export type MarkChannelMutation = { __typename?: 'Mutation', markChannel: { __typename?: 'ApplicationDMChannel', id: string, unread: boolean } | { __typename?: 'CommunityPublicChannel', id: string, unread: boolean } | { __typename?: 'OrganisationPrivateChannel', id: string, unread: boolean } };

export type ChannelMessagesQueryVariables = Exact<{
  id: Scalars['MigrateID'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type ChannelMessagesQuery = { __typename?: 'Query', messages: { __typename?: 'MessagePage', after?: any | null, data: Array<{ __typename?: 'Message', id: string, content?: string | null, createdAt: any, isSent: boolean, sendError: boolean, deletedAt?: any | null, author?: { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | null, attachment?: { __typename?: 'Attachment', id: string, filename: string, url: string } | null, referencedMessage?: { __typename?: 'Message', id: string, content?: string | null, deletedAt?: any | null, attachment?: { __typename?: 'Attachment', id: string, filename: string, url: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } | null }> }, channel: { __typename?: 'ApplicationDMChannel', id: string, unread: boolean } | { __typename?: 'CommunityPublicChannel', name: string, isMember: boolean, id: string, unread: boolean } | { __typename?: 'OrganisationPrivateChannel', name: string, id: string, unread: boolean } };

export type NewMessagePayloadFragment = { __typename?: 'Message', isSent: boolean, id: string, createdAt: any, content?: string | null, deletedAt?: any | null, channel: { __typename?: 'ApplicationDMChannel', id: string, unread: boolean, type: ChannelType, application: { __typename?: 'Application', id: string, job: { __typename?: 'Job', id: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string } } }, lastMessage?: { __typename?: 'Message', id: string, content?: string | null, createdAt: any, author?: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', id: string } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } | null } | null } | { __typename?: 'CommunityPublicChannel', name: string, id: string, unread: boolean, type: ChannelType, lastMessage?: { __typename?: 'Message', id: string, content?: string | null, createdAt: any, author?: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', id: string } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } | null } | null } | { __typename?: 'OrganisationPrivateChannel', id: string, unread: boolean, type: ChannelType, lastMessage?: { __typename?: 'Message', id: string, content?: string | null, createdAt: any, author?: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', id: string } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } | null } | null }, attachment?: { __typename?: 'Attachment', id: string, filename: string, url: string } | null, author?: { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | null, referencedMessage?: { __typename?: 'Message', id: string, content?: string | null, createdAt: any, deletedAt?: any | null, author?: { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | null, attachment?: { __typename?: 'Attachment', id: string, filename: string, url: string } | null } | null };

export type GetMessageQueryVariables = Exact<{
  id: Scalars['MigrateID'];
}>;


export type GetMessageQuery = { __typename?: 'Query', message: { __typename?: 'Message', isSent: boolean, id: string, createdAt: any, content?: string | null, deletedAt?: any | null, channel: { __typename?: 'ApplicationDMChannel', id: string, unread: boolean, type: ChannelType, application: { __typename?: 'Application', id: string, job: { __typename?: 'Job', id: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string } } }, lastMessage?: { __typename?: 'Message', id: string, content?: string | null, createdAt: any, author?: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', id: string } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } | null } | null } | { __typename?: 'CommunityPublicChannel', name: string, id: string, unread: boolean, type: ChannelType, lastMessage?: { __typename?: 'Message', id: string, content?: string | null, createdAt: any, author?: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', id: string } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } | null } | null } | { __typename?: 'OrganisationPrivateChannel', id: string, unread: boolean, type: ChannelType, lastMessage?: { __typename?: 'Message', id: string, content?: string | null, createdAt: any, author?: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', id: string } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } | null } | null }, attachment?: { __typename?: 'Attachment', id: string, filename: string, url: string } | null, author?: { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | null, referencedMessage?: { __typename?: 'Message', id: string, content?: string | null, createdAt: any, deletedAt?: any | null, author?: { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | null, attachment?: { __typename?: 'Attachment', id: string, filename: string, url: string } | null } | null } };

export type NewMessageFragment = { __typename?: 'Message', id: string };

export type DeleteMessageMutationVariables = Exact<{
  input: DeleteMessageInput;
}>;


export type DeleteMessageMutation = { __typename?: 'Mutation', deleteMessage: { __typename?: 'DeleteMessagePayload', message: { __typename?: 'Message', id: string, deletedAt?: any | null } } };

export type CommunityActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunityActivityQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'Candidate', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null } | { __typename?: 'CandidateV2', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, profession?: { __typename?: 'Profession', id: string, name: string } | null } | { __typename?: 'Staff', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'TeamMember', id: string, forenames: string, photoUrl?: string | null, isActive: boolean }, communityActivity: { __typename?: 'CommunityActivity', questionCount: number, answerCount: number, upvoteCount: number } };

export type QuestionsAnsweredQueryVariables = Exact<{
  where?: InputMaybe<AnswersWhereInput>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type QuestionsAnsweredQuery = { __typename?: 'Query', answers: { __typename?: 'AnswerPage', after?: any | null, data: Array<{ __typename?: 'Answer', id: string, createdAt: any, content: string, upvotes: number, downvotes: number, myVoteType?: VoteType | null, question?: { __typename?: 'Question', id: string, title: string, createdAt: any, topics: Array<{ __typename?: 'QuestionTopic', id: string, name: string }>, author: { __typename?: 'AccountManager', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'Candidate', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null } | { __typename?: 'CandidateV2', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, profession?: { __typename?: 'Profession', id: string, name: string } | null } | { __typename?: 'Staff', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'TeamMember', id: string, forenames: string, photoUrl?: string | null, isActive: boolean }, answers: { __typename?: 'AnswerPage', count: number } } | null, author: { __typename?: 'AccountManager', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'Candidate', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null } | { __typename?: 'CandidateV2', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, profession?: { __typename?: 'Profession', id: string, name: string } | null } | { __typename?: 'Staff', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'TeamMember', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } }> } };

export type MuteChannelMutationVariables = Exact<{
  input: MuteChannelInput;
}>;


export type MuteChannelMutation = { __typename?: 'Mutation', muteChannel: { __typename?: 'ApplicationDMChannel', id: string, mutedUntil?: any | null } | { __typename?: 'CommunityPublicChannel', id: string, mutedUntil?: any | null } | { __typename?: 'OrganisationPrivateChannel', id: string, mutedUntil?: any | null } };

export type UnmuteChannelMutationVariables = Exact<{
  input: UnmuteChannelInput;
}>;


export type UnmuteChannelMutation = { __typename?: 'Mutation', unmuteChannel: { __typename?: 'ApplicationDMChannel', id: string, mutedUntil?: any | null } | { __typename?: 'CommunityPublicChannel', id: string, mutedUntil?: any | null } | { __typename?: 'OrganisationPrivateChannel', id: string, mutedUntil?: any | null } };

export type CommunityChannelHeaderQueryVariables = Exact<{
  channelId: Scalars['MigrateID'];
}>;


export type CommunityChannelHeaderQuery = { __typename?: 'Query', communityPublicChannel: { __typename?: 'CommunityPublicChannel', id: string, mutedUntil?: any | null, isMember: boolean, name: string, members: { __typename?: 'UserPage', count: number }, categories: Array<{ __typename?: 'ChannelCategory', id: string, name: string }> } };

export type InboxChannelHeaderQueryVariables = Exact<{
  channelId: Scalars['MigrateID'];
}>;


export type InboxChannelHeaderQuery = { __typename?: 'Query', channel: { __typename?: 'ApplicationDMChannel', id: string, application: { __typename?: 'Application', id: string, job: { __typename?: 'Job', id: string, title: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string } } } } | { __typename?: 'CommunityPublicChannel', id: string } | { __typename?: 'OrganisationPrivateChannel', id: string, organisation: { __typename?: 'Organisation', id: string, name: string }, members: { __typename?: 'UserPage', count: number } } };

export type LeaveCommunityChannelMutationVariables = Exact<{
  input: LeaveChannelInput;
}>;


export type LeaveCommunityChannelMutation = { __typename?: 'Mutation', leaveChannel: { __typename?: 'ChannelMember', channel: { __typename?: 'ApplicationDMChannel', id: string, type: ChannelType, isMember: boolean } | { __typename?: 'CommunityPublicChannel', name: string, id: string, type: ChannelType, isMember: boolean } | { __typename?: 'OrganisationPrivateChannel', id: string, type: ChannelType, isMember: boolean } } };

export type ChannelCategoryFilterPropsFragment = { __typename?: 'ChannelCategory', id: string, name: string };

export type ChannelCategoriesFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type ChannelCategoriesFilterQuery = { __typename?: 'Query', channelCategories: { __typename?: 'ChannelCategoryPage', data: Array<{ __typename?: 'ChannelCategory', id: string, name: string }> } };

type BaseChannelListCardProps_ApplicationDmChannel_Fragment = { __typename?: 'ApplicationDMChannel', id: string, createdAt: any, unread: boolean, type: ChannelType, lastMessage?: { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } | null };

type BaseChannelListCardProps_CommunityPublicChannel_Fragment = { __typename?: 'CommunityPublicChannel', id: string, createdAt: any, unread: boolean, type: ChannelType, lastMessage?: { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } | null };

type BaseChannelListCardProps_OrganisationPrivateChannel_Fragment = { __typename?: 'OrganisationPrivateChannel', id: string, createdAt: any, unread: boolean, type: ChannelType, lastMessage?: { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } | null };

export type BaseChannelListCardPropsFragment = BaseChannelListCardProps_ApplicationDmChannel_Fragment | BaseChannelListCardProps_CommunityPublicChannel_Fragment | BaseChannelListCardProps_OrganisationPrivateChannel_Fragment;

export type ApplicationDmChannelListCardPropsFragment = { __typename?: 'ApplicationDMChannel', id: string, createdAt: any, unread: boolean, type: ChannelType, application: { __typename?: 'Application', job: { __typename?: 'Job', id: string, title: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string } } }, lastMessage?: { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } | null };

export type OrganisationPrivateChannelListCardPropsFragment = { __typename?: 'OrganisationPrivateChannel', name: string, id: string, createdAt: any, unread: boolean, type: ChannelType, lastMessage?: { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } | null };

export type CommunityPublicChannelListCardPropsFragment = { __typename?: 'CommunityPublicChannel', name: string, id: string, createdAt: any, unread: boolean, type: ChannelType, members: { __typename?: 'UserPage', count: number, data: Array<{ __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null }> }, lastMessage?: { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } | null };

export type CommunityChannelCardHeaderChannelFragmentFragment = { __typename?: 'CommunityPublicChannel', id: string, name: string, isMember: boolean };

type CommunityChannelCardHeaderUserFragment_AccountManager_Fragment = { __typename?: 'AccountManager', id: string, photoUrl?: string | null };

type CommunityChannelCardHeaderUserFragment_Candidate_Fragment = { __typename?: 'Candidate', id: string, photoUrl?: string | null };

type CommunityChannelCardHeaderUserFragment_CandidateV2_Fragment = { __typename?: 'CandidateV2', id: string, photoUrl?: string | null };

type CommunityChannelCardHeaderUserFragment_Staff_Fragment = { __typename?: 'Staff', id: string, photoUrl?: string | null };

type CommunityChannelCardHeaderUserFragment_TeamMember_Fragment = { __typename?: 'TeamMember', id: string, photoUrl?: string | null };

export type CommunityChannelCardHeaderUserFragmentFragment = CommunityChannelCardHeaderUserFragment_AccountManager_Fragment | CommunityChannelCardHeaderUserFragment_Candidate_Fragment | CommunityChannelCardHeaderUserFragment_CandidateV2_Fragment | CommunityChannelCardHeaderUserFragment_Staff_Fragment | CommunityChannelCardHeaderUserFragment_TeamMember_Fragment;

export type CommunityChannelCardHeaderMembersFragmentFragment = { __typename?: 'UserPage', count: number, data: Array<{ __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null }> };

export type CommunityChannelCardHeaderQueryVariables = Exact<{
  channelId: Scalars['MigrateID'];
}>;


export type CommunityChannelCardHeaderQuery = { __typename?: 'Query', communityPublicChannel: { __typename?: 'CommunityPublicChannel', id: string, name: string, isMember: boolean, members: { __typename?: 'UserPage', count: number, data: Array<{ __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null }> }, messages: { __typename?: 'MessagePage', data: Array<{ __typename?: 'Message', id: string, author?: { __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null } | null }> } } };

export type JoinedCommunityChannelFragment = { __typename?: 'CommunityPublicChannel', description?: string | null, unread: boolean, id: string, name: string, isMember: boolean, members: { __typename?: 'UserPage', count: number, data: Array<{ __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null }> }, messages: { __typename?: 'MessagePage', data: Array<{ __typename?: 'Message', id: string, author?: { __typename?: 'AccountManager', id: string, photoUrl?: string | null, displayName: string } | { __typename?: 'Candidate', id: string, photoUrl?: string | null, displayName: string } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null, displayName: string } | { __typename?: 'Staff', id: string, photoUrl?: string | null, displayName: string } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null, displayName: string } | null }> }, lastMessage?: { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } | null };

export type JoinedCommunityChannelCardQueryVariables = Exact<{
  channelId: Scalars['MigrateID'];
}>;


export type JoinedCommunityChannelCardQuery = { __typename?: 'Query', communityPublicChannel: { __typename?: 'CommunityPublicChannel', description?: string | null, unread: boolean, id: string, name: string, isMember: boolean, members: { __typename?: 'UserPage', count: number, data: Array<{ __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null }> }, messages: { __typename?: 'MessagePage', data: Array<{ __typename?: 'Message', id: string, author?: { __typename?: 'AccountManager', id: string, photoUrl?: string | null, displayName: string } | { __typename?: 'Candidate', id: string, photoUrl?: string | null, displayName: string } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null, displayName: string } | { __typename?: 'Staff', id: string, photoUrl?: string | null, displayName: string } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null, displayName: string } | null }> }, lastMessage?: { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } | null } };

export type CommunityHomeChannelsQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<ChannelsOrderBy>;
  where?: InputMaybe<JoinedChannelsWhereInput>;
}>;


export type CommunityHomeChannelsQuery = { __typename?: 'Query', joinedChannels: { __typename?: 'ChannelPage', after?: any | null, data: Array<{ __typename?: 'ApplicationDMChannel', id: string } | { __typename?: 'CommunityPublicChannel', id: string, description?: string | null, unread: boolean, name: string, isMember: boolean, members: { __typename?: 'UserPage', count: number, data: Array<{ __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null }> }, messages: { __typename?: 'MessagePage', data: Array<{ __typename?: 'Message', id: string, author?: { __typename?: 'AccountManager', id: string, photoUrl?: string | null, displayName: string } | { __typename?: 'Candidate', id: string, photoUrl?: string | null, displayName: string } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null, displayName: string } | { __typename?: 'Staff', id: string, photoUrl?: string | null, displayName: string } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null, displayName: string } | null }> }, lastMessage?: { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } | null } | { __typename?: 'OrganisationPrivateChannel', id: string }> } };

export type MessagePreviewAttachmentFragmentFragment = { __typename?: 'Attachment', id: string };

type MessagePreviewAuthorFragment_AccountManager_Fragment = { __typename?: 'AccountManager', id: string, displayName: string };

type MessagePreviewAuthorFragment_Candidate_Fragment = { __typename?: 'Candidate', id: string, displayName: string };

type MessagePreviewAuthorFragment_CandidateV2_Fragment = { __typename?: 'CandidateV2', id: string, displayName: string };

type MessagePreviewAuthorFragment_Staff_Fragment = { __typename?: 'Staff', id: string, displayName: string };

type MessagePreviewAuthorFragment_TeamMember_Fragment = { __typename?: 'TeamMember', id: string, displayName: string };

export type MessagePreviewAuthorFragmentFragment = MessagePreviewAuthorFragment_AccountManager_Fragment | MessagePreviewAuthorFragment_Candidate_Fragment | MessagePreviewAuthorFragment_CandidateV2_Fragment | MessagePreviewAuthorFragment_Staff_Fragment | MessagePreviewAuthorFragment_TeamMember_Fragment;

export type MessagePreviewFragmentFragment = { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null };

export type MessagePreviewQueryVariables = Exact<{
  messageId: Scalars['MigrateID'];
}>;


export type MessagePreviewQuery = { __typename?: 'Query', message: { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } };

export type OverviewCommunityChannelCardChannelPropsFragment = { __typename?: 'CommunityPublicChannel', id: string, isMember: boolean, description?: string | null, name: string, members: { __typename?: 'UserPage', count: number, data: Array<{ __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null }> }, messages: { __typename?: 'MessagePage', data: Array<{ __typename?: 'Message', id: string, author?: { __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null } | null }> } };

export type OverviewCommunityChannelCardQueryVariables = Exact<{
  channelId: Scalars['MigrateID'];
}>;


export type OverviewCommunityChannelCardQuery = { __typename?: 'Query', communityPublicChannel: { __typename?: 'CommunityPublicChannel', id: string, isMember: boolean, description?: string | null, name: string, members: { __typename?: 'UserPage', count: number, data: Array<{ __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null }> }, messages: { __typename?: 'MessagePage', data: Array<{ __typename?: 'Message', id: string, author?: { __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null } | null }> } } };

export type AllCommunityChannelsQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<ChannelsOrderBy>;
  where?: InputMaybe<CommunityPublicChannelsWhereInput>;
}>;


export type AllCommunityChannelsQuery = { __typename?: 'Query', communityPublicChannels: { __typename?: 'CommunityPublicChannelPage', after?: any | null, data: Array<{ __typename?: 'CommunityPublicChannel', isMember: boolean, id: string, description?: string | null, name: string, members: { __typename?: 'UserPage', count: number, data: Array<{ __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null }> }, messages: { __typename?: 'MessagePage', data: Array<{ __typename?: 'Message', id: string, author?: { __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null } | null }> } }> }, channelCategories: { __typename?: 'ChannelCategoryPage', data: Array<{ __typename?: 'ChannelCategory', id: string, name: string }> } };

export type CommunityChannelFooterQueryVariables = Exact<{
  channelId: Scalars['MigrateID'];
}>;


export type CommunityChannelFooterQuery = { __typename?: 'Query', communityPublicChannel: { __typename?: 'CommunityPublicChannel', id: string, isMember: boolean } };

export type JoinedChannelsQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<ChannelsOrderBy>;
  where?: InputMaybe<JoinedChannelsWhereInput>;
}>;


export type JoinedChannelsQuery = { __typename?: 'Query', joinedChannels: { __typename?: 'ChannelPage', after?: any | null, data: Array<{ __typename?: 'ApplicationDMChannel', id: string, createdAt: any, unread: boolean, type: ChannelType, application: { __typename?: 'Application', job: { __typename?: 'Job', id: string, title: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string } } }, lastMessage?: { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } | null } | { __typename?: 'CommunityPublicChannel', id: string, name: string, createdAt: any, unread: boolean, type: ChannelType, members: { __typename?: 'UserPage', count: number, data: Array<{ __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null }> }, lastMessage?: { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } | null } | { __typename?: 'OrganisationPrivateChannel', id: string, name: string, createdAt: any, unread: boolean, type: ChannelType, lastMessage?: { __typename?: 'Message', id: string, createdAt: any, content?: string | null, attachment?: { __typename?: 'Attachment', id: string } | null, author?: { __typename?: 'AccountManager', id: string, displayName: string } | { __typename?: 'Candidate', id: string, displayName: string } | { __typename?: 'CandidateV2', id: string, displayName: string } | { __typename?: 'Staff', id: string, displayName: string } | { __typename?: 'TeamMember', id: string, displayName: string } | null } | null }> } };

export type JoinCommunityChannelMutationVariables = Exact<{
  input: JoinChannelInput;
}>;


export type JoinCommunityChannelMutation = { __typename?: 'Mutation', joinChannel: { __typename?: 'ChannelMember', channel: { __typename?: 'ApplicationDMChannel', id: string, isMember: boolean } | { __typename?: 'CommunityPublicChannel', id: string, isMember: boolean } | { __typename?: 'OrganisationPrivateChannel', id: string, isMember: boolean } } };

export type MuteAllChannelsMutationVariables = Exact<{
  input: MuteAllChannelsInput;
}>;


export type MuteAllChannelsMutation = { __typename?: 'Mutation', muteAllChannels: { __typename?: 'AccountManager', id: string, notificationsMutedUntil?: any | null } | { __typename?: 'Candidate', id: string, notificationsMutedUntil?: any | null } | { __typename?: 'CandidateV2', id: string, notificationsMutedUntil?: any | null } | { __typename?: 'Staff', id: string, notificationsMutedUntil?: any | null } | { __typename?: 'TeamMember', id: string, notificationsMutedUntil?: any | null } };

export type UnmuteAllChannelsMutationVariables = Exact<{ [key: string]: never; }>;


export type UnmuteAllChannelsMutation = { __typename?: 'Mutation', unmuteAllChannels: { __typename?: 'AccountManager', id: string, notificationsMutedUntil?: any | null } | { __typename?: 'Candidate', id: string, notificationsMutedUntil?: any | null } | { __typename?: 'CandidateV2', id: string, notificationsMutedUntil?: any | null } | { __typename?: 'Staff', id: string, notificationsMutedUntil?: any | null } | { __typename?: 'TeamMember', id: string, notificationsMutedUntil?: any | null } };

export type ReadQuestionTitleFragment = { __typename?: 'Question', title: string };

export type AnswerQuestionMutationVariables = Exact<{
  input: AnswerQuestionInput;
}>;


export type AnswerQuestionMutation = { __typename?: 'Mutation', answerQuestion: { __typename?: 'Answer', id: string, createdAt: any, content: string, upvotes: number, downvotes: number, myVoteType?: VoteType | null, question?: { __typename?: 'Question', id: string, myAnswer?: { __typename?: 'Answer', id: string } | null } | null, author: { __typename?: 'AccountManager', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'Candidate', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null } | { __typename?: 'CandidateV2', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, profession?: { __typename?: 'Profession', id: string, name: string } | null } | { __typename?: 'Staff', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'TeamMember', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } } };

export type AnswerFragmentFragment = { __typename?: 'Answer', id: string, createdAt: any, content: string, upvotes: number, downvotes: number, myVoteType?: VoteType | null, author: { __typename?: 'AccountManager', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'Candidate', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null } | { __typename?: 'CandidateV2', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, profession?: { __typename?: 'Profession', id: string, name: string } | null } | { __typename?: 'Staff', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'TeamMember', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } };

export type AnswerQueryVariables = Exact<{
  answerId: Scalars['MigrateID'];
}>;


export type AnswerQuery = { __typename?: 'Query', answer: { __typename?: 'Answer', id: string, createdAt: any, content: string, upvotes: number, downvotes: number, myVoteType?: VoteType | null, author: { __typename?: 'AccountManager', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'Candidate', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null } | { __typename?: 'CandidateV2', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, profession?: { __typename?: 'Profession', id: string, name: string } | null } | { __typename?: 'Staff', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'TeamMember', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } } };

export type QuestionTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type QuestionTopicsQuery = { __typename?: 'Query', questionTopics: Array<{ __typename?: 'QuestionTopic', id: string, name: string }> };

export type AskQuestionMutationVariables = Exact<{
  input: AskQuestionInput;
}>;


export type AskQuestionMutation = { __typename?: 'Mutation', askQuestion: { __typename?: 'Question', id: string, title: string } };

export type DeleteQuestionMutationVariables = Exact<{
  input: DeleteQuestionInput;
}>;


export type DeleteQuestionMutation = { __typename?: 'Mutation', deleteQuestion: { __typename?: 'Question', id: string } };

export type DeleteAnswerMutationVariables = Exact<{
  input: DeleteAnswerInput;
}>;


export type DeleteAnswerMutation = { __typename?: 'Mutation', deleteAnswer: { __typename?: 'Answer', id: string } };

export type ToggleAnswerVoteMutationVariables = Exact<{
  input: ToggleAnswerVoteInput;
}>;


export type ToggleAnswerVoteMutation = { __typename?: 'Mutation', toggleAnswerVote: { __typename?: 'ToggleAnswerVotePayload', deleted?: boolean | null, answerVote: { __typename?: 'AnswerVote', id: string } } };

export type QuestionQueryVariables = Exact<{
  id: Scalars['MigrateID'];
  answersOrderBy?: InputMaybe<AnswersOrderBy>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type QuestionQuery = { __typename?: 'Query', question: { __typename?: 'Question', id: string, title: string, createdAt: any, topics: Array<{ __typename?: 'QuestionTopic', id: string, name: string }>, author: { __typename?: 'AccountManager', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'Candidate', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'CandidateV2', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'Staff', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'TeamMember', id: string, forenames: string, photoUrl?: string | null, isActive: boolean }, myAnswer?: { __typename?: 'Answer', id: string } | null, answers: { __typename?: 'AnswerPage', count: number, after?: any | null, data: Array<{ __typename?: 'Answer', id: string, createdAt: any, content: string, upvotes: number, downvotes: number, myVoteType?: VoteType | null, author: { __typename?: 'AccountManager', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'Candidate', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null } | { __typename?: 'CandidateV2', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, profession?: { __typename?: 'Profession', id: string, name: string } | null } | { __typename?: 'Staff', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'TeamMember', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } }> } } };

export type QuestionTopicFragment = { __typename?: 'QuestionTopic', id: string, name: string };

export type QuestionsQueryVariables = Exact<{
  where?: InputMaybe<QuestionsWhereInput>;
  orderBy?: InputMaybe<QuestionsOrderBy>;
  size?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type QuestionsQuery = { __typename?: 'Query', questions: { __typename?: 'QuestionPage', after?: any | null, data: Array<{ __typename?: 'Question', id: string, title: string, createdAt: any, topics: Array<{ __typename?: 'QuestionTopic', id: string, name: string }>, highlightedAnswer?: { __typename?: 'Answer', id: string, createdAt: any, content: string, upvotes: number, downvotes: number, myVoteType?: VoteType | null, author: { __typename?: 'AccountManager', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'Candidate', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null } | { __typename?: 'CandidateV2', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, profession?: { __typename?: 'Profession', id: string, name: string } | null } | { __typename?: 'Staff', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'TeamMember', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } } | null, answers: { __typename?: 'AnswerPage', count: number }, author: { __typename?: 'AccountManager', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'Candidate', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'CandidateV2', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'Staff', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'TeamMember', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } }> } };

type UserHeaderFragment_AccountManager_Fragment = { __typename?: 'AccountManager', id: string, forenames: string, photoUrl?: string | null, isActive: boolean };

type UserHeaderFragment_Candidate_Fragment = { __typename?: 'Candidate', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null };

type UserHeaderFragment_CandidateV2_Fragment = { __typename?: 'CandidateV2', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, profession?: { __typename?: 'Profession', id: string, name: string } | null };

type UserHeaderFragment_Staff_Fragment = { __typename?: 'Staff', id: string, forenames: string, photoUrl?: string | null, isActive: boolean };

type UserHeaderFragment_TeamMember_Fragment = { __typename?: 'TeamMember', id: string, forenames: string, photoUrl?: string | null, isActive: boolean };

export type UserHeaderFragmentFragment = UserHeaderFragment_AccountManager_Fragment | UserHeaderFragment_Candidate_Fragment | UserHeaderFragment_CandidateV2_Fragment | UserHeaderFragment_Staff_Fragment | UserHeaderFragment_TeamMember_Fragment;

export type UserHeaderQueryVariables = Exact<{
  userId: Scalars['MigrateID'];
}>;


export type UserHeaderQuery = { __typename?: 'Query', user: { __typename?: 'AccountManager', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'Candidate', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null } | { __typename?: 'CandidateV2', id: string, forenames: string, photoUrl?: string | null, isActive: boolean, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, profession?: { __typename?: 'Profession', id: string, name: string } | null } | { __typename?: 'Staff', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } | { __typename?: 'TeamMember', id: string, forenames: string, photoUrl?: string | null, isActive: boolean } };

export type UpdateCareerQuizResultMutationVariables = Exact<{
  input: UpdateCareerQuizResultInput;
}>;


export type UpdateCareerQuizResultMutation = { __typename?: 'Mutation', updateCareerQuizResult: { __typename?: 'CandidateV2', id: string, careerQuizResult?: CareerQuizResult | null } };

export type MyDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDocumentsQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', id: string, documents: { __typename?: 'DocumentPage', after?: any | null, count: number, data: Array<{ __typename?: 'Document', id: string, createdAt: any, url: string, filename: string, type: DocumentType, canDelete: boolean, typeProps: { __typename?: 'DocumentTypeProps', name: string } }> } } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type DocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentTypesQuery = { __typename?: 'Query', documentTypes: Array<{ __typename?: 'DocumentTypeProps', type: DocumentType, name: string }> };

export type HomeScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeScreenQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', hasSetPreferences: boolean, careerQuizResult?: CareerQuizResult | null, id: string, profession?: { __typename?: 'Profession', id: string } | null } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type ApplyToJobMatchMutationVariables = Exact<{
  jobId: Scalars['MigrateID'];
}>;


export type ApplyToJobMatchMutation = { __typename?: 'Mutation', respondToMatch: { __typename?: 'ApplicationApprovedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'ApplicationStartMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'ApplyMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'GenericMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'RejectedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } };

export type ApplicationStartActionButtonQueryVariables = Exact<{ [key: string]: never; }>;


export type ApplicationStartActionButtonQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', canApply: boolean, id: string } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type HideJobMatchMutationVariables = Exact<{
  jobId: Scalars['MigrateID'];
}>;


export type HideJobMatchMutation = { __typename?: 'Mutation', respondToMatch: { __typename?: 'ApplicationApprovedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'ApplicationStartMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'ApplyMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'GenericMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'RejectedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } };

export type SaveJobMatchMutationVariables = Exact<{
  jobId: Scalars['MigrateID'];
}>;


export type SaveJobMatchMutation = { __typename?: 'Mutation', respondToMatch: { __typename?: 'ApplicationApprovedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'ApplicationStartMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'ApplyMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'GenericMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'RejectedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } };

export type UnhideJobMatchMutationVariables = Exact<{
  id: Scalars['MigrateID'];
}>;


export type UnhideJobMatchMutation = { __typename?: 'Mutation', removeMatchResponse: { __typename?: 'ApplicationApprovedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'ApplicationStartMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'ApplyMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'GenericMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'RejectedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } };

export type UnsaveJobMatchMutationVariables = Exact<{
  id: Scalars['MigrateID'];
}>;


export type UnsaveJobMatchMutation = { __typename?: 'Mutation', removeMatchResponse: { __typename?: 'ApplicationApprovedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'ApplicationStartMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'ApplyMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'GenericMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'RejectedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } };

export type JobDetailsJobPropsFragment = { __typename?: 'Job', id: string, title: string, description?: string | null, organisationName: string, salary?: Array<number> | null, requiresLanguagePass: boolean, city?: string | null, highlights?: Array<string> | null, status: PublicationStatus, createdAt: any, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, updatedAt: any, type: MatchResponseType, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string } | { __typename?: 'ApplicationStartMatchResponse', id: string } | { __typename?: 'ApplyMatchResponse', id: string } | { __typename?: 'GenericMatchResponse', id: string } | { __typename?: 'RejectedMatchResponse', id: string } | null } } | { __typename?: 'ApplicationStartMatchResponse', id: string, updatedAt: any, type: MatchResponseType, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string } | { __typename?: 'ApplicationStartMatchResponse', id: string } | { __typename?: 'ApplyMatchResponse', id: string } | { __typename?: 'GenericMatchResponse', id: string } | { __typename?: 'RejectedMatchResponse', id: string } | null } } | { __typename?: 'ApplyMatchResponse', id: string, updatedAt: any, type: MatchResponseType, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string } | { __typename?: 'ApplicationStartMatchResponse', id: string } | { __typename?: 'ApplyMatchResponse', id: string } | { __typename?: 'GenericMatchResponse', id: string } | { __typename?: 'RejectedMatchResponse', id: string } | null } } | { __typename?: 'GenericMatchResponse', id: string, updatedAt: any, type: MatchResponseType, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string } | { __typename?: 'ApplicationStartMatchResponse', id: string } | { __typename?: 'ApplyMatchResponse', id: string } | { __typename?: 'GenericMatchResponse', id: string } | { __typename?: 'RejectedMatchResponse', id: string } | null } } | { __typename?: 'RejectedMatchResponse', reason: string, id: string, updatedAt: any, type: MatchResponseType, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string } | { __typename?: 'ApplicationStartMatchResponse', id: string } | { __typename?: 'ApplyMatchResponse', id: string } | { __typename?: 'GenericMatchResponse', id: string } | { __typename?: 'RejectedMatchResponse', id: string } | null } } | null, detailedDescription?: Array<{ __typename?: 'TextBlock', content: string }> | null, organisation: { __typename?: 'Organisation', id: string, name: string, photoUrl?: string | null, url: string }, location?: { __typename?: 'Location', id: string, name: string, description: string } | null, mapLocation?: { __typename?: 'MapLocation', name: string, location: { __typename?: 'Coordinates', lat: number, lon: number } } | null, files?: Array<{ __typename?: 'JobFile', id: any, filename: string, url: string }> | null };

export type JobDetailsQueryVariables = Exact<{
  id: Scalars['MigrateID'];
}>;


export type JobDetailsQuery = { __typename?: 'Query', job: { __typename?: 'Job', id: string, title: string, description?: string | null, organisationName: string, salary?: Array<number> | null, requiresLanguagePass: boolean, city?: string | null, highlights?: Array<string> | null, status: PublicationStatus, createdAt: any, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, updatedAt: any, type: MatchResponseType, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string } | { __typename?: 'ApplicationStartMatchResponse', id: string } | { __typename?: 'ApplyMatchResponse', id: string } | { __typename?: 'GenericMatchResponse', id: string } | { __typename?: 'RejectedMatchResponse', id: string } | null } } | { __typename?: 'ApplicationStartMatchResponse', id: string, updatedAt: any, type: MatchResponseType, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string } | { __typename?: 'ApplicationStartMatchResponse', id: string } | { __typename?: 'ApplyMatchResponse', id: string } | { __typename?: 'GenericMatchResponse', id: string } | { __typename?: 'RejectedMatchResponse', id: string } | null } } | { __typename?: 'ApplyMatchResponse', id: string, updatedAt: any, type: MatchResponseType, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string } | { __typename?: 'ApplicationStartMatchResponse', id: string } | { __typename?: 'ApplyMatchResponse', id: string } | { __typename?: 'GenericMatchResponse', id: string } | { __typename?: 'RejectedMatchResponse', id: string } | null } } | { __typename?: 'GenericMatchResponse', id: string, updatedAt: any, type: MatchResponseType, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string } | { __typename?: 'ApplicationStartMatchResponse', id: string } | { __typename?: 'ApplyMatchResponse', id: string } | { __typename?: 'GenericMatchResponse', id: string } | { __typename?: 'RejectedMatchResponse', id: string } | null } } | { __typename?: 'RejectedMatchResponse', reason: string, id: string, updatedAt: any, type: MatchResponseType, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string } | { __typename?: 'ApplicationStartMatchResponse', id: string } | { __typename?: 'ApplyMatchResponse', id: string } | { __typename?: 'GenericMatchResponse', id: string } | { __typename?: 'RejectedMatchResponse', id: string } | null } } | null, detailedDescription?: Array<{ __typename?: 'TextBlock', content: string }> | null, organisation: { __typename?: 'Organisation', id: string, name: string, photoUrl?: string | null, url: string }, location?: { __typename?: 'Location', id: string, name: string, description: string } | null, mapLocation?: { __typename?: 'MapLocation', name: string, location: { __typename?: 'Coordinates', lat: number, lon: number } } | null, files?: Array<{ __typename?: 'JobFile', id: any, filename: string, url: string }> | null } };

export type JobDetailsScreenQueryVariables = Exact<{
  jobId: Scalars['MigrateID'];
}>;


export type JobDetailsScreenQuery = { __typename?: 'Query', job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'ApplicationStartMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'ApplyMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'GenericMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | { __typename?: 'RejectedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } } | null } };

export type JobMatchesOverviewJobPagePropsFragment = { __typename?: 'JobPage', count: number };

export type JobMatchesOverviewQueryVariables = Exact<{
  input?: InputMaybe<MyMatchedJobsInput>;
}>;


export type JobMatchesOverviewQuery = { __typename?: 'Query', myMatchedJobs: { __typename?: 'JobPage', count: number } };

export type ApplicationProgressQueryVariables = Exact<{
  jobId: Scalars['MigrateID'];
}>;


export type ApplicationProgressQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', profileCompletion: Array<ProfileCompletion>, canApply: boolean, id: string } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string }, matchResponseByJob: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, job: { __typename?: 'Job', id: string, title: string, requiresLanguagePass: boolean } } | { __typename?: 'ApplicationStartMatchResponse', applicationCompletion: Array<ApplicationCompletion>, id: string, type: MatchResponseType, job: { __typename?: 'Job', id: string, title: string, requiresLanguagePass: boolean } } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, job: { __typename?: 'Job', id: string, title: string, requiresLanguagePass: boolean } } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, job: { __typename?: 'Job', id: string, title: string, requiresLanguagePass: boolean } } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, job: { __typename?: 'Job', id: string, title: string, requiresLanguagePass: boolean } } };

export type SubmitApplicationMutationVariables = Exact<{
  input: GenericMatchResponseInput;
}>;


export type SubmitApplicationMutation = { __typename?: 'Mutation', submitMatchApplication: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType } };

export type ApplicationQuestionSectionQueryVariables = Exact<{
  matchResponseId: Scalars['MigrateID'];
}>;


export type ApplicationQuestionSectionQuery = { __typename?: 'Query', matchResponse: { __typename?: 'ApplicationApprovedMatchResponse', id: string, job: { __typename?: 'Job', id: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string } } } | { __typename?: 'ApplicationStartMatchResponse', applicationCompletion: Array<ApplicationCompletion>, id: string, applicationQuestion: { __typename?: 'ApplicationQuestion', question: string, response?: string | null }, job: { __typename?: 'Job', id: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string } } } | { __typename?: 'ApplyMatchResponse', applicationCompletion: Array<ApplicationCompletion>, id: string, applicationQuestion: { __typename?: 'ApplicationQuestion', question: string, response?: string | null }, job: { __typename?: 'Job', id: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string } } } | { __typename?: 'GenericMatchResponse', id: string, job: { __typename?: 'Job', id: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string } } } | { __typename?: 'RejectedMatchResponse', id: string, job: { __typename?: 'Job', id: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string } } } };

export type AnswerApplicationQuestionMutationVariables = Exact<{
  input: AnswerApplicationQuestionInput;
}>;


export type AnswerApplicationQuestionMutation = { __typename?: 'Mutation', answerApplicationQuestion: { __typename?: 'ApplicationStartMatchResponse', applicationCompletion: Array<ApplicationCompletion>, id: string, applicationQuestion: { __typename?: 'ApplicationQuestion', response?: string | null } } };

export type RemoveApplicationQuestionResponseMutationVariables = Exact<{
  input: RemoveApplicationQuestionResponseInput;
}>;


export type RemoveApplicationQuestionResponseMutation = { __typename?: 'Mutation', removeApplicationQuestionResponse: { __typename?: 'ApplicationStartMatchResponse', applicationCompletion: Array<ApplicationCompletion>, id: string, applicationQuestion: { __typename?: 'ApplicationQuestion', response?: string | null } } };

export type ApplyFormQueryVariables = Exact<{
  jobId: Scalars['MigrateID'];
}>;


export type ApplyFormQuery = { __typename?: 'Query', matchResponseByJob: { __typename?: 'ApplicationApprovedMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string } } | { __typename?: 'ApplicationStartMatchResponse', applicationCompletion: Array<ApplicationCompletion>, id: string, applicationQuestion: { __typename?: 'ApplicationQuestion', question: string, response?: string | null }, job: { __typename?: 'Job', id: string, title: string } } | { __typename?: 'ApplyMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string } } | { __typename?: 'GenericMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string } } | { __typename?: 'RejectedMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string } } };

export type MatchedJobsQueryVariables = Exact<{
  input?: InputMaybe<MyMatchedJobsInput>;
}>;


export type MatchedJobsQuery = { __typename?: 'Query', myMatchedJobs: { __typename?: 'JobPage', count: number, data: Array<{ __typename?: 'Job', id: string, title: string, description?: string | null, organisationName: string, salary?: Array<number> | null, requiresLanguagePass: boolean, city?: string | null, highlights?: Array<string> | null, status: PublicationStatus, createdAt: any, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, updatedAt: any, type: MatchResponseType, createdAt: any, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null }, candidate: { __typename?: 'CandidateV2', id: string } } | { __typename?: 'ApplicationStartMatchResponse', id: string, updatedAt: any, type: MatchResponseType, createdAt: any, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null }, candidate: { __typename?: 'CandidateV2', id: string } } | { __typename?: 'ApplyMatchResponse', id: string, updatedAt: any, type: MatchResponseType, createdAt: any, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null }, candidate: { __typename?: 'CandidateV2', id: string } } | { __typename?: 'GenericMatchResponse', id: string, updatedAt: any, type: MatchResponseType, createdAt: any, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null }, candidate: { __typename?: 'CandidateV2', id: string } } | { __typename?: 'RejectedMatchResponse', reason: string, id: string, updatedAt: any, type: MatchResponseType, createdAt: any, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null }, candidate: { __typename?: 'CandidateV2', id: string } } | null, detailedDescription?: Array<{ __typename?: 'TextBlock', content: string }> | null, organisation: { __typename?: 'Organisation', id: string, name: string, photoUrl?: string | null, url: string }, location?: { __typename?: 'Location', id: string, name: string, description: string } | null, mapLocation?: { __typename?: 'MapLocation', name: string, location: { __typename?: 'Coordinates', lat: number, lon: number } } | null, files?: Array<{ __typename?: 'JobFile', id: any, filename: string, url: string }> | null }> } };

export type JobCardPropsFragment = { __typename?: 'Job', id: string, title: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string, photoUrl?: string | null }, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string } } } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType } | null };

export type JobCardQueryVariables = Exact<{
  jobId: Scalars['MigrateID'];
}>;


export type JobCardQuery = { __typename?: 'Query', job: { __typename?: 'Job', id: string, title: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string, photoUrl?: string | null }, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string } } } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType } | null } };

export type MyJobsQueryVariables = Exact<{
  types: Array<MatchResponseType> | MatchResponseType;
  after?: InputMaybe<Scalars['String']>;
}>;


export type MyJobsQuery = { __typename?: 'Query', myMatchResponses: { __typename?: 'MatchResponsePage', count: number, after?: any | null, data: Array<{ __typename?: 'ApplicationApprovedMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string, photoUrl?: string | null }, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string } } } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType } | null } } | { __typename?: 'ApplicationStartMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string, photoUrl?: string | null }, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string } } } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType } | null } } | { __typename?: 'ApplyMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string, photoUrl?: string | null }, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string } } } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType } | null } } | { __typename?: 'GenericMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string, photoUrl?: string | null }, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string } } } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType } | null } } | { __typename?: 'RejectedMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisationName: string, organisation: { __typename?: 'Organisation', id: string, name: string, photoUrl?: string | null }, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string } } } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType } | null } }> }, me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', applicationsRemaining: number, id: string } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type NumUnreadMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type NumUnreadMessagesQuery = { __typename?: 'Query', numUnreadMessages: number };

type NotificationFields_CandidateApplicationRejectedNotification_Fragment = { __typename?: 'CandidateApplicationRejectedNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, matchResponse: { __typename?: 'ApplicationApprovedMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'ApplicationStartMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'ApplyMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'GenericMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'RejectedMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } };

type NotificationFields_CandidateCanReapplyNotification_Fragment = { __typename?: 'CandidateCanReapplyNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } };

type NotificationFields_CandidateCompleteApplicationReminderNotification_Fragment = { __typename?: 'CandidateCompleteApplicationReminderNotification', id: string, createdAt: any, unread: boolean, type: NotificationType };

type NotificationFields_CandidateCompleteProfileReminderNotification_Fragment = { __typename?: 'CandidateCompleteProfileReminderNotification', id: string, createdAt: any, unread: boolean, type: NotificationType };

type NotificationFields_CandidateInterviewInviteNotification_Fragment = { __typename?: 'CandidateInterviewInviteNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, interview: { __typename?: 'Interview', id: string, startDatetime: any, endDatetime: any, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string }, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } } };

type NotificationFields_CandidateInterviewUpdatedNotification_Fragment = { __typename?: 'CandidateInterviewUpdatedNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, interview: { __typename?: 'Interview', id: string, startDatetime: any, endDatetime: any, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string }, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } } };

type NotificationFields_CandidateQuestionAnsweredNotification_Fragment = { __typename?: 'CandidateQuestionAnsweredNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, answer: { __typename?: 'Answer', id: string, content: string, author: { __typename?: 'AccountManager', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, displayName: string, photoUrl?: string | null }, question?: { __typename?: 'Question', id: string, title: string } | null } };

type NotificationFields_NewCandidateNotification_Fragment = { __typename?: 'NewCandidateNotification', id: string, createdAt: any, unread: boolean, type: NotificationType };

type NotificationFields_NewMentionNotification_Fragment = { __typename?: 'NewMentionNotification', id: string, createdAt: any, unread: boolean, type: NotificationType };

type NotificationFields_NewMessageNotification_Fragment = { __typename?: 'NewMessageNotification', id: string, createdAt: any, unread: boolean, type: NotificationType };

export type NotificationFieldsFragment = NotificationFields_CandidateApplicationRejectedNotification_Fragment | NotificationFields_CandidateCanReapplyNotification_Fragment | NotificationFields_CandidateCompleteApplicationReminderNotification_Fragment | NotificationFields_CandidateCompleteProfileReminderNotification_Fragment | NotificationFields_CandidateInterviewInviteNotification_Fragment | NotificationFields_CandidateInterviewUpdatedNotification_Fragment | NotificationFields_CandidateQuestionAnsweredNotification_Fragment | NotificationFields_NewCandidateNotification_Fragment | NotificationFields_NewMentionNotification_Fragment | NotificationFields_NewMessageNotification_Fragment;

export type NotificationsQueryVariables = Exact<{
  where?: InputMaybe<NotificationsWhereInput>;
  size?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationPage', count: number, after?: any | null, data: Array<{ __typename?: 'CandidateApplicationRejectedNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, matchResponse: { __typename?: 'ApplicationApprovedMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'ApplicationStartMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'ApplyMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'GenericMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'RejectedMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } } | { __typename?: 'CandidateCanReapplyNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'CandidateCompleteApplicationReminderNotification', id: string, createdAt: any, unread: boolean, type: NotificationType } | { __typename?: 'CandidateCompleteProfileReminderNotification', id: string, createdAt: any, unread: boolean, type: NotificationType } | { __typename?: 'CandidateInterviewInviteNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, interview: { __typename?: 'Interview', id: string, startDatetime: any, endDatetime: any, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string }, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } } } | { __typename?: 'CandidateInterviewUpdatedNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, interview: { __typename?: 'Interview', id: string, startDatetime: any, endDatetime: any, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string }, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } } } | { __typename?: 'CandidateQuestionAnsweredNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, answer: { __typename?: 'Answer', id: string, content: string, author: { __typename?: 'AccountManager', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, displayName: string, photoUrl?: string | null }, question?: { __typename?: 'Question', id: string, title: string } | null } } | { __typename?: 'NewCandidateNotification', id: string, createdAt: any, unread: boolean, type: NotificationType } | { __typename?: 'NewMentionNotification', id: string, createdAt: any, unread: boolean, type: NotificationType } | { __typename?: 'NewMessageNotification', id: string, createdAt: any, unread: boolean, type: NotificationType } | null> } };

export type GetNotificationQueryVariables = Exact<{
  id: Scalars['MigrateID'];
}>;


export type GetNotificationQuery = { __typename?: 'Query', notification: { __typename?: 'CandidateApplicationRejectedNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, matchResponse: { __typename?: 'ApplicationApprovedMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'ApplicationStartMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'ApplyMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'GenericMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'RejectedMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } } | { __typename?: 'CandidateCanReapplyNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'CandidateCompleteApplicationReminderNotification', id: string, createdAt: any, unread: boolean, type: NotificationType } | { __typename?: 'CandidateCompleteProfileReminderNotification', id: string, createdAt: any, unread: boolean, type: NotificationType } | { __typename?: 'CandidateInterviewInviteNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, interview: { __typename?: 'Interview', id: string, startDatetime: any, endDatetime: any, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string }, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } } } | { __typename?: 'CandidateInterviewUpdatedNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, interview: { __typename?: 'Interview', id: string, startDatetime: any, endDatetime: any, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string }, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } } } | { __typename?: 'CandidateQuestionAnsweredNotification', id: string, createdAt: any, unread: boolean, type: NotificationType, answer: { __typename?: 'Answer', id: string, content: string, author: { __typename?: 'AccountManager', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, displayName: string, photoUrl?: string | null }, question?: { __typename?: 'Question', id: string, title: string } | null } } | { __typename?: 'NewCandidateNotification', id: string, createdAt: any, unread: boolean, type: NotificationType } | { __typename?: 'NewMentionNotification', id: string, createdAt: any, unread: boolean, type: NotificationType } | { __typename?: 'NewMessageNotification', id: string, createdAt: any, unread: boolean, type: NotificationType } };

type NewNotification_CandidateApplicationRejectedNotification_Fragment = { __typename?: 'CandidateApplicationRejectedNotification', id: string };

type NewNotification_CandidateCanReapplyNotification_Fragment = { __typename?: 'CandidateCanReapplyNotification', id: string };

type NewNotification_CandidateCompleteApplicationReminderNotification_Fragment = { __typename?: 'CandidateCompleteApplicationReminderNotification', id: string };

type NewNotification_CandidateCompleteProfileReminderNotification_Fragment = { __typename?: 'CandidateCompleteProfileReminderNotification', id: string };

type NewNotification_CandidateInterviewInviteNotification_Fragment = { __typename?: 'CandidateInterviewInviteNotification', id: string };

type NewNotification_CandidateInterviewUpdatedNotification_Fragment = { __typename?: 'CandidateInterviewUpdatedNotification', id: string };

type NewNotification_CandidateQuestionAnsweredNotification_Fragment = { __typename?: 'CandidateQuestionAnsweredNotification', id: string };

type NewNotification_NewCandidateNotification_Fragment = { __typename?: 'NewCandidateNotification', id: string };

type NewNotification_NewMentionNotification_Fragment = { __typename?: 'NewMentionNotification', id: string };

type NewNotification_NewMessageNotification_Fragment = { __typename?: 'NewMessageNotification', id: string };

export type NewNotificationFragment = NewNotification_CandidateApplicationRejectedNotification_Fragment | NewNotification_CandidateCanReapplyNotification_Fragment | NewNotification_CandidateCompleteApplicationReminderNotification_Fragment | NewNotification_CandidateCompleteProfileReminderNotification_Fragment | NewNotification_CandidateInterviewInviteNotification_Fragment | NewNotification_CandidateInterviewUpdatedNotification_Fragment | NewNotification_CandidateQuestionAnsweredNotification_Fragment | NewNotification_NewCandidateNotification_Fragment | NewNotification_NewMentionNotification_Fragment | NewNotification_NewMessageNotification_Fragment;

export type ApplicationRejectedFieldsFragment = { __typename?: 'CandidateApplicationRejectedNotification', matchResponse: { __typename?: 'ApplicationApprovedMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'ApplicationStartMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'ApplyMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'GenericMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } | { __typename?: 'RejectedMatchResponse', id: string, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } };

export type CanReapplyFieldsFragment = { __typename?: 'CandidateCanReapplyNotification', job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } };

export type InterviewInviteFieldsFragment = { __typename?: 'CandidateInterviewInviteNotification', interview: { __typename?: 'Interview', id: string, startDatetime: any, endDatetime: any, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string }, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } } };

export type InterviewUpdatedFieldsFragment = { __typename?: 'CandidateInterviewUpdatedNotification', interview: { __typename?: 'Interview', id: string, startDatetime: any, endDatetime: any, application: { __typename?: 'Application', id: string, channel: { __typename?: 'ApplicationDMChannel', id: string }, job: { __typename?: 'Job', id: string, title: string, organisation: { __typename?: 'Organisation', id: string, photoUrl?: string | null } } } } };

export type QuestionAnsweredFieldsFragment = { __typename?: 'CandidateQuestionAnsweredNotification', answer: { __typename?: 'Answer', id: string, content: string, author: { __typename?: 'AccountManager', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, displayName: string, photoUrl?: string | null }, question?: { __typename?: 'Question', id: string, title: string } | null } };

export type ReadNotificationMutationVariables = Exact<{
  id: Scalars['MigrateID'];
}>;


export type ReadNotificationMutation = { __typename?: 'Mutation', readNotification: { __typename?: 'CandidateApplicationRejectedNotification', id: string, unread: boolean } | { __typename?: 'CandidateCanReapplyNotification', id: string, unread: boolean } | { __typename?: 'CandidateCompleteApplicationReminderNotification', id: string, unread: boolean } | { __typename?: 'CandidateCompleteProfileReminderNotification', id: string, unread: boolean } | { __typename?: 'CandidateInterviewInviteNotification', id: string, unread: boolean } | { __typename?: 'CandidateInterviewUpdatedNotification', id: string, unread: boolean } | { __typename?: 'CandidateQuestionAnsweredNotification', id: string, unread: boolean } | { __typename?: 'NewCandidateNotification', id: string, unread: boolean } | { __typename?: 'NewMentionNotification', id: string, unread: boolean } | { __typename?: 'NewMessageNotification', id: string, unread: boolean } };

export type JobPreferencesScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type JobPreferencesScreenQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string, country?: string | null, profession?: { __typename?: 'Profession', id: string, name: string } | null } | { __typename?: 'CandidateV2', id: string, country?: string | null, searchStage?: SearchStage | null, hasSetPreferences: boolean, profession?: { __typename?: 'Profession', id: string, name: string } | null, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, tagPreferences: Array<{ __typename?: 'Tag', id: string, name: string }>, locationPreferences: Array<{ __typename?: 'Location', id: string, name: string }> } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string }, getProfessions: { __typename?: 'ProfessionPage', data: Array<{ __typename?: 'Profession', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }> }, locations: Array<{ __typename?: 'Location', id: string, name: string }> };

export type OnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingQuery = { __typename?: 'Query', getProfessions: { __typename?: 'ProfessionPage', data: Array<{ __typename?: 'Profession', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }> }, locations: Array<{ __typename?: 'Location', id: string, name: string }> };

export type SignupToMailingListMutationVariables = Exact<{ [key: string]: never; }>;


export type SignupToMailingListMutation = { __typename?: 'Mutation', signupToMailingList: boolean };

export type RedListCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type RedListCountriesQuery = { __typename?: 'Query', redListCountries: Array<string | null> };

export type LocationStepLocationPropsFragment = { __typename?: 'Location', id: string, name: string };

export type LocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationsQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, name: string }> };

export type ProfessionStepProfessionPropsFragment = { __typename?: 'Profession', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> };

export type ProfessionStepProfessionPagePropsFragment = { __typename?: 'ProfessionPage', data: Array<{ __typename?: 'Profession', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }> };

export type OnboardingProfessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingProfessionsQuery = { __typename?: 'Query', getProfessions: { __typename?: 'ProfessionPage', data: Array<{ __typename?: 'Profession', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }> } };

export type AccountSettingsFormQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSettingsFormQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string, forenames: string, surname: string, email: string } | { __typename?: 'Candidate', id: string, forenames: string, surname: string, email: string } | { __typename?: 'CandidateV2', id: string, forenames: string, surname: string, email: string } | { __typename?: 'Staff', id: string, forenames: string, surname: string, email: string } | { __typename?: 'TeamMember', id: string, forenames: string, surname: string, email: string } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'AccountManager', id: string, forenames: string, surname: string } | { __typename?: 'Candidate', id: string, forenames: string, surname: string } | { __typename?: 'CandidateV2', id: string, forenames: string, surname: string } | { __typename?: 'Staff', id: string, forenames: string, surname: string } | { __typename?: 'TeamMember', id: string, forenames: string, surname: string } };

export type DeleteCandidateAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteCandidateAccountMutation = { __typename?: 'Mutation', deleteCandidateAccount: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', id: string } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type ProfileCompletionQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileCompletionQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string, fullName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, fullName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', profileCompletion: Array<ProfileCompletion>, id: string, fullName: string, photoUrl?: string | null, profession?: { __typename?: 'Profession', id: string, name: string } | null, countryInfo?: { __typename?: 'CountryInfo', name: string } | null } | { __typename?: 'Staff', id: string, fullName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, fullName: string, photoUrl?: string | null } };

export type ProfileTrackingQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileTrackingQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', profileCompletion: Array<ProfileCompletion>, id: string } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type GetProfilePhotoUploadTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfilePhotoUploadTokenQuery = { __typename?: 'Query', getProfilePhotoUploadToken: { __typename?: 'FileUploadPayload', token: any, url: string } };

export type UploadProfilePhotoMutationVariables = Exact<{
  input: UploadProfilePhotoInput;
}>;


export type UploadProfilePhotoMutation = { __typename?: 'Mutation', uploadProfilePhoto: { __typename?: 'AccountManager', id: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, photoUrl?: string | null } };

type CareerExperienceFields_CareerBreak_Fragment = { __typename?: 'CareerBreak', id: string, type: CareerExperienceType, reason: string, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> };

type CareerExperienceFields_WorkExperience_Fragment = { __typename?: 'WorkExperience', id: string, type: CareerExperienceType, organisationName: string, title: string, country?: string | null, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> };

export type CareerExperienceFieldsFragment = CareerExperienceFields_CareerBreak_Fragment | CareerExperienceFields_WorkExperience_Fragment;

export type CareerExperienceSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type CareerExperienceSectionQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', profileCompletion: Array<ProfileCompletion>, id: string, careerExperiences?: Array<{ __typename?: 'CareerBreak', id: string, type: CareerExperienceType, reason: string, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> } | { __typename?: 'WorkExperience', id: string, type: CareerExperienceType, organisationName: string, title: string, country?: string | null, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> }> | null } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type EducationExperienceSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type EducationExperienceSectionQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', profileCompletion: Array<ProfileCompletion>, id: string, coreDocuments?: { __typename?: 'CoreDocuments', qualification: Array<{ __typename?: 'Document', id: string, createdAt: any, url: string, filename: string, typeProps: { __typename?: 'DocumentTypeProps', type: DocumentType, name: string } }> } | null, educationExperiences?: Array<{ __typename?: 'EducationExperience', id: string, institutionName: string, qualification: string, grade?: string | null, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> }> | null } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type CreateWorkExperienceMutationVariables = Exact<{
  input: CreateWorkExperienceInput;
}>;


export type CreateWorkExperienceMutation = { __typename?: 'Mutation', createWorkExperience: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, isExemptFromLanguageTest: boolean, careerExperiences?: Array<{ __typename?: 'CareerBreak', id: string, type: CareerExperienceType, reason: string, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> } | { __typename?: 'WorkExperience', id: string, type: CareerExperienceType, organisationName: string, title: string, country?: string | null, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> }> | null } };

export type UpdateWorkExperienceMutationVariables = Exact<{
  input: UpdateWorkExperienceInput;
}>;


export type UpdateWorkExperienceMutation = { __typename?: 'Mutation', updateWorkExperience: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, isExemptFromLanguageTest: boolean, careerExperiences?: Array<{ __typename?: 'CareerBreak', id: string, type: CareerExperienceType, reason: string, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> } | { __typename?: 'WorkExperience', id: string, type: CareerExperienceType, organisationName: string, title: string, country?: string | null, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> }> | null } };

export type CreateCareerBreakMutationVariables = Exact<{
  input: CreateCareerBreakInput;
}>;


export type CreateCareerBreakMutation = { __typename?: 'Mutation', createCareerBreak: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, careerExperiences?: Array<{ __typename?: 'CareerBreak', id: string, type: CareerExperienceType, reason: string, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> } | { __typename?: 'WorkExperience', id: string, type: CareerExperienceType, organisationName: string, title: string, country?: string | null, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> }> | null } };

export type UpdateCareerBreakMutationVariables = Exact<{
  input: UpdateCareerBreakInput;
}>;


export type UpdateCareerBreakMutation = { __typename?: 'Mutation', updateCareerBreak: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, careerExperiences?: Array<{ __typename?: 'CareerBreak', id: string, type: CareerExperienceType, reason: string, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> } | { __typename?: 'WorkExperience', id: string, type: CareerExperienceType, organisationName: string, title: string, country?: string | null, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> }> | null } };

export type DeleteCareerExperienceMutationVariables = Exact<{
  input: DeleteCareerExperienceInput;
}>;


export type DeleteCareerExperienceMutation = { __typename?: 'Mutation', deleteCareerExperience: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, isExemptFromLanguageTest: boolean, careerExperiences?: Array<{ __typename?: 'CareerBreak', id: string, type: CareerExperienceType, reason: string, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> } | { __typename?: 'WorkExperience', id: string, type: CareerExperienceType, organisationName: string, title: string, country?: string | null, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> }> | null } };

export type CreateEducationExperienceMutationVariables = Exact<{
  input: CreateEducationExperienceInput;
}>;


export type CreateEducationExperienceMutation = { __typename?: 'Mutation', createEducationExperience: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, educationExperiences?: Array<{ __typename?: 'EducationExperience', id: string, institutionName: string, qualification: string, grade?: string | null, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> }> | null } };

export type UpdateEducationExperienceMutationVariables = Exact<{
  input: UpdateEducationExperienceInput;
}>;


export type UpdateEducationExperienceMutation = { __typename?: 'Mutation', updateEducationExperience: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, educationExperiences?: Array<{ __typename?: 'EducationExperience', id: string, institutionName: string, qualification: string, grade?: string | null, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> }> | null } };

export type DeleteEducationExperienceMutationVariables = Exact<{
  input: DeleteEducationExperienceInput;
}>;


export type DeleteEducationExperienceMutation = { __typename?: 'Mutation', deleteEducationExperience: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, educationExperiences?: Array<{ __typename?: 'EducationExperience', id: string, institutionName: string, qualification: string, grade?: string | null, startDate: any, endDate?: any | null, description: Array<{ __typename?: 'TextBlock', content: string }> }> | null } };

export type CreateLanguageResultMutationVariables = Exact<{
  input: CreateLanguageResultInput;
}>;


export type CreateLanguageResultMutation = { __typename?: 'Mutation', createLanguageResult: { __typename?: 'CandidateV2', id: string, meetsLanguageRequirements: boolean, profileCompletion: Array<ProfileCompletion>, languageResults?: Array<{ __typename?: 'LanguageResult', id: string, awardingBody: LanguageResultAwardingBody, date: any, listening: string, reading: string, writing: string, speaking: string }> | null } };

export type UpdateLanguageResultMutationVariables = Exact<{
  input: UpdateLanguageResultInput;
}>;


export type UpdateLanguageResultMutation = { __typename?: 'Mutation', updateLanguageResult: { __typename?: 'CandidateV2', id: string, meetsLanguageRequirements: boolean, profileCompletion: Array<ProfileCompletion>, languageResults?: Array<{ __typename?: 'LanguageResult', id: string, awardingBody: LanguageResultAwardingBody, date: any, listening: string, reading: string, writing: string, speaking: string }> | null } };

export type DeleteLanguageResultMutationVariables = Exact<{
  input: DeleteLanguageResultInput;
}>;


export type DeleteLanguageResultMutation = { __typename?: 'Mutation', deleteLanguageResult: { __typename?: 'CandidateV2', id: string, meetsLanguageRequirements: boolean, profileCompletion: Array<ProfileCompletion>, languageResults?: Array<{ __typename?: 'LanguageResult', id: string, awardingBody: LanguageResultAwardingBody, date: any, listening: string, reading: string, writing: string, speaking: string }> | null } };

export type CreateQuestionResponseMutationVariables = Exact<{
  input: CreateQuestionResponseInput;
}>;


export type CreateQuestionResponseMutation = { __typename?: 'Mutation', createQuestionResponse: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, questionResponses?: Array<{ __typename?: 'QuestionResponse', id: string, question: string, response: string }> | null } };

export type UpdateQuestionResponseMutationVariables = Exact<{
  input: UpdateQuestionResponseInput;
}>;


export type UpdateQuestionResponseMutation = { __typename?: 'Mutation', updateQuestionResponse: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, questionResponses?: Array<{ __typename?: 'QuestionResponse', id: string, question: string, response: string }> | null } };

export type DeleteQuestionResponseMutationVariables = Exact<{
  input: DeleteQuestionResponseInput;
}>;


export type DeleteQuestionResponseMutation = { __typename?: 'Mutation', deleteQuestionResponse: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, questionResponses?: Array<{ __typename?: 'QuestionResponse', id: string, question: string, response: string }> | null } };

export type CreateRegistrationDetailMutationVariables = Exact<{
  input: CreateRegistrationDetailInput;
}>;


export type CreateRegistrationDetailMutation = { __typename?: 'Mutation', createRegistrationDetail: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, registrationDetails?: Array<{ __typename?: 'RegistrationDetailV2', id: string, country: string, referenceNumber?: string | null, countryInfo: { __typename?: 'CountryInfo', name: string } }> | null } };

export type UpdateRegistrationDetailMutationVariables = Exact<{
  input: UpdateRegistrationDetailInput;
}>;


export type UpdateRegistrationDetailMutation = { __typename?: 'Mutation', updateRegistrationDetail: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, registrationDetails?: Array<{ __typename?: 'RegistrationDetailV2', id: string, country: string, referenceNumber?: string | null, countryInfo: { __typename?: 'CountryInfo', name: string } }> | null } };

export type DeleteRegistrationDetailMutationVariables = Exact<{
  input: DeleteRegistrationDetailInput;
}>;


export type DeleteRegistrationDetailMutation = { __typename?: 'Mutation', deleteRegistrationDetail: { __typename?: 'CandidateV2', id: string, profileCompletion: Array<ProfileCompletion>, registrationDetails?: Array<{ __typename?: 'RegistrationDetailV2', id: string, country: string, referenceNumber?: string | null, countryInfo: { __typename?: 'CountryInfo', name: string } }> | null } };

export type LanguageResultFormQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguageResultFormQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', meetsLanguageRequirements: boolean, isExemptFromLanguageTest: boolean, profileCompletion: Array<ProfileCompletion>, id: string, coreDocuments?: { __typename?: 'CoreDocuments', languageCertificate: Array<{ __typename?: 'Document', id: string, createdAt: any, url: string, filename: string, typeProps: { __typename?: 'DocumentTypeProps', type: DocumentType, name: string } }> } | null, languageResults?: Array<{ __typename?: 'LanguageResult', id: string, awardingBody: LanguageResultAwardingBody, date: any, listening: string, reading: string, writing: string, speaking: string }> | null } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string }, languageResultSchema: { __typename?: 'LanguageResultSchema', IELTS: Array<string>, OET: Array<string> } };

export type LanguageRequirementsLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguageRequirementsLinkQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', id: string, profession?: { __typename?: 'Profession', id: string, name: string } | null } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type JobPreferencesOverviewCardQueryVariables = Exact<{ [key: string]: never; }>;


export type JobPreferencesOverviewCardQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string, country?: string | null, profession?: { __typename?: 'Profession', id: string, name: string } | null } | { __typename?: 'CandidateV2', id: string, country?: string | null, searchStage?: SearchStage | null, hasSetPreferences: boolean, profession?: { __typename?: 'Profession', id: string, name: string } | null, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, tagPreferences: Array<{ __typename?: 'Tag', id: string, name: string }>, locationPreferences: Array<{ __typename?: 'Location', id: string, name: string }> } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type ProfileOverviewCardQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileOverviewCardQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string, forenames: string } | { __typename?: 'Candidate', id: string, forenames: string } | { __typename?: 'CandidateV2', id: string, forenames: string } | { __typename?: 'Staff', id: string, forenames: string } | { __typename?: 'TeamMember', id: string, forenames: string } };

export type QuestionResponseFormQueryVariables = Exact<{ [key: string]: never; }>;


export type QuestionResponseFormQuery = { __typename?: 'Query', profileQuestions: Array<string>, me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', profileCompletion: Array<ProfileCompletion>, id: string, questionResponses?: Array<{ __typename?: 'QuestionResponse', id: string, question: string, response: string }> | null } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type RegistrationDetailFormQueryVariables = Exact<{ [key: string]: never; }>;


export type RegistrationDetailFormQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', profileCompletion: Array<ProfileCompletion>, id: string, registrationDetails?: Array<{ __typename?: 'RegistrationDetailV2', id: string, country: string, referenceNumber?: string | null, countryInfo: { __typename?: 'CountryInfo', name: string } }> | null } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type ImportFromCvQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportFromCvQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', id: string, cv?: { __typename?: 'Document', id: string, url: string } | null } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type UpdateCandidateCvCacheQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdateCandidateCvCacheQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', id: string, cv?: { __typename?: 'Document', id: string, url: string } | null } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

export type PassportSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type PassportSectionQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string } | { __typename?: 'Candidate', id: string } | { __typename?: 'CandidateV2', id: string, coreDocuments?: { __typename?: 'CoreDocuments', passport: Array<{ __typename?: 'Document', id: string, createdAt: any, url: string, filename: string, typeProps: { __typename?: 'DocumentTypeProps', type: DocumentType, name: string } }> } | null } | { __typename?: 'Staff', id: string } | { __typename?: 'TeamMember', id: string } };

type JobMatchActionMatchResponseProps_ApplicationApprovedMatchResponse_Fragment = { __typename?: 'ApplicationApprovedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } };

type JobMatchActionMatchResponseProps_ApplicationStartMatchResponse_Fragment = { __typename?: 'ApplicationStartMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } };

type JobMatchActionMatchResponseProps_ApplyMatchResponse_Fragment = { __typename?: 'ApplyMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } };

type JobMatchActionMatchResponseProps_GenericMatchResponse_Fragment = { __typename?: 'GenericMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } };

type JobMatchActionMatchResponseProps_RejectedMatchResponse_Fragment = { __typename?: 'RejectedMatchResponse', id: string, createdAt: any, type: MatchResponseType, candidate: { __typename?: 'CandidateV2', id: string }, job: { __typename?: 'Job', id: string, myMatchResponse?: { __typename?: 'ApplicationApprovedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplicationStartMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'ApplyMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'GenericMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | { __typename?: 'RejectedMatchResponse', id: string, type: MatchResponseType, updatedAt: any } | null } };

export type JobMatchActionMatchResponsePropsFragment = JobMatchActionMatchResponseProps_ApplicationApprovedMatchResponse_Fragment | JobMatchActionMatchResponseProps_ApplicationStartMatchResponse_Fragment | JobMatchActionMatchResponseProps_ApplyMatchResponse_Fragment | JobMatchActionMatchResponseProps_GenericMatchResponse_Fragment | JobMatchActionMatchResponseProps_RejectedMatchResponse_Fragment;

type JobPreferencesApplicantProps_Candidate_Fragment = { __typename?: 'Candidate', id: string, country?: string | null, profession?: { __typename?: 'Profession', id: string, name: string } | null };

type JobPreferencesApplicantProps_ExternalCandidate_Fragment = { __typename?: 'ExternalCandidate', id: string, country?: string | null, profession?: { __typename?: 'Profession', id: string, name: string } | null };

export type JobPreferencesApplicantPropsFragment = JobPreferencesApplicantProps_Candidate_Fragment | JobPreferencesApplicantProps_ExternalCandidate_Fragment;

export type JobPreferencesCandidateV2PropsFragment = { __typename?: 'CandidateV2', id: string, country?: string | null, searchStage?: SearchStage | null, hasSetPreferences: boolean, profession?: { __typename?: 'Profession', id: string, name: string } | null, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, tagPreferences: Array<{ __typename?: 'Tag', id: string, name: string }>, locationPreferences: Array<{ __typename?: 'Location', id: string, name: string }> };

export type UpdateJobPreferencesMutationVariables = Exact<{
  input: UpdateCurrentCandidateInput;
}>;


export type UpdateJobPreferencesMutation = { __typename?: 'Mutation', updateCurrentCandidate: { __typename?: 'CandidateV2', id: string, country?: string | null, searchStage?: SearchStage | null, hasSetPreferences: boolean, profession?: { __typename?: 'Profession', id: string, name: string } | null, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, tagPreferences: Array<{ __typename?: 'Tag', id: string, name: string }>, locationPreferences: Array<{ __typename?: 'Location', id: string, name: string }> } };

export type SendMessageOptimisticAuthorQueryVariables = Exact<{ [key: string]: never; }>;


export type SendMessageOptimisticAuthorQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } };

export type AttachmentErrorFragment = { __typename?: 'Attachment', isUploading: boolean };

export type GetAttachmentUploadTokenQueryVariables = Exact<{
  input: GetAttachmentUploadTokenInput;
}>;


export type GetAttachmentUploadTokenQuery = { __typename?: 'Query', getAttachmentUploadToken: { __typename?: 'FileUploadPayload', token: any, url: string } };

type MessageAuthorFields_AccountManager_Fragment = { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null };

type MessageAuthorFields_Candidate_Fragment = { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null };

type MessageAuthorFields_CandidateV2_Fragment = { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null };

type MessageAuthorFields_Staff_Fragment = { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null };

type MessageAuthorFields_TeamMember_Fragment = { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null };

export type MessageAuthorFieldsFragment = MessageAuthorFields_AccountManager_Fragment | MessageAuthorFields_Candidate_Fragment | MessageAuthorFields_CandidateV2_Fragment | MessageAuthorFields_Staff_Fragment | MessageAuthorFields_TeamMember_Fragment;

export type MessageAttachmentFieldsFragment = { __typename?: 'Attachment', id: string, filename: string, url: string };

export type ReferencedMessageFieldsFragment = { __typename?: 'Message', id: string, content?: string | null, createdAt: any, deletedAt?: any | null, author?: { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | null, attachment?: { __typename?: 'Attachment', id: string, filename: string, url: string } | null };

export type MessageFieldsNoLocalStateFragment = { __typename?: 'Message', id: string, createdAt: any, content?: string | null, isSent: boolean, deletedAt?: any | null, attachment?: { __typename?: 'Attachment', id: string, filename: string, url: string } | null, author?: { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | null, referencedMessage?: { __typename?: 'Message', id: string, content?: string | null, createdAt: any, deletedAt?: any | null, author?: { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | null, attachment?: { __typename?: 'Attachment', id: string, filename: string, url: string } | null } | null };

export type MessageFieldsFragment = { __typename?: 'Message', sendError: boolean, id: string, createdAt: any, content?: string | null, isSent: boolean, deletedAt?: any | null, attachment?: { __typename?: 'Attachment', isUploading: boolean, id: string, filename: string, url: string, localFile?: { __typename?: 'FileFromFilesystem', uri: string, name?: string | null } | null } | null, author?: { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | null, referencedMessage?: { __typename?: 'Message', id: string, content?: string | null, createdAt: any, deletedAt?: any | null, author?: { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | null, attachment?: { __typename?: 'Attachment', id: string, filename: string, url: string } | null } | null };

export type UploadMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type UploadMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'Message', sendError: boolean, id: string, createdAt: any, content?: string | null, isSent: boolean, deletedAt?: any | null, attachment?: { __typename?: 'Attachment', isUploading: boolean, id: string, filename: string, url: string, localFile?: { __typename?: 'FileFromFilesystem', uri: string, name?: string | null } | null } | null, author?: { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | null, referencedMessage?: { __typename?: 'Message', id: string, content?: string | null, createdAt: any, deletedAt?: any | null, author?: { __typename?: 'AccountManager', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Candidate', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'CandidateV2', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'Staff', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | { __typename?: 'TeamMember', id: string, isActive: boolean, displayName: string, photoUrl?: string | null } | null, attachment?: { __typename?: 'Attachment', id: string, filename: string, url: string } | null } | null } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', me: { __typename?: 'AccountManager', surname: string, email: string, isActive: boolean, notificationsMutedUntil?: any | null, id: string, forenames: string, photoUrl?: string | null, account?: { __typename?: 'Account', id: string, verified: boolean } | null } | { __typename?: 'Candidate', surname: string, email: string, isActive: boolean, notificationsMutedUntil?: any | null, id: string, forenames: string, photoUrl?: string | null, account?: { __typename?: 'Account', id: string, verified: boolean } | null, countryInfo?: { __typename?: 'CountryInfo', name: string } | null } | { __typename?: 'CandidateV2', hasSetPreferences: boolean, surname: string, email: string, isActive: boolean, notificationsMutedUntil?: any | null, id: string, forenames: string, photoUrl?: string | null, account?: { __typename?: 'Account', id: string, verified: boolean } | null, countryInfo?: { __typename?: 'CountryInfo', name: string } | null, profession?: { __typename?: 'Profession', id: string, name: string } | null } | { __typename?: 'Staff', surname: string, email: string, isActive: boolean, notificationsMutedUntil?: any | null, id: string, forenames: string, photoUrl?: string | null, account?: { __typename?: 'Account', id: string, verified: boolean } | null } | { __typename?: 'TeamMember', surname: string, email: string, isActive: boolean, notificationsMutedUntil?: any | null, id: string, forenames: string, photoUrl?: string | null, account?: { __typename?: 'Account', id: string, verified: boolean } | null } };

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['MigrateID'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument: { __typename?: 'Document', id: string } };

export type GetDocumentUploadTokenQueryVariables = Exact<{
  filename?: InputMaybe<Scalars['String']>;
}>;


export type GetDocumentUploadTokenQuery = { __typename?: 'Query', getDocumentUploadToken: { __typename?: 'FileUploadPayload', token: any, url: string } };

export type UploadDocumentMutationVariables = Exact<{
  input: UploadDocumentInput;
}>;


export type UploadDocumentMutation = { __typename?: 'Mutation', uploadDocument: { __typename?: 'Document', id: string, url: string, type: DocumentType, fileMetadata: { __typename?: 'FileMetadata', filename: string, size?: number | null, createdAt: any }, typeProps: { __typename?: 'DocumentTypeProps', name: string } } };

export type NewDocumentFragment = { __typename?: 'Document', id: string, type: DocumentType };

export type ReadDocumentFragment = { __typename?: 'Document', id: string, type: DocumentType };

export const UserInCacheFragmentDoc = gql`
    fragment UserInCache on User {
  id
}
    `;
export const CoreDocumentsFieldsFragmentDoc = gql`
    fragment CoreDocumentsFields on Document {
  id
  createdAt
  url
  filename
  typeProps {
    type
    name
  }
}
    `;
export const MessageAttachmentFieldsFragmentDoc = gql`
    fragment MessageAttachmentFields on Attachment {
  id
  filename
  url
}
    `;
export const MessageAuthorFieldsFragmentDoc = gql`
    fragment MessageAuthorFields on User {
  id
  isActive
  displayName
  photoUrl
}
    `;
export const ReferencedMessageFieldsFragmentDoc = gql`
    fragment ReferencedMessageFields on Message {
  id
  author {
    ...MessageAuthorFields
  }
  content
  attachment {
    ...MessageAttachmentFields
  }
  createdAt
  deletedAt
}
    ${MessageAuthorFieldsFragmentDoc}
${MessageAttachmentFieldsFragmentDoc}`;
export const MessageFieldsNoLocalStateFragmentDoc = gql`
    fragment MessageFieldsNoLocalState on Message {
  id
  createdAt
  content
  isSent
  deletedAt
  attachment {
    ...MessageAttachmentFields
  }
  author {
    ...MessageAuthorFields
  }
  referencedMessage {
    ...ReferencedMessageFields
  }
}
    ${MessageAttachmentFieldsFragmentDoc}
${MessageAuthorFieldsFragmentDoc}
${ReferencedMessageFieldsFragmentDoc}`;
export const NewMessagePayloadFragmentDoc = gql`
    fragment NewMessagePayload on Message {
  ...MessageFieldsNoLocalState
  channel {
    id
    unread
    type
    lastMessage {
      id
      content
      createdAt
      author {
        id
      }
    }
    ... on CommunityPublicChannel {
      name
    }
    ... on ApplicationDMChannel {
      application {
        id
        job {
          id
          organisationName
          organisation {
            id
            name
          }
        }
      }
    }
  }
  isSent
}
    ${MessageFieldsNoLocalStateFragmentDoc}`;
export const NewMessageFragmentDoc = gql`
    fragment NewMessage on Message {
  id
}
    `;
export const ChannelCategoryFilterPropsFragmentDoc = gql`
    fragment ChannelCategoryFilterProps on ChannelCategory {
  id
  name
}
    `;
export const BaseChannelListCardPropsFragmentDoc = gql`
    fragment BaseChannelListCardProps on Channel {
  id
  lastMessage {
    id
    createdAt
    content
    attachment {
      id
    }
    author {
      id
      displayName
    }
  }
  createdAt
  unread
  type
}
    `;
export const ApplicationDmChannelListCardPropsFragmentDoc = gql`
    fragment ApplicationDMChannelListCardProps on ApplicationDMChannel {
  ...BaseChannelListCardProps
  application {
    job {
      id
      title
      organisationName
      organisation {
        id
        name
      }
    }
  }
}
    ${BaseChannelListCardPropsFragmentDoc}`;
export const OrganisationPrivateChannelListCardPropsFragmentDoc = gql`
    fragment OrganisationPrivateChannelListCardProps on OrganisationPrivateChannel {
  ...BaseChannelListCardProps
  name
}
    ${BaseChannelListCardPropsFragmentDoc}`;
export const CommunityChannelCardHeaderUserFragmentFragmentDoc = gql`
    fragment CommunityChannelCardHeaderUserFragment on User {
  id
  photoUrl
}
    `;
export const CommunityChannelCardHeaderMembersFragmentFragmentDoc = gql`
    fragment CommunityChannelCardHeaderMembersFragment on UserPage {
  data {
    ...CommunityChannelCardHeaderUserFragment
  }
  count
}
    ${CommunityChannelCardHeaderUserFragmentFragmentDoc}`;
export const CommunityPublicChannelListCardPropsFragmentDoc = gql`
    fragment CommunityPublicChannelListCardProps on CommunityPublicChannel {
  ...BaseChannelListCardProps
  name
  members(_size: 2) {
    ...CommunityChannelCardHeaderMembersFragment
  }
}
    ${BaseChannelListCardPropsFragmentDoc}
${CommunityChannelCardHeaderMembersFragmentFragmentDoc}`;
export const CommunityChannelCardHeaderChannelFragmentFragmentDoc = gql`
    fragment CommunityChannelCardHeaderChannelFragment on CommunityPublicChannel {
  id
  name
  isMember
}
    `;
export const MessagePreviewAuthorFragmentFragmentDoc = gql`
    fragment MessagePreviewAuthorFragment on User {
  id
  displayName
}
    `;
export const MessagePreviewAttachmentFragmentFragmentDoc = gql`
    fragment MessagePreviewAttachmentFragment on Attachment {
  id
}
    `;
export const MessagePreviewFragmentFragmentDoc = gql`
    fragment MessagePreviewFragment on Message {
  id
  createdAt
  content
  attachment {
    ...MessagePreviewAttachmentFragment
  }
  author {
    ...MessagePreviewAuthorFragment
  }
}
    ${MessagePreviewAttachmentFragmentFragmentDoc}
${MessagePreviewAuthorFragmentFragmentDoc}`;
export const JoinedCommunityChannelFragmentDoc = gql`
    fragment JoinedCommunityChannel on CommunityPublicChannel {
  ...CommunityChannelCardHeaderChannelFragment
  members(_size: 2) {
    ...CommunityChannelCardHeaderMembersFragment
  }
  messages(_size: 2) {
    data {
      id
      author {
        ...CommunityChannelCardHeaderUserFragment
        ...MessagePreviewAuthorFragment
      }
    }
  }
  description
  lastMessage {
    ...MessagePreviewFragment
  }
  unread
}
    ${CommunityChannelCardHeaderChannelFragmentFragmentDoc}
${CommunityChannelCardHeaderMembersFragmentFragmentDoc}
${CommunityChannelCardHeaderUserFragmentFragmentDoc}
${MessagePreviewAuthorFragmentFragmentDoc}
${MessagePreviewFragmentFragmentDoc}`;
export const OverviewCommunityChannelCardChannelPropsFragmentDoc = gql`
    fragment OverviewCommunityChannelCardChannelProps on CommunityPublicChannel {
  id
  isMember
  description
  ...CommunityChannelCardHeaderChannelFragment
  members(_size: 2) {
    ...CommunityChannelCardHeaderMembersFragment
  }
  messages(_size: 2) {
    data {
      id
      author {
        ...CommunityChannelCardHeaderUserFragment
      }
    }
  }
}
    ${CommunityChannelCardHeaderChannelFragmentFragmentDoc}
${CommunityChannelCardHeaderMembersFragmentFragmentDoc}
${CommunityChannelCardHeaderUserFragmentFragmentDoc}`;
export const ReadQuestionTitleFragmentDoc = gql`
    fragment ReadQuestionTitle on Question {
  title
}
    `;
export const UserHeaderFragmentFragmentDoc = gql`
    fragment UserHeaderFragment on User {
  id
  forenames
  photoUrl
  isActive
  ... on Candidate {
    countryInfo {
      name
    }
  }
  ... on CandidateV2 {
    countryInfo {
      name
    }
    profession {
      id
      name
    }
  }
}
    `;
export const AnswerFragmentFragmentDoc = gql`
    fragment AnswerFragment on Answer {
  id
  createdAt
  author {
    ...UserHeaderFragment
  }
  content
  upvotes
  downvotes
  myVoteType
}
    ${UserHeaderFragmentFragmentDoc}`;
export const QuestionTopicFragmentDoc = gql`
    fragment QuestionTopic on QuestionTopic {
  id
  name
}
    `;
export const JobDetailsJobPropsFragmentDoc = gql`
    fragment JobDetailsJobProps on Job {
  id
  myMatchResponse {
    id
    updatedAt
    type
    ... on RejectedMatchResponse {
      reason
    }
    job {
      id
      myMatchResponse {
        id
      }
    }
  }
  title
  description
  detailedDescription {
    ... on TextBlock {
      content
    }
  }
  organisationName
  organisation {
    id
    name
    photoUrl
    url
  }
  salary
  requiresLanguagePass
  city
  location {
    id
    name
    description
  }
  mapLocation {
    name
    location {
      lat
      lon
    }
  }
  highlights
  files {
    id
    filename
    url
  }
  status
  createdAt
}
    `;
export const JobMatchesOverviewJobPagePropsFragmentDoc = gql`
    fragment JobMatchesOverviewJobPageProps on JobPage {
  count
}
    `;
export const JobCardPropsFragmentDoc = gql`
    fragment JobCardProps on Job {
  id
  title
  organisationName
  organisation {
    id
    name
    photoUrl
  }
  myMatchResponse {
    id
    type
    ... on ApplicationApprovedMatchResponse {
      application {
        id
        channel {
          id
        }
      }
    }
  }
}
    `;
export const ApplicationRejectedFieldsFragmentDoc = gql`
    fragment ApplicationRejectedFields on CandidateApplicationRejectedNotification {
  matchResponse {
    id
    job {
      id
      title
      organisation {
        id
        photoUrl
      }
    }
  }
}
    `;
export const CanReapplyFieldsFragmentDoc = gql`
    fragment CanReapplyFields on CandidateCanReapplyNotification {
  job {
    id
    title
    organisation {
      id
      photoUrl
    }
  }
}
    `;
export const QuestionAnsweredFieldsFragmentDoc = gql`
    fragment QuestionAnsweredFields on CandidateQuestionAnsweredNotification {
  answer {
    id
    author {
      id
      displayName
      photoUrl
    }
    question {
      id
      title
    }
    content
  }
}
    `;
export const InterviewInviteFieldsFragmentDoc = gql`
    fragment InterviewInviteFields on CandidateInterviewInviteNotification {
  interview {
    id
    startDatetime
    endDatetime
    application {
      id
      channel {
        id
      }
      job {
        id
        title
        organisation {
          id
          photoUrl
        }
      }
    }
  }
}
    `;
export const InterviewUpdatedFieldsFragmentDoc = gql`
    fragment InterviewUpdatedFields on CandidateInterviewUpdatedNotification {
  interview {
    id
    startDatetime
    endDatetime
    application {
      id
      channel {
        id
      }
      job {
        id
        title
        organisation {
          id
          photoUrl
        }
      }
    }
  }
}
    `;
export const NotificationFieldsFragmentDoc = gql`
    fragment NotificationFields on Notification {
  id
  createdAt
  unread
  type
  ... on CandidateApplicationRejectedNotification {
    ...ApplicationRejectedFields
  }
  ... on CandidateCanReapplyNotification {
    ...CanReapplyFields
  }
  ... on CandidateQuestionAnsweredNotification {
    ...QuestionAnsweredFields
  }
  ... on CandidateInterviewInviteNotification {
    ...InterviewInviteFields
  }
  ... on CandidateInterviewUpdatedNotification {
    ...InterviewUpdatedFields
  }
}
    ${ApplicationRejectedFieldsFragmentDoc}
${CanReapplyFieldsFragmentDoc}
${QuestionAnsweredFieldsFragmentDoc}
${InterviewInviteFieldsFragmentDoc}
${InterviewUpdatedFieldsFragmentDoc}`;
export const NewNotificationFragmentDoc = gql`
    fragment NewNotification on Notification {
  id
}
    `;
export const LocationStepLocationPropsFragmentDoc = gql`
    fragment LocationStepLocationProps on Location {
  id
  name
}
    `;
export const ProfessionStepProfessionPropsFragmentDoc = gql`
    fragment ProfessionStepProfessionProps on Profession {
  id
  name
  tags {
    id
    name
  }
}
    `;
export const ProfessionStepProfessionPagePropsFragmentDoc = gql`
    fragment ProfessionStepProfessionPageProps on ProfessionPage {
  data {
    ...ProfessionStepProfessionProps
  }
}
    ${ProfessionStepProfessionPropsFragmentDoc}`;
export const CareerExperienceFieldsFragmentDoc = gql`
    fragment CareerExperienceFields on CareerExperience {
  ... on WorkExperience {
    id
    type
    organisationName
    title
    country
    startDate
    endDate
    description {
      content
    }
  }
  ... on CareerBreak {
    id
    type
    reason
    startDate
    endDate
    description {
      content
    }
  }
}
    `;
export const JobMatchActionMatchResponsePropsFragmentDoc = gql`
    fragment JobMatchActionMatchResponseProps on MatchResponse {
  id
  createdAt
  type
  candidate {
    id
  }
  job {
    id
    myMatchResponse {
      id
      type
      updatedAt
    }
  }
}
    `;
export const JobPreferencesApplicantPropsFragmentDoc = gql`
    fragment JobPreferencesApplicantProps on Applicant {
  id
  profession {
    id
    name
  }
  country
}
    `;
export const JobPreferencesCandidateV2PropsFragmentDoc = gql`
    fragment JobPreferencesCandidateV2Props on CandidateV2 {
  id
  profession {
    id
    name
  }
  country
  countryInfo {
    name
  }
  tagPreferences {
    id
    name
  }
  locationPreferences {
    id
    name
  }
  searchStage
  hasSetPreferences
}
    `;
export const AttachmentErrorFragmentDoc = gql`
    fragment AttachmentError on Attachment {
  isUploading @client
}
    `;
export const MessageFieldsFragmentDoc = gql`
    fragment MessageFields on Message {
  ...MessageFieldsNoLocalState
  sendError @client
  attachment {
    ...MessageAttachmentFields
    isUploading @client
    localFile @client {
      uri
      name
    }
  }
}
    ${MessageFieldsNoLocalStateFragmentDoc}
${MessageAttachmentFieldsFragmentDoc}`;
export const NewDocumentFragmentDoc = gql`
    fragment NewDocument on Document {
  id
  type
}
    `;
export const ReadDocumentFragmentDoc = gql`
    fragment ReadDocument on Document {
  id
  type
}
    `;
export const SetPushTokenDocument = gql`
    mutation SetPushToken($input: SetPushTokenInput!) {
  setPushToken(input: $input) {
    id
    pushToken
  }
}
    `;
export type SetPushTokenMutationFn = Apollo.MutationFunction<SetPushTokenMutation, SetPushTokenMutationVariables>;

/**
 * __useSetPushTokenMutation__
 *
 * To run a mutation, you first call `useSetPushTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPushTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPushTokenMutation, { data, loading, error }] = useSetPushTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPushTokenMutation(baseOptions?: Apollo.MutationHookOptions<SetPushTokenMutation, SetPushTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPushTokenMutation, SetPushTokenMutationVariables>(SetPushTokenDocument, options);
      }
export type SetPushTokenMutationHookResult = ReturnType<typeof useSetPushTokenMutation>;
export type SetPushTokenMutationResult = Apollo.MutationResult<SetPushTokenMutation>;
export type SetPushTokenMutationOptions = Apollo.BaseMutationOptions<SetPushTokenMutation, SetPushTokenMutationVariables>;
export const UpdateCandidateCoreDocsCacheDocument = gql`
    query UpdateCandidateCoreDocsCache {
  me {
    id
    ... on CandidateV2 {
      coreDocuments {
        passport {
          ...CoreDocumentsFields
        }
        qualification {
          ...CoreDocumentsFields
        }
        languageCertificate {
          ...CoreDocumentsFields
        }
      }
      profileCompletion
    }
  }
}
    ${CoreDocumentsFieldsFragmentDoc}`;

/**
 * __useUpdateCandidateCoreDocsCacheQuery__
 *
 * To run a query within a React component, call `useUpdateCandidateCoreDocsCacheQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateCoreDocsCacheQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateCandidateCoreDocsCacheQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdateCandidateCoreDocsCacheQuery(baseOptions?: Apollo.QueryHookOptions<UpdateCandidateCoreDocsCacheQuery, UpdateCandidateCoreDocsCacheQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateCandidateCoreDocsCacheQuery, UpdateCandidateCoreDocsCacheQueryVariables>(UpdateCandidateCoreDocsCacheDocument, options);
      }
export function useUpdateCandidateCoreDocsCacheLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateCandidateCoreDocsCacheQuery, UpdateCandidateCoreDocsCacheQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateCandidateCoreDocsCacheQuery, UpdateCandidateCoreDocsCacheQueryVariables>(UpdateCandidateCoreDocsCacheDocument, options);
        }
export type UpdateCandidateCoreDocsCacheQueryHookResult = ReturnType<typeof useUpdateCandidateCoreDocsCacheQuery>;
export type UpdateCandidateCoreDocsCacheLazyQueryHookResult = ReturnType<typeof useUpdateCandidateCoreDocsCacheLazyQuery>;
export type UpdateCandidateCoreDocsCacheQueryResult = Apollo.QueryResult<UpdateCandidateCoreDocsCacheQuery, UpdateCandidateCoreDocsCacheQueryVariables>;
export const UpdateCacheAfterVerifyDocument = gql`
    query UpdateCacheAfterVerify {
  me {
    id
    account {
      id
      verified
    }
  }
}
    `;

/**
 * __useUpdateCacheAfterVerifyQuery__
 *
 * To run a query within a React component, call `useUpdateCacheAfterVerifyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateCacheAfterVerifyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateCacheAfterVerifyQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdateCacheAfterVerifyQuery(baseOptions?: Apollo.QueryHookOptions<UpdateCacheAfterVerifyQuery, UpdateCacheAfterVerifyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateCacheAfterVerifyQuery, UpdateCacheAfterVerifyQueryVariables>(UpdateCacheAfterVerifyDocument, options);
      }
export function useUpdateCacheAfterVerifyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateCacheAfterVerifyQuery, UpdateCacheAfterVerifyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateCacheAfterVerifyQuery, UpdateCacheAfterVerifyQueryVariables>(UpdateCacheAfterVerifyDocument, options);
        }
export type UpdateCacheAfterVerifyQueryHookResult = ReturnType<typeof useUpdateCacheAfterVerifyQuery>;
export type UpdateCacheAfterVerifyLazyQueryHookResult = ReturnType<typeof useUpdateCacheAfterVerifyLazyQuery>;
export type UpdateCacheAfterVerifyQueryResult = Apollo.QueryResult<UpdateCacheAfterVerifyQuery, UpdateCacheAfterVerifyQueryVariables>;
export const MarkChannelDocument = gql`
    mutation MarkChannel($input: MarkChannelInput!) {
  markChannel(input: $input) {
    id
    unread
  }
}
    `;
export type MarkChannelMutationFn = Apollo.MutationFunction<MarkChannelMutation, MarkChannelMutationVariables>;

/**
 * __useMarkChannelMutation__
 *
 * To run a mutation, you first call `useMarkChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markChannelMutation, { data, loading, error }] = useMarkChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkChannelMutation(baseOptions?: Apollo.MutationHookOptions<MarkChannelMutation, MarkChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkChannelMutation, MarkChannelMutationVariables>(MarkChannelDocument, options);
      }
export type MarkChannelMutationHookResult = ReturnType<typeof useMarkChannelMutation>;
export type MarkChannelMutationResult = Apollo.MutationResult<MarkChannelMutation>;
export type MarkChannelMutationOptions = Apollo.BaseMutationOptions<MarkChannelMutation, MarkChannelMutationVariables>;
export const ChannelMessagesDocument = gql`
    query ChannelMessages($id: MigrateID!, $after: String) {
  messages(where: {channel: {in: [$id]}}, _cursor: $after) {
    data {
      id
      content
      createdAt
      author {
        ...MessageAuthorFields
      }
      isSent
      sendError @client
      attachment {
        id
        filename
        url
      }
      deletedAt
      referencedMessage {
        id
        attachment {
          id
          filename
          url
        }
        content
        author {
          id
          displayName
        }
        deletedAt
      }
    }
    after
  }
  channel(id: $id) {
    id
    unread
    ... on WithName {
      name
    }
    ... on CommunityPublicChannel {
      isMember
    }
  }
}
    ${MessageAuthorFieldsFragmentDoc}`;

/**
 * __useChannelMessagesQuery__
 *
 * To run a query within a React component, call `useChannelMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelMessagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useChannelMessagesQuery(baseOptions: Apollo.QueryHookOptions<ChannelMessagesQuery, ChannelMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelMessagesQuery, ChannelMessagesQueryVariables>(ChannelMessagesDocument, options);
      }
export function useChannelMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelMessagesQuery, ChannelMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelMessagesQuery, ChannelMessagesQueryVariables>(ChannelMessagesDocument, options);
        }
export type ChannelMessagesQueryHookResult = ReturnType<typeof useChannelMessagesQuery>;
export type ChannelMessagesLazyQueryHookResult = ReturnType<typeof useChannelMessagesLazyQuery>;
export type ChannelMessagesQueryResult = Apollo.QueryResult<ChannelMessagesQuery, ChannelMessagesQueryVariables>;
export const GetMessageDocument = gql`
    query GetMessage($id: MigrateID!) {
  message(id: $id) {
    ...NewMessagePayload
  }
}
    ${NewMessagePayloadFragmentDoc}`;

/**
 * __useGetMessageQuery__
 *
 * To run a query within a React component, call `useGetMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMessageQuery(baseOptions: Apollo.QueryHookOptions<GetMessageQuery, GetMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, options);
      }
export function useGetMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageQuery, GetMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, options);
        }
export type GetMessageQueryHookResult = ReturnType<typeof useGetMessageQuery>;
export type GetMessageLazyQueryHookResult = ReturnType<typeof useGetMessageLazyQuery>;
export type GetMessageQueryResult = Apollo.QueryResult<GetMessageQuery, GetMessageQueryVariables>;
export const DeleteMessageDocument = gql`
    mutation DeleteMessage($input: DeleteMessageInput!) {
  deleteMessage(input: $input) {
    message {
      id
      deletedAt
    }
  }
}
    `;
export type DeleteMessageMutationFn = Apollo.MutationFunction<DeleteMessageMutation, DeleteMessageMutationVariables>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageMutation, DeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageMutation, DeleteMessageMutationVariables>(DeleteMessageDocument, options);
      }
export type DeleteMessageMutationHookResult = ReturnType<typeof useDeleteMessageMutation>;
export type DeleteMessageMutationResult = Apollo.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<DeleteMessageMutation, DeleteMessageMutationVariables>;
export const CommunityActivityDocument = gql`
    query CommunityActivity {
  me {
    ...UserHeaderFragment
  }
  communityActivity {
    questionCount
    answerCount
    upvoteCount
  }
}
    ${UserHeaderFragmentFragmentDoc}`;

/**
 * __useCommunityActivityQuery__
 *
 * To run a query within a React component, call `useCommunityActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunityActivityQuery(baseOptions?: Apollo.QueryHookOptions<CommunityActivityQuery, CommunityActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityActivityQuery, CommunityActivityQueryVariables>(CommunityActivityDocument, options);
      }
export function useCommunityActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityActivityQuery, CommunityActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityActivityQuery, CommunityActivityQueryVariables>(CommunityActivityDocument, options);
        }
export type CommunityActivityQueryHookResult = ReturnType<typeof useCommunityActivityQuery>;
export type CommunityActivityLazyQueryHookResult = ReturnType<typeof useCommunityActivityLazyQuery>;
export type CommunityActivityQueryResult = Apollo.QueryResult<CommunityActivityQuery, CommunityActivityQueryVariables>;
export const QuestionsAnsweredDocument = gql`
    query QuestionsAnswered($where: AnswersWhereInput, $size: Int) {
  answers(where: $where, _size: $size) {
    data {
      ...AnswerFragment
      question {
        id
        title
        createdAt
        topics {
          id
          name
        }
        author {
          ...UserHeaderFragment
        }
        answers {
          count
        }
      }
    }
    after
  }
}
    ${AnswerFragmentFragmentDoc}
${UserHeaderFragmentFragmentDoc}`;

/**
 * __useQuestionsAnsweredQuery__
 *
 * To run a query within a React component, call `useQuestionsAnsweredQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionsAnsweredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionsAnsweredQuery({
 *   variables: {
 *      where: // value for 'where'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useQuestionsAnsweredQuery(baseOptions?: Apollo.QueryHookOptions<QuestionsAnsweredQuery, QuestionsAnsweredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionsAnsweredQuery, QuestionsAnsweredQueryVariables>(QuestionsAnsweredDocument, options);
      }
export function useQuestionsAnsweredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionsAnsweredQuery, QuestionsAnsweredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionsAnsweredQuery, QuestionsAnsweredQueryVariables>(QuestionsAnsweredDocument, options);
        }
export type QuestionsAnsweredQueryHookResult = ReturnType<typeof useQuestionsAnsweredQuery>;
export type QuestionsAnsweredLazyQueryHookResult = ReturnType<typeof useQuestionsAnsweredLazyQuery>;
export type QuestionsAnsweredQueryResult = Apollo.QueryResult<QuestionsAnsweredQuery, QuestionsAnsweredQueryVariables>;
export const MuteChannelDocument = gql`
    mutation MuteChannel($input: MuteChannelInput!) {
  muteChannel(input: $input) {
    id
    mutedUntil
  }
}
    `;
export type MuteChannelMutationFn = Apollo.MutationFunction<MuteChannelMutation, MuteChannelMutationVariables>;

/**
 * __useMuteChannelMutation__
 *
 * To run a mutation, you first call `useMuteChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMuteChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [muteChannelMutation, { data, loading, error }] = useMuteChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMuteChannelMutation(baseOptions?: Apollo.MutationHookOptions<MuteChannelMutation, MuteChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MuteChannelMutation, MuteChannelMutationVariables>(MuteChannelDocument, options);
      }
export type MuteChannelMutationHookResult = ReturnType<typeof useMuteChannelMutation>;
export type MuteChannelMutationResult = Apollo.MutationResult<MuteChannelMutation>;
export type MuteChannelMutationOptions = Apollo.BaseMutationOptions<MuteChannelMutation, MuteChannelMutationVariables>;
export const UnmuteChannelDocument = gql`
    mutation UnmuteChannel($input: UnmuteChannelInput!) {
  unmuteChannel(input: $input) {
    id
    mutedUntil
  }
}
    `;
export type UnmuteChannelMutationFn = Apollo.MutationFunction<UnmuteChannelMutation, UnmuteChannelMutationVariables>;

/**
 * __useUnmuteChannelMutation__
 *
 * To run a mutation, you first call `useUnmuteChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmuteChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmuteChannelMutation, { data, loading, error }] = useUnmuteChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnmuteChannelMutation(baseOptions?: Apollo.MutationHookOptions<UnmuteChannelMutation, UnmuteChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnmuteChannelMutation, UnmuteChannelMutationVariables>(UnmuteChannelDocument, options);
      }
export type UnmuteChannelMutationHookResult = ReturnType<typeof useUnmuteChannelMutation>;
export type UnmuteChannelMutationResult = Apollo.MutationResult<UnmuteChannelMutation>;
export type UnmuteChannelMutationOptions = Apollo.BaseMutationOptions<UnmuteChannelMutation, UnmuteChannelMutationVariables>;
export const CommunityChannelHeaderDocument = gql`
    query CommunityChannelHeader($channelId: MigrateID!) {
  communityPublicChannel(id: $channelId) {
    id
    mutedUntil
    isMember
    name
    members {
      count
    }
    categories {
      id
      name
    }
  }
}
    `;

/**
 * __useCommunityChannelHeaderQuery__
 *
 * To run a query within a React component, call `useCommunityChannelHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityChannelHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityChannelHeaderQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useCommunityChannelHeaderQuery(baseOptions: Apollo.QueryHookOptions<CommunityChannelHeaderQuery, CommunityChannelHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityChannelHeaderQuery, CommunityChannelHeaderQueryVariables>(CommunityChannelHeaderDocument, options);
      }
export function useCommunityChannelHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityChannelHeaderQuery, CommunityChannelHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityChannelHeaderQuery, CommunityChannelHeaderQueryVariables>(CommunityChannelHeaderDocument, options);
        }
export type CommunityChannelHeaderQueryHookResult = ReturnType<typeof useCommunityChannelHeaderQuery>;
export type CommunityChannelHeaderLazyQueryHookResult = ReturnType<typeof useCommunityChannelHeaderLazyQuery>;
export type CommunityChannelHeaderQueryResult = Apollo.QueryResult<CommunityChannelHeaderQuery, CommunityChannelHeaderQueryVariables>;
export const InboxChannelHeaderDocument = gql`
    query InboxChannelHeader($channelId: MigrateID!) {
  channel(id: $channelId) {
    id
    ... on OrganisationPrivateChannel {
      organisation {
        id
        name
      }
      members {
        count
      }
    }
    ... on ApplicationDMChannel {
      application {
        id
        job {
          id
          title
          organisationName
          organisation {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useInboxChannelHeaderQuery__
 *
 * To run a query within a React component, call `useInboxChannelHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxChannelHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxChannelHeaderQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useInboxChannelHeaderQuery(baseOptions: Apollo.QueryHookOptions<InboxChannelHeaderQuery, InboxChannelHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxChannelHeaderQuery, InboxChannelHeaderQueryVariables>(InboxChannelHeaderDocument, options);
      }
export function useInboxChannelHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxChannelHeaderQuery, InboxChannelHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxChannelHeaderQuery, InboxChannelHeaderQueryVariables>(InboxChannelHeaderDocument, options);
        }
export type InboxChannelHeaderQueryHookResult = ReturnType<typeof useInboxChannelHeaderQuery>;
export type InboxChannelHeaderLazyQueryHookResult = ReturnType<typeof useInboxChannelHeaderLazyQuery>;
export type InboxChannelHeaderQueryResult = Apollo.QueryResult<InboxChannelHeaderQuery, InboxChannelHeaderQueryVariables>;
export const LeaveCommunityChannelDocument = gql`
    mutation LeaveCommunityChannel($input: LeaveChannelInput!) {
  leaveChannel(input: $input) {
    channel {
      id
      type
      isMember
      ... on CommunityPublicChannel {
        name
      }
    }
  }
}
    `;
export type LeaveCommunityChannelMutationFn = Apollo.MutationFunction<LeaveCommunityChannelMutation, LeaveCommunityChannelMutationVariables>;

/**
 * __useLeaveCommunityChannelMutation__
 *
 * To run a mutation, you first call `useLeaveCommunityChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveCommunityChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveCommunityChannelMutation, { data, loading, error }] = useLeaveCommunityChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeaveCommunityChannelMutation(baseOptions?: Apollo.MutationHookOptions<LeaveCommunityChannelMutation, LeaveCommunityChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveCommunityChannelMutation, LeaveCommunityChannelMutationVariables>(LeaveCommunityChannelDocument, options);
      }
export type LeaveCommunityChannelMutationHookResult = ReturnType<typeof useLeaveCommunityChannelMutation>;
export type LeaveCommunityChannelMutationResult = Apollo.MutationResult<LeaveCommunityChannelMutation>;
export type LeaveCommunityChannelMutationOptions = Apollo.BaseMutationOptions<LeaveCommunityChannelMutation, LeaveCommunityChannelMutationVariables>;
export const ChannelCategoriesFilterDocument = gql`
    query ChannelCategoriesFilter {
  channelCategories(_size: 100) {
    data {
      ...ChannelCategoryFilterProps
    }
  }
}
    ${ChannelCategoryFilterPropsFragmentDoc}`;

/**
 * __useChannelCategoriesFilterQuery__
 *
 * To run a query within a React component, call `useChannelCategoriesFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelCategoriesFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelCategoriesFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useChannelCategoriesFilterQuery(baseOptions?: Apollo.QueryHookOptions<ChannelCategoriesFilterQuery, ChannelCategoriesFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelCategoriesFilterQuery, ChannelCategoriesFilterQueryVariables>(ChannelCategoriesFilterDocument, options);
      }
export function useChannelCategoriesFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelCategoriesFilterQuery, ChannelCategoriesFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelCategoriesFilterQuery, ChannelCategoriesFilterQueryVariables>(ChannelCategoriesFilterDocument, options);
        }
export type ChannelCategoriesFilterQueryHookResult = ReturnType<typeof useChannelCategoriesFilterQuery>;
export type ChannelCategoriesFilterLazyQueryHookResult = ReturnType<typeof useChannelCategoriesFilterLazyQuery>;
export type ChannelCategoriesFilterQueryResult = Apollo.QueryResult<ChannelCategoriesFilterQuery, ChannelCategoriesFilterQueryVariables>;
export const CommunityChannelCardHeaderDocument = gql`
    query CommunityChannelCardHeader($channelId: MigrateID!) {
  communityPublicChannel(id: $channelId) {
    ...CommunityChannelCardHeaderChannelFragment
    members(_size: 2) {
      ...CommunityChannelCardHeaderMembersFragment
    }
    messages(_size: 2) {
      data {
        id
        author {
          ...CommunityChannelCardHeaderUserFragment
        }
      }
    }
  }
}
    ${CommunityChannelCardHeaderChannelFragmentFragmentDoc}
${CommunityChannelCardHeaderMembersFragmentFragmentDoc}
${CommunityChannelCardHeaderUserFragmentFragmentDoc}`;

/**
 * __useCommunityChannelCardHeaderQuery__
 *
 * To run a query within a React component, call `useCommunityChannelCardHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityChannelCardHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityChannelCardHeaderQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useCommunityChannelCardHeaderQuery(baseOptions: Apollo.QueryHookOptions<CommunityChannelCardHeaderQuery, CommunityChannelCardHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityChannelCardHeaderQuery, CommunityChannelCardHeaderQueryVariables>(CommunityChannelCardHeaderDocument, options);
      }
export function useCommunityChannelCardHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityChannelCardHeaderQuery, CommunityChannelCardHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityChannelCardHeaderQuery, CommunityChannelCardHeaderQueryVariables>(CommunityChannelCardHeaderDocument, options);
        }
export type CommunityChannelCardHeaderQueryHookResult = ReturnType<typeof useCommunityChannelCardHeaderQuery>;
export type CommunityChannelCardHeaderLazyQueryHookResult = ReturnType<typeof useCommunityChannelCardHeaderLazyQuery>;
export type CommunityChannelCardHeaderQueryResult = Apollo.QueryResult<CommunityChannelCardHeaderQuery, CommunityChannelCardHeaderQueryVariables>;
export const JoinedCommunityChannelCardDocument = gql`
    query JoinedCommunityChannelCard($channelId: MigrateID!) {
  communityPublicChannel(id: $channelId) {
    ...JoinedCommunityChannel
  }
}
    ${JoinedCommunityChannelFragmentDoc}`;

/**
 * __useJoinedCommunityChannelCardQuery__
 *
 * To run a query within a React component, call `useJoinedCommunityChannelCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useJoinedCommunityChannelCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJoinedCommunityChannelCardQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useJoinedCommunityChannelCardQuery(baseOptions: Apollo.QueryHookOptions<JoinedCommunityChannelCardQuery, JoinedCommunityChannelCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JoinedCommunityChannelCardQuery, JoinedCommunityChannelCardQueryVariables>(JoinedCommunityChannelCardDocument, options);
      }
export function useJoinedCommunityChannelCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JoinedCommunityChannelCardQuery, JoinedCommunityChannelCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JoinedCommunityChannelCardQuery, JoinedCommunityChannelCardQueryVariables>(JoinedCommunityChannelCardDocument, options);
        }
export type JoinedCommunityChannelCardQueryHookResult = ReturnType<typeof useJoinedCommunityChannelCardQuery>;
export type JoinedCommunityChannelCardLazyQueryHookResult = ReturnType<typeof useJoinedCommunityChannelCardLazyQuery>;
export type JoinedCommunityChannelCardQueryResult = Apollo.QueryResult<JoinedCommunityChannelCardQuery, JoinedCommunityChannelCardQueryVariables>;
export const CommunityHomeChannelsDocument = gql`
    query CommunityHomeChannels($size: Int, $after: String, $orderBy: ChannelsOrderBy, $where: JoinedChannelsWhereInput) {
  joinedChannels(where: $where, orderBy: $orderBy, _size: $size, _cursor: $after) {
    data {
      id
      ...JoinedCommunityChannel
    }
    after
  }
}
    ${JoinedCommunityChannelFragmentDoc}`;

/**
 * __useCommunityHomeChannelsQuery__
 *
 * To run a query within a React component, call `useCommunityHomeChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityHomeChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityHomeChannelsQuery({
 *   variables: {
 *      size: // value for 'size'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCommunityHomeChannelsQuery(baseOptions?: Apollo.QueryHookOptions<CommunityHomeChannelsQuery, CommunityHomeChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityHomeChannelsQuery, CommunityHomeChannelsQueryVariables>(CommunityHomeChannelsDocument, options);
      }
export function useCommunityHomeChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityHomeChannelsQuery, CommunityHomeChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityHomeChannelsQuery, CommunityHomeChannelsQueryVariables>(CommunityHomeChannelsDocument, options);
        }
export type CommunityHomeChannelsQueryHookResult = ReturnType<typeof useCommunityHomeChannelsQuery>;
export type CommunityHomeChannelsLazyQueryHookResult = ReturnType<typeof useCommunityHomeChannelsLazyQuery>;
export type CommunityHomeChannelsQueryResult = Apollo.QueryResult<CommunityHomeChannelsQuery, CommunityHomeChannelsQueryVariables>;
export const MessagePreviewDocument = gql`
    query MessagePreview($messageId: MigrateID!) {
  message(id: $messageId) {
    ...MessagePreviewFragment
  }
}
    ${MessagePreviewFragmentFragmentDoc}`;

/**
 * __useMessagePreviewQuery__
 *
 * To run a query within a React component, call `useMessagePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagePreviewQuery({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useMessagePreviewQuery(baseOptions: Apollo.QueryHookOptions<MessagePreviewQuery, MessagePreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagePreviewQuery, MessagePreviewQueryVariables>(MessagePreviewDocument, options);
      }
export function useMessagePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagePreviewQuery, MessagePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagePreviewQuery, MessagePreviewQueryVariables>(MessagePreviewDocument, options);
        }
export type MessagePreviewQueryHookResult = ReturnType<typeof useMessagePreviewQuery>;
export type MessagePreviewLazyQueryHookResult = ReturnType<typeof useMessagePreviewLazyQuery>;
export type MessagePreviewQueryResult = Apollo.QueryResult<MessagePreviewQuery, MessagePreviewQueryVariables>;
export const OverviewCommunityChannelCardDocument = gql`
    query OverviewCommunityChannelCard($channelId: MigrateID!) {
  communityPublicChannel(id: $channelId) {
    ...OverviewCommunityChannelCardChannelProps
  }
}
    ${OverviewCommunityChannelCardChannelPropsFragmentDoc}`;

/**
 * __useOverviewCommunityChannelCardQuery__
 *
 * To run a query within a React component, call `useOverviewCommunityChannelCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewCommunityChannelCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewCommunityChannelCardQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useOverviewCommunityChannelCardQuery(baseOptions: Apollo.QueryHookOptions<OverviewCommunityChannelCardQuery, OverviewCommunityChannelCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverviewCommunityChannelCardQuery, OverviewCommunityChannelCardQueryVariables>(OverviewCommunityChannelCardDocument, options);
      }
export function useOverviewCommunityChannelCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverviewCommunityChannelCardQuery, OverviewCommunityChannelCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverviewCommunityChannelCardQuery, OverviewCommunityChannelCardQueryVariables>(OverviewCommunityChannelCardDocument, options);
        }
export type OverviewCommunityChannelCardQueryHookResult = ReturnType<typeof useOverviewCommunityChannelCardQuery>;
export type OverviewCommunityChannelCardLazyQueryHookResult = ReturnType<typeof useOverviewCommunityChannelCardLazyQuery>;
export type OverviewCommunityChannelCardQueryResult = Apollo.QueryResult<OverviewCommunityChannelCardQuery, OverviewCommunityChannelCardQueryVariables>;
export const AllCommunityChannelsDocument = gql`
    query AllCommunityChannels($size: Int, $after: String, $orderBy: ChannelsOrderBy, $where: CommunityPublicChannelsWhereInput) {
  communityPublicChannels(
    where: $where
    orderBy: $orderBy
    _size: $size
    _cursor: $after
  ) {
    data {
      ...OverviewCommunityChannelCardChannelProps
      isMember
    }
    after
  }
  channelCategories {
    data {
      ...ChannelCategoryFilterProps
    }
  }
}
    ${OverviewCommunityChannelCardChannelPropsFragmentDoc}
${ChannelCategoryFilterPropsFragmentDoc}`;

/**
 * __useAllCommunityChannelsQuery__
 *
 * To run a query within a React component, call `useAllCommunityChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCommunityChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCommunityChannelsQuery({
 *   variables: {
 *      size: // value for 'size'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAllCommunityChannelsQuery(baseOptions?: Apollo.QueryHookOptions<AllCommunityChannelsQuery, AllCommunityChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCommunityChannelsQuery, AllCommunityChannelsQueryVariables>(AllCommunityChannelsDocument, options);
      }
export function useAllCommunityChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCommunityChannelsQuery, AllCommunityChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCommunityChannelsQuery, AllCommunityChannelsQueryVariables>(AllCommunityChannelsDocument, options);
        }
export type AllCommunityChannelsQueryHookResult = ReturnType<typeof useAllCommunityChannelsQuery>;
export type AllCommunityChannelsLazyQueryHookResult = ReturnType<typeof useAllCommunityChannelsLazyQuery>;
export type AllCommunityChannelsQueryResult = Apollo.QueryResult<AllCommunityChannelsQuery, AllCommunityChannelsQueryVariables>;
export const CommunityChannelFooterDocument = gql`
    query CommunityChannelFooter($channelId: MigrateID!) {
  communityPublicChannel(id: $channelId) {
    id
    isMember
  }
}
    `;

/**
 * __useCommunityChannelFooterQuery__
 *
 * To run a query within a React component, call `useCommunityChannelFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityChannelFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityChannelFooterQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useCommunityChannelFooterQuery(baseOptions: Apollo.QueryHookOptions<CommunityChannelFooterQuery, CommunityChannelFooterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityChannelFooterQuery, CommunityChannelFooterQueryVariables>(CommunityChannelFooterDocument, options);
      }
export function useCommunityChannelFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityChannelFooterQuery, CommunityChannelFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityChannelFooterQuery, CommunityChannelFooterQueryVariables>(CommunityChannelFooterDocument, options);
        }
export type CommunityChannelFooterQueryHookResult = ReturnType<typeof useCommunityChannelFooterQuery>;
export type CommunityChannelFooterLazyQueryHookResult = ReturnType<typeof useCommunityChannelFooterLazyQuery>;
export type CommunityChannelFooterQueryResult = Apollo.QueryResult<CommunityChannelFooterQuery, CommunityChannelFooterQueryVariables>;
export const JoinedChannelsDocument = gql`
    query JoinedChannels($size: Int, $after: String, $orderBy: ChannelsOrderBy, $where: JoinedChannelsWhereInput) {
  joinedChannels(where: $where, orderBy: $orderBy, _size: $size, _cursor: $after) {
    data {
      id
      ...ApplicationDMChannelListCardProps
      ...OrganisationPrivateChannelListCardProps
      ...CommunityPublicChannelListCardProps
    }
    after
  }
}
    ${ApplicationDmChannelListCardPropsFragmentDoc}
${OrganisationPrivateChannelListCardPropsFragmentDoc}
${CommunityPublicChannelListCardPropsFragmentDoc}`;

/**
 * __useJoinedChannelsQuery__
 *
 * To run a query within a React component, call `useJoinedChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJoinedChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJoinedChannelsQuery({
 *   variables: {
 *      size: // value for 'size'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useJoinedChannelsQuery(baseOptions?: Apollo.QueryHookOptions<JoinedChannelsQuery, JoinedChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JoinedChannelsQuery, JoinedChannelsQueryVariables>(JoinedChannelsDocument, options);
      }
export function useJoinedChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JoinedChannelsQuery, JoinedChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JoinedChannelsQuery, JoinedChannelsQueryVariables>(JoinedChannelsDocument, options);
        }
export type JoinedChannelsQueryHookResult = ReturnType<typeof useJoinedChannelsQuery>;
export type JoinedChannelsLazyQueryHookResult = ReturnType<typeof useJoinedChannelsLazyQuery>;
export type JoinedChannelsQueryResult = Apollo.QueryResult<JoinedChannelsQuery, JoinedChannelsQueryVariables>;
export const JoinCommunityChannelDocument = gql`
    mutation JoinCommunityChannel($input: JoinChannelInput!) {
  joinChannel(input: $input) {
    channel {
      id
      isMember
    }
  }
}
    `;
export type JoinCommunityChannelMutationFn = Apollo.MutationFunction<JoinCommunityChannelMutation, JoinCommunityChannelMutationVariables>;

/**
 * __useJoinCommunityChannelMutation__
 *
 * To run a mutation, you first call `useJoinCommunityChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCommunityChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCommunityChannelMutation, { data, loading, error }] = useJoinCommunityChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinCommunityChannelMutation(baseOptions?: Apollo.MutationHookOptions<JoinCommunityChannelMutation, JoinCommunityChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinCommunityChannelMutation, JoinCommunityChannelMutationVariables>(JoinCommunityChannelDocument, options);
      }
export type JoinCommunityChannelMutationHookResult = ReturnType<typeof useJoinCommunityChannelMutation>;
export type JoinCommunityChannelMutationResult = Apollo.MutationResult<JoinCommunityChannelMutation>;
export type JoinCommunityChannelMutationOptions = Apollo.BaseMutationOptions<JoinCommunityChannelMutation, JoinCommunityChannelMutationVariables>;
export const MuteAllChannelsDocument = gql`
    mutation muteAllChannels($input: MuteAllChannelsInput!) {
  muteAllChannels(input: $input) {
    id
    notificationsMutedUntil
  }
}
    `;
export type MuteAllChannelsMutationFn = Apollo.MutationFunction<MuteAllChannelsMutation, MuteAllChannelsMutationVariables>;

/**
 * __useMuteAllChannelsMutation__
 *
 * To run a mutation, you first call `useMuteAllChannelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMuteAllChannelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [muteAllChannelsMutation, { data, loading, error }] = useMuteAllChannelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMuteAllChannelsMutation(baseOptions?: Apollo.MutationHookOptions<MuteAllChannelsMutation, MuteAllChannelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MuteAllChannelsMutation, MuteAllChannelsMutationVariables>(MuteAllChannelsDocument, options);
      }
export type MuteAllChannelsMutationHookResult = ReturnType<typeof useMuteAllChannelsMutation>;
export type MuteAllChannelsMutationResult = Apollo.MutationResult<MuteAllChannelsMutation>;
export type MuteAllChannelsMutationOptions = Apollo.BaseMutationOptions<MuteAllChannelsMutation, MuteAllChannelsMutationVariables>;
export const UnmuteAllChannelsDocument = gql`
    mutation unmuteAllChannels {
  unmuteAllChannels {
    id
    notificationsMutedUntil
  }
}
    `;
export type UnmuteAllChannelsMutationFn = Apollo.MutationFunction<UnmuteAllChannelsMutation, UnmuteAllChannelsMutationVariables>;

/**
 * __useUnmuteAllChannelsMutation__
 *
 * To run a mutation, you first call `useUnmuteAllChannelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmuteAllChannelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmuteAllChannelsMutation, { data, loading, error }] = useUnmuteAllChannelsMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnmuteAllChannelsMutation(baseOptions?: Apollo.MutationHookOptions<UnmuteAllChannelsMutation, UnmuteAllChannelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnmuteAllChannelsMutation, UnmuteAllChannelsMutationVariables>(UnmuteAllChannelsDocument, options);
      }
export type UnmuteAllChannelsMutationHookResult = ReturnType<typeof useUnmuteAllChannelsMutation>;
export type UnmuteAllChannelsMutationResult = Apollo.MutationResult<UnmuteAllChannelsMutation>;
export type UnmuteAllChannelsMutationOptions = Apollo.BaseMutationOptions<UnmuteAllChannelsMutation, UnmuteAllChannelsMutationVariables>;
export const AnswerQuestionDocument = gql`
    mutation AnswerQuestion($input: AnswerQuestionInput!) {
  answerQuestion(input: $input) {
    ...AnswerFragment
    question {
      id
      myAnswer {
        id
      }
    }
  }
}
    ${AnswerFragmentFragmentDoc}`;
export type AnswerQuestionMutationFn = Apollo.MutationFunction<AnswerQuestionMutation, AnswerQuestionMutationVariables>;

/**
 * __useAnswerQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerQuestionMutation, { data, loading, error }] = useAnswerQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AnswerQuestionMutation, AnswerQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerQuestionMutation, AnswerQuestionMutationVariables>(AnswerQuestionDocument, options);
      }
export type AnswerQuestionMutationHookResult = ReturnType<typeof useAnswerQuestionMutation>;
export type AnswerQuestionMutationResult = Apollo.MutationResult<AnswerQuestionMutation>;
export type AnswerQuestionMutationOptions = Apollo.BaseMutationOptions<AnswerQuestionMutation, AnswerQuestionMutationVariables>;
export const AnswerDocument = gql`
    query Answer($answerId: MigrateID!) {
  answer(id: $answerId) {
    ...AnswerFragment
  }
}
    ${AnswerFragmentFragmentDoc}`;

/**
 * __useAnswerQuery__
 *
 * To run a query within a React component, call `useAnswerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnswerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnswerQuery({
 *   variables: {
 *      answerId: // value for 'answerId'
 *   },
 * });
 */
export function useAnswerQuery(baseOptions: Apollo.QueryHookOptions<AnswerQuery, AnswerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnswerQuery, AnswerQueryVariables>(AnswerDocument, options);
      }
export function useAnswerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnswerQuery, AnswerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnswerQuery, AnswerQueryVariables>(AnswerDocument, options);
        }
export type AnswerQueryHookResult = ReturnType<typeof useAnswerQuery>;
export type AnswerLazyQueryHookResult = ReturnType<typeof useAnswerLazyQuery>;
export type AnswerQueryResult = Apollo.QueryResult<AnswerQuery, AnswerQueryVariables>;
export const QuestionTopicsDocument = gql`
    query QuestionTopics {
  questionTopics {
    id
    name
  }
}
    `;

/**
 * __useQuestionTopicsQuery__
 *
 * To run a query within a React component, call `useQuestionTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuestionTopicsQuery(baseOptions?: Apollo.QueryHookOptions<QuestionTopicsQuery, QuestionTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionTopicsQuery, QuestionTopicsQueryVariables>(QuestionTopicsDocument, options);
      }
export function useQuestionTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionTopicsQuery, QuestionTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionTopicsQuery, QuestionTopicsQueryVariables>(QuestionTopicsDocument, options);
        }
export type QuestionTopicsQueryHookResult = ReturnType<typeof useQuestionTopicsQuery>;
export type QuestionTopicsLazyQueryHookResult = ReturnType<typeof useQuestionTopicsLazyQuery>;
export type QuestionTopicsQueryResult = Apollo.QueryResult<QuestionTopicsQuery, QuestionTopicsQueryVariables>;
export const AskQuestionDocument = gql`
    mutation AskQuestion($input: AskQuestionInput!) {
  askQuestion(input: $input) {
    id
    title
  }
}
    `;
export type AskQuestionMutationFn = Apollo.MutationFunction<AskQuestionMutation, AskQuestionMutationVariables>;

/**
 * __useAskQuestionMutation__
 *
 * To run a mutation, you first call `useAskQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAskQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [askQuestionMutation, { data, loading, error }] = useAskQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAskQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AskQuestionMutation, AskQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AskQuestionMutation, AskQuestionMutationVariables>(AskQuestionDocument, options);
      }
export type AskQuestionMutationHookResult = ReturnType<typeof useAskQuestionMutation>;
export type AskQuestionMutationResult = Apollo.MutationResult<AskQuestionMutation>;
export type AskQuestionMutationOptions = Apollo.BaseMutationOptions<AskQuestionMutation, AskQuestionMutationVariables>;
export const DeleteQuestionDocument = gql`
    mutation DeleteQuestion($input: DeleteQuestionInput!) {
  deleteQuestion(input: $input) {
    id
  }
}
    `;
export type DeleteQuestionMutationFn = Apollo.MutationFunction<DeleteQuestionMutation, DeleteQuestionMutationVariables>;

/**
 * __useDeleteQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionMutation, { data, loading, error }] = useDeleteQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuestionMutation, DeleteQuestionMutationVariables>(DeleteQuestionDocument, options);
      }
export type DeleteQuestionMutationHookResult = ReturnType<typeof useDeleteQuestionMutation>;
export type DeleteQuestionMutationResult = Apollo.MutationResult<DeleteQuestionMutation>;
export type DeleteQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>;
export const DeleteAnswerDocument = gql`
    mutation DeleteAnswer($input: DeleteAnswerInput!) {
  deleteAnswer(input: $input) {
    id
  }
}
    `;
export type DeleteAnswerMutationFn = Apollo.MutationFunction<DeleteAnswerMutation, DeleteAnswerMutationVariables>;

/**
 * __useDeleteAnswerMutation__
 *
 * To run a mutation, you first call `useDeleteAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnswerMutation, { data, loading, error }] = useDeleteAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAnswerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnswerMutation, DeleteAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnswerMutation, DeleteAnswerMutationVariables>(DeleteAnswerDocument, options);
      }
export type DeleteAnswerMutationHookResult = ReturnType<typeof useDeleteAnswerMutation>;
export type DeleteAnswerMutationResult = Apollo.MutationResult<DeleteAnswerMutation>;
export type DeleteAnswerMutationOptions = Apollo.BaseMutationOptions<DeleteAnswerMutation, DeleteAnswerMutationVariables>;
export const ToggleAnswerVoteDocument = gql`
    mutation ToggleAnswerVote($input: ToggleAnswerVoteInput!) {
  toggleAnswerVote(input: $input) {
    answerVote {
      id
    }
    deleted
  }
}
    `;
export type ToggleAnswerVoteMutationFn = Apollo.MutationFunction<ToggleAnswerVoteMutation, ToggleAnswerVoteMutationVariables>;

/**
 * __useToggleAnswerVoteMutation__
 *
 * To run a mutation, you first call `useToggleAnswerVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAnswerVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAnswerVoteMutation, { data, loading, error }] = useToggleAnswerVoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleAnswerVoteMutation(baseOptions?: Apollo.MutationHookOptions<ToggleAnswerVoteMutation, ToggleAnswerVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleAnswerVoteMutation, ToggleAnswerVoteMutationVariables>(ToggleAnswerVoteDocument, options);
      }
export type ToggleAnswerVoteMutationHookResult = ReturnType<typeof useToggleAnswerVoteMutation>;
export type ToggleAnswerVoteMutationResult = Apollo.MutationResult<ToggleAnswerVoteMutation>;
export type ToggleAnswerVoteMutationOptions = Apollo.BaseMutationOptions<ToggleAnswerVoteMutation, ToggleAnswerVoteMutationVariables>;
export const QuestionDocument = gql`
    query Question($id: MigrateID!, $answersOrderBy: AnswersOrderBy, $after: String) {
  question(id: $id) {
    id
    title
    topics {
      id
      name
    }
    author {
      id
      forenames
      photoUrl
      isActive
    }
    createdAt
    myAnswer {
      id
    }
    answers(orderBy: $answersOrderBy, _cursor: $after) {
      count
      data {
        ...AnswerFragment
      }
      after
    }
  }
}
    ${AnswerFragmentFragmentDoc}`;

/**
 * __useQuestionQuery__
 *
 * To run a query within a React component, call `useQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      answersOrderBy: // value for 'answersOrderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useQuestionQuery(baseOptions: Apollo.QueryHookOptions<QuestionQuery, QuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionQuery, QuestionQueryVariables>(QuestionDocument, options);
      }
export function useQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionQuery, QuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionQuery, QuestionQueryVariables>(QuestionDocument, options);
        }
export type QuestionQueryHookResult = ReturnType<typeof useQuestionQuery>;
export type QuestionLazyQueryHookResult = ReturnType<typeof useQuestionLazyQuery>;
export type QuestionQueryResult = Apollo.QueryResult<QuestionQuery, QuestionQueryVariables>;
export const QuestionsDocument = gql`
    query Questions($where: QuestionsWhereInput, $orderBy: QuestionsOrderBy, $size: Int, $after: String) {
  questions(where: $where, orderBy: $orderBy, _cursor: $after, _size: $size) {
    data {
      id
      title
      createdAt
      topics {
        id
        name
      }
      highlightedAnswer {
        ...AnswerFragment
      }
      answers {
        count
      }
      author {
        id
        forenames
        photoUrl
        isActive
      }
    }
    after
  }
}
    ${AnswerFragmentFragmentDoc}`;

/**
 * __useQuestionsQuery__
 *
 * To run a query within a React component, call `useQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      size: // value for 'size'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<QuestionsQuery, QuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionsQuery, QuestionsQueryVariables>(QuestionsDocument, options);
      }
export function useQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionsQuery, QuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionsQuery, QuestionsQueryVariables>(QuestionsDocument, options);
        }
export type QuestionsQueryHookResult = ReturnType<typeof useQuestionsQuery>;
export type QuestionsLazyQueryHookResult = ReturnType<typeof useQuestionsLazyQuery>;
export type QuestionsQueryResult = Apollo.QueryResult<QuestionsQuery, QuestionsQueryVariables>;
export const UserHeaderDocument = gql`
    query UserHeader($userId: MigrateID!) {
  user(id: $userId) {
    ...UserHeaderFragment
  }
}
    ${UserHeaderFragmentFragmentDoc}`;

/**
 * __useUserHeaderQuery__
 *
 * To run a query within a React component, call `useUserHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHeaderQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserHeaderQuery(baseOptions: Apollo.QueryHookOptions<UserHeaderQuery, UserHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserHeaderQuery, UserHeaderQueryVariables>(UserHeaderDocument, options);
      }
export function useUserHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserHeaderQuery, UserHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserHeaderQuery, UserHeaderQueryVariables>(UserHeaderDocument, options);
        }
export type UserHeaderQueryHookResult = ReturnType<typeof useUserHeaderQuery>;
export type UserHeaderLazyQueryHookResult = ReturnType<typeof useUserHeaderLazyQuery>;
export type UserHeaderQueryResult = Apollo.QueryResult<UserHeaderQuery, UserHeaderQueryVariables>;
export const UpdateCareerQuizResultDocument = gql`
    mutation UpdateCareerQuizResult($input: UpdateCareerQuizResultInput!) {
  updateCareerQuizResult(input: $input) {
    id
    careerQuizResult
  }
}
    `;
export type UpdateCareerQuizResultMutationFn = Apollo.MutationFunction<UpdateCareerQuizResultMutation, UpdateCareerQuizResultMutationVariables>;

/**
 * __useUpdateCareerQuizResultMutation__
 *
 * To run a mutation, you first call `useUpdateCareerQuizResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCareerQuizResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCareerQuizResultMutation, { data, loading, error }] = useUpdateCareerQuizResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCareerQuizResultMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCareerQuizResultMutation, UpdateCareerQuizResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCareerQuizResultMutation, UpdateCareerQuizResultMutationVariables>(UpdateCareerQuizResultDocument, options);
      }
export type UpdateCareerQuizResultMutationHookResult = ReturnType<typeof useUpdateCareerQuizResultMutation>;
export type UpdateCareerQuizResultMutationResult = Apollo.MutationResult<UpdateCareerQuizResultMutation>;
export type UpdateCareerQuizResultMutationOptions = Apollo.BaseMutationOptions<UpdateCareerQuizResultMutation, UpdateCareerQuizResultMutationVariables>;
export const MyDocumentsDocument = gql`
    query MyDocuments {
  me {
    id
    ... on CandidateV2 {
      documents(_size: 100) {
        data {
          id
          createdAt
          url
          filename
          type
          typeProps {
            name
          }
          canDelete
        }
        after
        count
      }
    }
  }
}
    `;

/**
 * __useMyDocumentsQuery__
 *
 * To run a query within a React component, call `useMyDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<MyDocumentsQuery, MyDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyDocumentsQuery, MyDocumentsQueryVariables>(MyDocumentsDocument, options);
      }
export function useMyDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyDocumentsQuery, MyDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyDocumentsQuery, MyDocumentsQueryVariables>(MyDocumentsDocument, options);
        }
export type MyDocumentsQueryHookResult = ReturnType<typeof useMyDocumentsQuery>;
export type MyDocumentsLazyQueryHookResult = ReturnType<typeof useMyDocumentsLazyQuery>;
export type MyDocumentsQueryResult = Apollo.QueryResult<MyDocumentsQuery, MyDocumentsQueryVariables>;
export const DocumentTypesDocument = gql`
    query DocumentTypes {
  documentTypes {
    type
    name
  }
}
    `;

/**
 * __useDocumentTypesQuery__
 *
 * To run a query within a React component, call `useDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentTypesQuery(baseOptions?: Apollo.QueryHookOptions<DocumentTypesQuery, DocumentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentTypesQuery, DocumentTypesQueryVariables>(DocumentTypesDocument, options);
      }
export function useDocumentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentTypesQuery, DocumentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentTypesQuery, DocumentTypesQueryVariables>(DocumentTypesDocument, options);
        }
export type DocumentTypesQueryHookResult = ReturnType<typeof useDocumentTypesQuery>;
export type DocumentTypesLazyQueryHookResult = ReturnType<typeof useDocumentTypesLazyQuery>;
export type DocumentTypesQueryResult = Apollo.QueryResult<DocumentTypesQuery, DocumentTypesQueryVariables>;
export const HomeScreenDocument = gql`
    query HomeScreen {
  me {
    id
    ... on CandidateV2 {
      hasSetPreferences
      profession {
        id
      }
      careerQuizResult
    }
  }
}
    `;

/**
 * __useHomeScreenQuery__
 *
 * To run a query within a React component, call `useHomeScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeScreenQuery(baseOptions?: Apollo.QueryHookOptions<HomeScreenQuery, HomeScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeScreenQuery, HomeScreenQueryVariables>(HomeScreenDocument, options);
      }
export function useHomeScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeScreenQuery, HomeScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeScreenQuery, HomeScreenQueryVariables>(HomeScreenDocument, options);
        }
export type HomeScreenQueryHookResult = ReturnType<typeof useHomeScreenQuery>;
export type HomeScreenLazyQueryHookResult = ReturnType<typeof useHomeScreenLazyQuery>;
export type HomeScreenQueryResult = Apollo.QueryResult<HomeScreenQuery, HomeScreenQueryVariables>;
export const ApplyToJobMatchDocument = gql`
    mutation ApplyToJobMatch($jobId: MigrateID!) {
  respondToMatch(input: {jobId: $jobId, type: APPLICATION_START}) {
    ...JobMatchActionMatchResponseProps
  }
}
    ${JobMatchActionMatchResponsePropsFragmentDoc}`;
export type ApplyToJobMatchMutationFn = Apollo.MutationFunction<ApplyToJobMatchMutation, ApplyToJobMatchMutationVariables>;

/**
 * __useApplyToJobMatchMutation__
 *
 * To run a mutation, you first call `useApplyToJobMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyToJobMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyToJobMatchMutation, { data, loading, error }] = useApplyToJobMatchMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useApplyToJobMatchMutation(baseOptions?: Apollo.MutationHookOptions<ApplyToJobMatchMutation, ApplyToJobMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyToJobMatchMutation, ApplyToJobMatchMutationVariables>(ApplyToJobMatchDocument, options);
      }
export type ApplyToJobMatchMutationHookResult = ReturnType<typeof useApplyToJobMatchMutation>;
export type ApplyToJobMatchMutationResult = Apollo.MutationResult<ApplyToJobMatchMutation>;
export type ApplyToJobMatchMutationOptions = Apollo.BaseMutationOptions<ApplyToJobMatchMutation, ApplyToJobMatchMutationVariables>;
export const ApplicationStartActionButtonDocument = gql`
    query ApplicationStartActionButton {
  me {
    id
    ... on CandidateV2 {
      canApply
    }
  }
}
    `;

/**
 * __useApplicationStartActionButtonQuery__
 *
 * To run a query within a React component, call `useApplicationStartActionButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationStartActionButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationStartActionButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useApplicationStartActionButtonQuery(baseOptions?: Apollo.QueryHookOptions<ApplicationStartActionButtonQuery, ApplicationStartActionButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationStartActionButtonQuery, ApplicationStartActionButtonQueryVariables>(ApplicationStartActionButtonDocument, options);
      }
export function useApplicationStartActionButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationStartActionButtonQuery, ApplicationStartActionButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationStartActionButtonQuery, ApplicationStartActionButtonQueryVariables>(ApplicationStartActionButtonDocument, options);
        }
export type ApplicationStartActionButtonQueryHookResult = ReturnType<typeof useApplicationStartActionButtonQuery>;
export type ApplicationStartActionButtonLazyQueryHookResult = ReturnType<typeof useApplicationStartActionButtonLazyQuery>;
export type ApplicationStartActionButtonQueryResult = Apollo.QueryResult<ApplicationStartActionButtonQuery, ApplicationStartActionButtonQueryVariables>;
export const HideJobMatchDocument = gql`
    mutation HideJobMatch($jobId: MigrateID!) {
  respondToMatch(input: {jobId: $jobId, type: HIDE}) {
    ...JobMatchActionMatchResponseProps
  }
}
    ${JobMatchActionMatchResponsePropsFragmentDoc}`;
export type HideJobMatchMutationFn = Apollo.MutationFunction<HideJobMatchMutation, HideJobMatchMutationVariables>;

/**
 * __useHideJobMatchMutation__
 *
 * To run a mutation, you first call `useHideJobMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideJobMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideJobMatchMutation, { data, loading, error }] = useHideJobMatchMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useHideJobMatchMutation(baseOptions?: Apollo.MutationHookOptions<HideJobMatchMutation, HideJobMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideJobMatchMutation, HideJobMatchMutationVariables>(HideJobMatchDocument, options);
      }
export type HideJobMatchMutationHookResult = ReturnType<typeof useHideJobMatchMutation>;
export type HideJobMatchMutationResult = Apollo.MutationResult<HideJobMatchMutation>;
export type HideJobMatchMutationOptions = Apollo.BaseMutationOptions<HideJobMatchMutation, HideJobMatchMutationVariables>;
export const SaveJobMatchDocument = gql`
    mutation SaveJobMatch($jobId: MigrateID!) {
  respondToMatch(input: {jobId: $jobId, type: SAVE}) {
    ...JobMatchActionMatchResponseProps
  }
}
    ${JobMatchActionMatchResponsePropsFragmentDoc}`;
export type SaveJobMatchMutationFn = Apollo.MutationFunction<SaveJobMatchMutation, SaveJobMatchMutationVariables>;

/**
 * __useSaveJobMatchMutation__
 *
 * To run a mutation, you first call `useSaveJobMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveJobMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveJobMatchMutation, { data, loading, error }] = useSaveJobMatchMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useSaveJobMatchMutation(baseOptions?: Apollo.MutationHookOptions<SaveJobMatchMutation, SaveJobMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveJobMatchMutation, SaveJobMatchMutationVariables>(SaveJobMatchDocument, options);
      }
export type SaveJobMatchMutationHookResult = ReturnType<typeof useSaveJobMatchMutation>;
export type SaveJobMatchMutationResult = Apollo.MutationResult<SaveJobMatchMutation>;
export type SaveJobMatchMutationOptions = Apollo.BaseMutationOptions<SaveJobMatchMutation, SaveJobMatchMutationVariables>;
export const UnhideJobMatchDocument = gql`
    mutation UnhideJobMatch($id: MigrateID!) {
  removeMatchResponse(input: {id: $id}) {
    ...JobMatchActionMatchResponseProps
  }
}
    ${JobMatchActionMatchResponsePropsFragmentDoc}`;
export type UnhideJobMatchMutationFn = Apollo.MutationFunction<UnhideJobMatchMutation, UnhideJobMatchMutationVariables>;

/**
 * __useUnhideJobMatchMutation__
 *
 * To run a mutation, you first call `useUnhideJobMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnhideJobMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unhideJobMatchMutation, { data, loading, error }] = useUnhideJobMatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnhideJobMatchMutation(baseOptions?: Apollo.MutationHookOptions<UnhideJobMatchMutation, UnhideJobMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnhideJobMatchMutation, UnhideJobMatchMutationVariables>(UnhideJobMatchDocument, options);
      }
export type UnhideJobMatchMutationHookResult = ReturnType<typeof useUnhideJobMatchMutation>;
export type UnhideJobMatchMutationResult = Apollo.MutationResult<UnhideJobMatchMutation>;
export type UnhideJobMatchMutationOptions = Apollo.BaseMutationOptions<UnhideJobMatchMutation, UnhideJobMatchMutationVariables>;
export const UnsaveJobMatchDocument = gql`
    mutation UnsaveJobMatch($id: MigrateID!) {
  removeMatchResponse(input: {id: $id}) {
    ...JobMatchActionMatchResponseProps
  }
}
    ${JobMatchActionMatchResponsePropsFragmentDoc}`;
export type UnsaveJobMatchMutationFn = Apollo.MutationFunction<UnsaveJobMatchMutation, UnsaveJobMatchMutationVariables>;

/**
 * __useUnsaveJobMatchMutation__
 *
 * To run a mutation, you first call `useUnsaveJobMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsaveJobMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsaveJobMatchMutation, { data, loading, error }] = useUnsaveJobMatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnsaveJobMatchMutation(baseOptions?: Apollo.MutationHookOptions<UnsaveJobMatchMutation, UnsaveJobMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsaveJobMatchMutation, UnsaveJobMatchMutationVariables>(UnsaveJobMatchDocument, options);
      }
export type UnsaveJobMatchMutationHookResult = ReturnType<typeof useUnsaveJobMatchMutation>;
export type UnsaveJobMatchMutationResult = Apollo.MutationResult<UnsaveJobMatchMutation>;
export type UnsaveJobMatchMutationOptions = Apollo.BaseMutationOptions<UnsaveJobMatchMutation, UnsaveJobMatchMutationVariables>;
export const JobDetailsDocument = gql`
    query JobDetails($id: MigrateID!) {
  job(id: $id) {
    ...JobDetailsJobProps
  }
}
    ${JobDetailsJobPropsFragmentDoc}`;

/**
 * __useJobDetailsQuery__
 *
 * To run a query within a React component, call `useJobDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobDetailsQuery(baseOptions: Apollo.QueryHookOptions<JobDetailsQuery, JobDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobDetailsQuery, JobDetailsQueryVariables>(JobDetailsDocument, options);
      }
export function useJobDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobDetailsQuery, JobDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobDetailsQuery, JobDetailsQueryVariables>(JobDetailsDocument, options);
        }
export type JobDetailsQueryHookResult = ReturnType<typeof useJobDetailsQuery>;
export type JobDetailsLazyQueryHookResult = ReturnType<typeof useJobDetailsLazyQuery>;
export type JobDetailsQueryResult = Apollo.QueryResult<JobDetailsQuery, JobDetailsQueryVariables>;
export const JobDetailsScreenDocument = gql`
    query JobDetailsScreen($jobId: MigrateID!) {
  job(id: $jobId) {
    id
    myMatchResponse {
      ...JobMatchActionMatchResponseProps
    }
  }
}
    ${JobMatchActionMatchResponsePropsFragmentDoc}`;

/**
 * __useJobDetailsScreenQuery__
 *
 * To run a query within a React component, call `useJobDetailsScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobDetailsScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobDetailsScreenQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobDetailsScreenQuery(baseOptions: Apollo.QueryHookOptions<JobDetailsScreenQuery, JobDetailsScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobDetailsScreenQuery, JobDetailsScreenQueryVariables>(JobDetailsScreenDocument, options);
      }
export function useJobDetailsScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobDetailsScreenQuery, JobDetailsScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobDetailsScreenQuery, JobDetailsScreenQueryVariables>(JobDetailsScreenDocument, options);
        }
export type JobDetailsScreenQueryHookResult = ReturnType<typeof useJobDetailsScreenQuery>;
export type JobDetailsScreenLazyQueryHookResult = ReturnType<typeof useJobDetailsScreenLazyQuery>;
export type JobDetailsScreenQueryResult = Apollo.QueryResult<JobDetailsScreenQuery, JobDetailsScreenQueryVariables>;
export const JobMatchesOverviewDocument = gql`
    query JobMatchesOverview($input: MyMatchedJobsInput) {
  myMatchedJobs(input: $input) {
    ...JobMatchesOverviewJobPageProps
  }
}
    ${JobMatchesOverviewJobPagePropsFragmentDoc}`;

/**
 * __useJobMatchesOverviewQuery__
 *
 * To run a query within a React component, call `useJobMatchesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobMatchesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobMatchesOverviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobMatchesOverviewQuery(baseOptions?: Apollo.QueryHookOptions<JobMatchesOverviewQuery, JobMatchesOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobMatchesOverviewQuery, JobMatchesOverviewQueryVariables>(JobMatchesOverviewDocument, options);
      }
export function useJobMatchesOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobMatchesOverviewQuery, JobMatchesOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobMatchesOverviewQuery, JobMatchesOverviewQueryVariables>(JobMatchesOverviewDocument, options);
        }
export type JobMatchesOverviewQueryHookResult = ReturnType<typeof useJobMatchesOverviewQuery>;
export type JobMatchesOverviewLazyQueryHookResult = ReturnType<typeof useJobMatchesOverviewLazyQuery>;
export type JobMatchesOverviewQueryResult = Apollo.QueryResult<JobMatchesOverviewQuery, JobMatchesOverviewQueryVariables>;
export const ApplicationProgressDocument = gql`
    query ApplicationProgress($jobId: MigrateID!) {
  me {
    id
    ... on CandidateV2 {
      profileCompletion
      canApply
    }
  }
  matchResponseByJob(jobId: $jobId) {
    id
    type
    job {
      id
      title
      requiresLanguagePass
    }
    ... on ApplicationStartMatchResponse {
      applicationCompletion
    }
  }
}
    `;

/**
 * __useApplicationProgressQuery__
 *
 * To run a query within a React component, call `useApplicationProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationProgressQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useApplicationProgressQuery(baseOptions: Apollo.QueryHookOptions<ApplicationProgressQuery, ApplicationProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationProgressQuery, ApplicationProgressQueryVariables>(ApplicationProgressDocument, options);
      }
export function useApplicationProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationProgressQuery, ApplicationProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationProgressQuery, ApplicationProgressQueryVariables>(ApplicationProgressDocument, options);
        }
export type ApplicationProgressQueryHookResult = ReturnType<typeof useApplicationProgressQuery>;
export type ApplicationProgressLazyQueryHookResult = ReturnType<typeof useApplicationProgressLazyQuery>;
export type ApplicationProgressQueryResult = Apollo.QueryResult<ApplicationProgressQuery, ApplicationProgressQueryVariables>;
export const SubmitApplicationDocument = gql`
    mutation SubmitApplication($input: GenericMatchResponseInput!) {
  submitMatchApplication(input: $input) {
    id
    type
  }
}
    `;
export type SubmitApplicationMutationFn = Apollo.MutationFunction<SubmitApplicationMutation, SubmitApplicationMutationVariables>;

/**
 * __useSubmitApplicationMutation__
 *
 * To run a mutation, you first call `useSubmitApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitApplicationMutation, { data, loading, error }] = useSubmitApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitApplicationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitApplicationMutation, SubmitApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitApplicationMutation, SubmitApplicationMutationVariables>(SubmitApplicationDocument, options);
      }
export type SubmitApplicationMutationHookResult = ReturnType<typeof useSubmitApplicationMutation>;
export type SubmitApplicationMutationResult = Apollo.MutationResult<SubmitApplicationMutation>;
export type SubmitApplicationMutationOptions = Apollo.BaseMutationOptions<SubmitApplicationMutation, SubmitApplicationMutationVariables>;
export const ApplicationQuestionSectionDocument = gql`
    query ApplicationQuestionSection($matchResponseId: MigrateID!) {
  matchResponse(id: $matchResponseId) {
    id
    job {
      id
      organisationName
      organisation {
        id
        name
      }
    }
    ... on ApplicationStartMatchResponse {
      applicationQuestion {
        question
        response
      }
      applicationCompletion
    }
    ... on ApplyMatchResponse {
      applicationQuestion {
        question
        response
      }
      applicationCompletion
    }
  }
}
    `;

/**
 * __useApplicationQuestionSectionQuery__
 *
 * To run a query within a React component, call `useApplicationQuestionSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationQuestionSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationQuestionSectionQuery({
 *   variables: {
 *      matchResponseId: // value for 'matchResponseId'
 *   },
 * });
 */
export function useApplicationQuestionSectionQuery(baseOptions: Apollo.QueryHookOptions<ApplicationQuestionSectionQuery, ApplicationQuestionSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationQuestionSectionQuery, ApplicationQuestionSectionQueryVariables>(ApplicationQuestionSectionDocument, options);
      }
export function useApplicationQuestionSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationQuestionSectionQuery, ApplicationQuestionSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationQuestionSectionQuery, ApplicationQuestionSectionQueryVariables>(ApplicationQuestionSectionDocument, options);
        }
export type ApplicationQuestionSectionQueryHookResult = ReturnType<typeof useApplicationQuestionSectionQuery>;
export type ApplicationQuestionSectionLazyQueryHookResult = ReturnType<typeof useApplicationQuestionSectionLazyQuery>;
export type ApplicationQuestionSectionQueryResult = Apollo.QueryResult<ApplicationQuestionSectionQuery, ApplicationQuestionSectionQueryVariables>;
export const AnswerApplicationQuestionDocument = gql`
    mutation AnswerApplicationQuestion($input: AnswerApplicationQuestionInput!) {
  answerApplicationQuestion(input: $input) {
    id
    ... on ApplicationStartMatchResponse {
      applicationQuestion {
        response
      }
      applicationCompletion
    }
  }
}
    `;
export type AnswerApplicationQuestionMutationFn = Apollo.MutationFunction<AnswerApplicationQuestionMutation, AnswerApplicationQuestionMutationVariables>;

/**
 * __useAnswerApplicationQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerApplicationQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerApplicationQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerApplicationQuestionMutation, { data, loading, error }] = useAnswerApplicationQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerApplicationQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AnswerApplicationQuestionMutation, AnswerApplicationQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerApplicationQuestionMutation, AnswerApplicationQuestionMutationVariables>(AnswerApplicationQuestionDocument, options);
      }
export type AnswerApplicationQuestionMutationHookResult = ReturnType<typeof useAnswerApplicationQuestionMutation>;
export type AnswerApplicationQuestionMutationResult = Apollo.MutationResult<AnswerApplicationQuestionMutation>;
export type AnswerApplicationQuestionMutationOptions = Apollo.BaseMutationOptions<AnswerApplicationQuestionMutation, AnswerApplicationQuestionMutationVariables>;
export const RemoveApplicationQuestionResponseDocument = gql`
    mutation RemoveApplicationQuestionResponse($input: RemoveApplicationQuestionResponseInput!) {
  removeApplicationQuestionResponse(input: $input) {
    id
    ... on ApplicationStartMatchResponse {
      applicationQuestion {
        response
      }
      applicationCompletion
    }
  }
}
    `;
export type RemoveApplicationQuestionResponseMutationFn = Apollo.MutationFunction<RemoveApplicationQuestionResponseMutation, RemoveApplicationQuestionResponseMutationVariables>;

/**
 * __useRemoveApplicationQuestionResponseMutation__
 *
 * To run a mutation, you first call `useRemoveApplicationQuestionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveApplicationQuestionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeApplicationQuestionResponseMutation, { data, loading, error }] = useRemoveApplicationQuestionResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveApplicationQuestionResponseMutation(baseOptions?: Apollo.MutationHookOptions<RemoveApplicationQuestionResponseMutation, RemoveApplicationQuestionResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveApplicationQuestionResponseMutation, RemoveApplicationQuestionResponseMutationVariables>(RemoveApplicationQuestionResponseDocument, options);
      }
export type RemoveApplicationQuestionResponseMutationHookResult = ReturnType<typeof useRemoveApplicationQuestionResponseMutation>;
export type RemoveApplicationQuestionResponseMutationResult = Apollo.MutationResult<RemoveApplicationQuestionResponseMutation>;
export type RemoveApplicationQuestionResponseMutationOptions = Apollo.BaseMutationOptions<RemoveApplicationQuestionResponseMutation, RemoveApplicationQuestionResponseMutationVariables>;
export const ApplyFormDocument = gql`
    query ApplyForm($jobId: MigrateID!) {
  matchResponseByJob(jobId: $jobId) {
    id
    job {
      id
      title
    }
    ... on ApplicationStartMatchResponse {
      applicationQuestion {
        question
        response
      }
      applicationCompletion
    }
  }
}
    `;

/**
 * __useApplyFormQuery__
 *
 * To run a query within a React component, call `useApplyFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyFormQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useApplyFormQuery(baseOptions: Apollo.QueryHookOptions<ApplyFormQuery, ApplyFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplyFormQuery, ApplyFormQueryVariables>(ApplyFormDocument, options);
      }
export function useApplyFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplyFormQuery, ApplyFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplyFormQuery, ApplyFormQueryVariables>(ApplyFormDocument, options);
        }
export type ApplyFormQueryHookResult = ReturnType<typeof useApplyFormQuery>;
export type ApplyFormLazyQueryHookResult = ReturnType<typeof useApplyFormLazyQuery>;
export type ApplyFormQueryResult = Apollo.QueryResult<ApplyFormQuery, ApplyFormQueryVariables>;
export const MatchedJobsDocument = gql`
    query MatchedJobs($input: MyMatchedJobsInput) {
  myMatchedJobs(input: $input) {
    data {
      ...JobDetailsJobProps
      myMatchResponse {
        ...JobMatchActionMatchResponseProps
      }
    }
    count
  }
}
    ${JobDetailsJobPropsFragmentDoc}
${JobMatchActionMatchResponsePropsFragmentDoc}`;

/**
 * __useMatchedJobsQuery__
 *
 * To run a query within a React component, call `useMatchedJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchedJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchedJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchedJobsQuery(baseOptions?: Apollo.QueryHookOptions<MatchedJobsQuery, MatchedJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchedJobsQuery, MatchedJobsQueryVariables>(MatchedJobsDocument, options);
      }
export function useMatchedJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchedJobsQuery, MatchedJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchedJobsQuery, MatchedJobsQueryVariables>(MatchedJobsDocument, options);
        }
export type MatchedJobsQueryHookResult = ReturnType<typeof useMatchedJobsQuery>;
export type MatchedJobsLazyQueryHookResult = ReturnType<typeof useMatchedJobsLazyQuery>;
export type MatchedJobsQueryResult = Apollo.QueryResult<MatchedJobsQuery, MatchedJobsQueryVariables>;
export const JobCardDocument = gql`
    query JobCard($jobId: MigrateID!) {
  job(id: $jobId) {
    ...JobCardProps
  }
}
    ${JobCardPropsFragmentDoc}`;

/**
 * __useJobCardQuery__
 *
 * To run a query within a React component, call `useJobCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobCardQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobCardQuery(baseOptions: Apollo.QueryHookOptions<JobCardQuery, JobCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobCardQuery, JobCardQueryVariables>(JobCardDocument, options);
      }
export function useJobCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobCardQuery, JobCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobCardQuery, JobCardQueryVariables>(JobCardDocument, options);
        }
export type JobCardQueryHookResult = ReturnType<typeof useJobCardQuery>;
export type JobCardLazyQueryHookResult = ReturnType<typeof useJobCardLazyQuery>;
export type JobCardQueryResult = Apollo.QueryResult<JobCardQuery, JobCardQueryVariables>;
export const MyJobsDocument = gql`
    query MyJobs($types: [MatchResponseType!]!, $after: String) {
  myMatchResponses(where: {type: {in: $types}}, _cursor: $after) {
    data {
      id
      job {
        ...JobCardProps
      }
    }
    count
    after
  }
  me {
    id
    ... on CandidateV2 {
      applicationsRemaining
    }
  }
}
    ${JobCardPropsFragmentDoc}`;

/**
 * __useMyJobsQuery__
 *
 * To run a query within a React component, call `useMyJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyJobsQuery({
 *   variables: {
 *      types: // value for 'types'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMyJobsQuery(baseOptions: Apollo.QueryHookOptions<MyJobsQuery, MyJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyJobsQuery, MyJobsQueryVariables>(MyJobsDocument, options);
      }
export function useMyJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyJobsQuery, MyJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyJobsQuery, MyJobsQueryVariables>(MyJobsDocument, options);
        }
export type MyJobsQueryHookResult = ReturnType<typeof useMyJobsQuery>;
export type MyJobsLazyQueryHookResult = ReturnType<typeof useMyJobsLazyQuery>;
export type MyJobsQueryResult = Apollo.QueryResult<MyJobsQuery, MyJobsQueryVariables>;
export const NumUnreadMessagesDocument = gql`
    query NumUnreadMessages {
  numUnreadMessages
}
    `;

/**
 * __useNumUnreadMessagesQuery__
 *
 * To run a query within a React component, call `useNumUnreadMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumUnreadMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumUnreadMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNumUnreadMessagesQuery(baseOptions?: Apollo.QueryHookOptions<NumUnreadMessagesQuery, NumUnreadMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NumUnreadMessagesQuery, NumUnreadMessagesQueryVariables>(NumUnreadMessagesDocument, options);
      }
export function useNumUnreadMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NumUnreadMessagesQuery, NumUnreadMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NumUnreadMessagesQuery, NumUnreadMessagesQueryVariables>(NumUnreadMessagesDocument, options);
        }
export type NumUnreadMessagesQueryHookResult = ReturnType<typeof useNumUnreadMessagesQuery>;
export type NumUnreadMessagesLazyQueryHookResult = ReturnType<typeof useNumUnreadMessagesLazyQuery>;
export type NumUnreadMessagesQueryResult = Apollo.QueryResult<NumUnreadMessagesQuery, NumUnreadMessagesQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications($where: NotificationsWhereInput, $size: Int, $after: String) {
  notifications(where: $where, _size: $size, _cursor: $after) {
    data {
      ...NotificationFields
    }
    count
    after
  }
}
    ${NotificationFieldsFragmentDoc}`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      size: // value for 'size'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const GetNotificationDocument = gql`
    query GetNotification($id: MigrateID!) {
  notification(id: $id) {
    ...NotificationFields
  }
}
    ${NotificationFieldsFragmentDoc}`;

/**
 * __useGetNotificationQuery__
 *
 * To run a query within a React component, call `useGetNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationQuery, GetNotificationQueryVariables>(GetNotificationDocument, options);
      }
export function useGetNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationQuery, GetNotificationQueryVariables>(GetNotificationDocument, options);
        }
export type GetNotificationQueryHookResult = ReturnType<typeof useGetNotificationQuery>;
export type GetNotificationLazyQueryHookResult = ReturnType<typeof useGetNotificationLazyQuery>;
export type GetNotificationQueryResult = Apollo.QueryResult<GetNotificationQuery, GetNotificationQueryVariables>;
export const ReadNotificationDocument = gql`
    mutation ReadNotification($id: MigrateID!) {
  readNotification(id: $id) {
    id
    unread
  }
}
    `;
export type ReadNotificationMutationFn = Apollo.MutationFunction<ReadNotificationMutation, ReadNotificationMutationVariables>;

/**
 * __useReadNotificationMutation__
 *
 * To run a mutation, you first call `useReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationMutation, { data, loading, error }] = useReadNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ReadNotificationMutation, ReadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument, options);
      }
export type ReadNotificationMutationHookResult = ReturnType<typeof useReadNotificationMutation>;
export type ReadNotificationMutationResult = Apollo.MutationResult<ReadNotificationMutation>;
export type ReadNotificationMutationOptions = Apollo.BaseMutationOptions<ReadNotificationMutation, ReadNotificationMutationVariables>;
export const JobPreferencesScreenDocument = gql`
    query JobPreferencesScreen {
  me {
    id
    ...JobPreferencesApplicantProps
    ...JobPreferencesCandidateV2Props
  }
  getProfessions(_size: 100) {
    ...ProfessionStepProfessionPageProps
  }
  locations {
    ...LocationStepLocationProps
  }
}
    ${JobPreferencesApplicantPropsFragmentDoc}
${JobPreferencesCandidateV2PropsFragmentDoc}
${ProfessionStepProfessionPagePropsFragmentDoc}
${LocationStepLocationPropsFragmentDoc}`;

/**
 * __useJobPreferencesScreenQuery__
 *
 * To run a query within a React component, call `useJobPreferencesScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPreferencesScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPreferencesScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobPreferencesScreenQuery(baseOptions?: Apollo.QueryHookOptions<JobPreferencesScreenQuery, JobPreferencesScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPreferencesScreenQuery, JobPreferencesScreenQueryVariables>(JobPreferencesScreenDocument, options);
      }
export function useJobPreferencesScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPreferencesScreenQuery, JobPreferencesScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPreferencesScreenQuery, JobPreferencesScreenQueryVariables>(JobPreferencesScreenDocument, options);
        }
export type JobPreferencesScreenQueryHookResult = ReturnType<typeof useJobPreferencesScreenQuery>;
export type JobPreferencesScreenLazyQueryHookResult = ReturnType<typeof useJobPreferencesScreenLazyQuery>;
export type JobPreferencesScreenQueryResult = Apollo.QueryResult<JobPreferencesScreenQuery, JobPreferencesScreenQueryVariables>;
export const OnboardingDocument = gql`
    query Onboarding {
  getProfessions(_size: 100) {
    ...ProfessionStepProfessionPageProps
  }
  locations {
    ...LocationStepLocationProps
  }
}
    ${ProfessionStepProfessionPagePropsFragmentDoc}
${LocationStepLocationPropsFragmentDoc}`;

/**
 * __useOnboardingQuery__
 *
 * To run a query within a React component, call `useOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingQuery, OnboardingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingQuery, OnboardingQueryVariables>(OnboardingDocument, options);
      }
export function useOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingQuery, OnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingQuery, OnboardingQueryVariables>(OnboardingDocument, options);
        }
export type OnboardingQueryHookResult = ReturnType<typeof useOnboardingQuery>;
export type OnboardingLazyQueryHookResult = ReturnType<typeof useOnboardingLazyQuery>;
export type OnboardingQueryResult = Apollo.QueryResult<OnboardingQuery, OnboardingQueryVariables>;
export const SignupToMailingListDocument = gql`
    mutation SignupToMailingList {
  signupToMailingList
}
    `;
export type SignupToMailingListMutationFn = Apollo.MutationFunction<SignupToMailingListMutation, SignupToMailingListMutationVariables>;

/**
 * __useSignupToMailingListMutation__
 *
 * To run a mutation, you first call `useSignupToMailingListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupToMailingListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupToMailingListMutation, { data, loading, error }] = useSignupToMailingListMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignupToMailingListMutation(baseOptions?: Apollo.MutationHookOptions<SignupToMailingListMutation, SignupToMailingListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupToMailingListMutation, SignupToMailingListMutationVariables>(SignupToMailingListDocument, options);
      }
export type SignupToMailingListMutationHookResult = ReturnType<typeof useSignupToMailingListMutation>;
export type SignupToMailingListMutationResult = Apollo.MutationResult<SignupToMailingListMutation>;
export type SignupToMailingListMutationOptions = Apollo.BaseMutationOptions<SignupToMailingListMutation, SignupToMailingListMutationVariables>;
export const RedListCountriesDocument = gql`
    query RedListCountries {
  redListCountries @client
}
    `;

/**
 * __useRedListCountriesQuery__
 *
 * To run a query within a React component, call `useRedListCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedListCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedListCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRedListCountriesQuery(baseOptions?: Apollo.QueryHookOptions<RedListCountriesQuery, RedListCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedListCountriesQuery, RedListCountriesQueryVariables>(RedListCountriesDocument, options);
      }
export function useRedListCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedListCountriesQuery, RedListCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedListCountriesQuery, RedListCountriesQueryVariables>(RedListCountriesDocument, options);
        }
export type RedListCountriesQueryHookResult = ReturnType<typeof useRedListCountriesQuery>;
export type RedListCountriesLazyQueryHookResult = ReturnType<typeof useRedListCountriesLazyQuery>;
export type RedListCountriesQueryResult = Apollo.QueryResult<RedListCountriesQuery, RedListCountriesQueryVariables>;
export const LocationsDocument = gql`
    query Locations {
  locations {
    ...LocationStepLocationProps
  }
}
    ${LocationStepLocationPropsFragmentDoc}`;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const OnboardingProfessionsDocument = gql`
    query OnboardingProfessions {
  getProfessions(_size: 100) {
    ...ProfessionStepProfessionPageProps
  }
}
    ${ProfessionStepProfessionPagePropsFragmentDoc}`;

/**
 * __useOnboardingProfessionsQuery__
 *
 * To run a query within a React component, call `useOnboardingProfessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingProfessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingProfessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingProfessionsQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingProfessionsQuery, OnboardingProfessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingProfessionsQuery, OnboardingProfessionsQueryVariables>(OnboardingProfessionsDocument, options);
      }
export function useOnboardingProfessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingProfessionsQuery, OnboardingProfessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingProfessionsQuery, OnboardingProfessionsQueryVariables>(OnboardingProfessionsDocument, options);
        }
export type OnboardingProfessionsQueryHookResult = ReturnType<typeof useOnboardingProfessionsQuery>;
export type OnboardingProfessionsLazyQueryHookResult = ReturnType<typeof useOnboardingProfessionsLazyQuery>;
export type OnboardingProfessionsQueryResult = Apollo.QueryResult<OnboardingProfessionsQuery, OnboardingProfessionsQueryVariables>;
export const AccountSettingsFormDocument = gql`
    query AccountSettingsForm {
  me {
    id
    forenames
    surname
    email
  }
}
    `;

/**
 * __useAccountSettingsFormQuery__
 *
 * To run a query within a React component, call `useAccountSettingsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSettingsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSettingsFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountSettingsFormQuery(baseOptions?: Apollo.QueryHookOptions<AccountSettingsFormQuery, AccountSettingsFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSettingsFormQuery, AccountSettingsFormQueryVariables>(AccountSettingsFormDocument, options);
      }
export function useAccountSettingsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSettingsFormQuery, AccountSettingsFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSettingsFormQuery, AccountSettingsFormQueryVariables>(AccountSettingsFormDocument, options);
        }
export type AccountSettingsFormQueryHookResult = ReturnType<typeof useAccountSettingsFormQuery>;
export type AccountSettingsFormLazyQueryHookResult = ReturnType<typeof useAccountSettingsFormLazyQuery>;
export type AccountSettingsFormQueryResult = Apollo.QueryResult<AccountSettingsFormQuery, AccountSettingsFormQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    forenames
    surname
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteCandidateAccountDocument = gql`
    mutation DeleteCandidateAccount {
  deleteCandidateAccount {
    id
  }
}
    `;
export type DeleteCandidateAccountMutationFn = Apollo.MutationFunction<DeleteCandidateAccountMutation, DeleteCandidateAccountMutationVariables>;

/**
 * __useDeleteCandidateAccountMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateAccountMutation, { data, loading, error }] = useDeleteCandidateAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteCandidateAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCandidateAccountMutation, DeleteCandidateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCandidateAccountMutation, DeleteCandidateAccountMutationVariables>(DeleteCandidateAccountDocument, options);
      }
export type DeleteCandidateAccountMutationHookResult = ReturnType<typeof useDeleteCandidateAccountMutation>;
export type DeleteCandidateAccountMutationResult = Apollo.MutationResult<DeleteCandidateAccountMutation>;
export type DeleteCandidateAccountMutationOptions = Apollo.BaseMutationOptions<DeleteCandidateAccountMutation, DeleteCandidateAccountMutationVariables>;
export const ProfileCompletionDocument = gql`
    query ProfileCompletion {
  me {
    id
    fullName
    photoUrl
    ... on CandidateV2 {
      profession {
        id
        name
      }
      countryInfo {
        name
      }
      profileCompletion
    }
  }
}
    `;

/**
 * __useProfileCompletionQuery__
 *
 * To run a query within a React component, call `useProfileCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileCompletionQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileCompletionQuery(baseOptions?: Apollo.QueryHookOptions<ProfileCompletionQuery, ProfileCompletionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileCompletionQuery, ProfileCompletionQueryVariables>(ProfileCompletionDocument, options);
      }
export function useProfileCompletionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileCompletionQuery, ProfileCompletionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileCompletionQuery, ProfileCompletionQueryVariables>(ProfileCompletionDocument, options);
        }
export type ProfileCompletionQueryHookResult = ReturnType<typeof useProfileCompletionQuery>;
export type ProfileCompletionLazyQueryHookResult = ReturnType<typeof useProfileCompletionLazyQuery>;
export type ProfileCompletionQueryResult = Apollo.QueryResult<ProfileCompletionQuery, ProfileCompletionQueryVariables>;
export const ProfileTrackingDocument = gql`
    query ProfileTracking {
  me {
    id
    ... on CandidateV2 {
      profileCompletion
    }
  }
}
    `;

/**
 * __useProfileTrackingQuery__
 *
 * To run a query within a React component, call `useProfileTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileTrackingQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileTrackingQuery(baseOptions?: Apollo.QueryHookOptions<ProfileTrackingQuery, ProfileTrackingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileTrackingQuery, ProfileTrackingQueryVariables>(ProfileTrackingDocument, options);
      }
export function useProfileTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileTrackingQuery, ProfileTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileTrackingQuery, ProfileTrackingQueryVariables>(ProfileTrackingDocument, options);
        }
export type ProfileTrackingQueryHookResult = ReturnType<typeof useProfileTrackingQuery>;
export type ProfileTrackingLazyQueryHookResult = ReturnType<typeof useProfileTrackingLazyQuery>;
export type ProfileTrackingQueryResult = Apollo.QueryResult<ProfileTrackingQuery, ProfileTrackingQueryVariables>;
export const GetProfilePhotoUploadTokenDocument = gql`
    query GetProfilePhotoUploadToken {
  getProfilePhotoUploadToken {
    token
    url
  }
}
    `;

/**
 * __useGetProfilePhotoUploadTokenQuery__
 *
 * To run a query within a React component, call `useGetProfilePhotoUploadTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilePhotoUploadTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilePhotoUploadTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfilePhotoUploadTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetProfilePhotoUploadTokenQuery, GetProfilePhotoUploadTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfilePhotoUploadTokenQuery, GetProfilePhotoUploadTokenQueryVariables>(GetProfilePhotoUploadTokenDocument, options);
      }
export function useGetProfilePhotoUploadTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfilePhotoUploadTokenQuery, GetProfilePhotoUploadTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfilePhotoUploadTokenQuery, GetProfilePhotoUploadTokenQueryVariables>(GetProfilePhotoUploadTokenDocument, options);
        }
export type GetProfilePhotoUploadTokenQueryHookResult = ReturnType<typeof useGetProfilePhotoUploadTokenQuery>;
export type GetProfilePhotoUploadTokenLazyQueryHookResult = ReturnType<typeof useGetProfilePhotoUploadTokenLazyQuery>;
export type GetProfilePhotoUploadTokenQueryResult = Apollo.QueryResult<GetProfilePhotoUploadTokenQuery, GetProfilePhotoUploadTokenQueryVariables>;
export const UploadProfilePhotoDocument = gql`
    mutation uploadProfilePhoto($input: UploadProfilePhotoInput!) {
  uploadProfilePhoto(input: $input) {
    id
    photoUrl
  }
}
    `;
export type UploadProfilePhotoMutationFn = Apollo.MutationFunction<UploadProfilePhotoMutation, UploadProfilePhotoMutationVariables>;

/**
 * __useUploadProfilePhotoMutation__
 *
 * To run a mutation, you first call `useUploadProfilePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProfilePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProfilePhotoMutation, { data, loading, error }] = useUploadProfilePhotoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadProfilePhotoMutation(baseOptions?: Apollo.MutationHookOptions<UploadProfilePhotoMutation, UploadProfilePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProfilePhotoMutation, UploadProfilePhotoMutationVariables>(UploadProfilePhotoDocument, options);
      }
export type UploadProfilePhotoMutationHookResult = ReturnType<typeof useUploadProfilePhotoMutation>;
export type UploadProfilePhotoMutationResult = Apollo.MutationResult<UploadProfilePhotoMutation>;
export type UploadProfilePhotoMutationOptions = Apollo.BaseMutationOptions<UploadProfilePhotoMutation, UploadProfilePhotoMutationVariables>;
export const CareerExperienceSectionDocument = gql`
    query CareerExperienceSection {
  me {
    id
    ... on CandidateV2 {
      careerExperiences {
        ...CareerExperienceFields
      }
      profileCompletion
    }
  }
}
    ${CareerExperienceFieldsFragmentDoc}`;

/**
 * __useCareerExperienceSectionQuery__
 *
 * To run a query within a React component, call `useCareerExperienceSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerExperienceSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerExperienceSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCareerExperienceSectionQuery(baseOptions?: Apollo.QueryHookOptions<CareerExperienceSectionQuery, CareerExperienceSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerExperienceSectionQuery, CareerExperienceSectionQueryVariables>(CareerExperienceSectionDocument, options);
      }
export function useCareerExperienceSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerExperienceSectionQuery, CareerExperienceSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerExperienceSectionQuery, CareerExperienceSectionQueryVariables>(CareerExperienceSectionDocument, options);
        }
export type CareerExperienceSectionQueryHookResult = ReturnType<typeof useCareerExperienceSectionQuery>;
export type CareerExperienceSectionLazyQueryHookResult = ReturnType<typeof useCareerExperienceSectionLazyQuery>;
export type CareerExperienceSectionQueryResult = Apollo.QueryResult<CareerExperienceSectionQuery, CareerExperienceSectionQueryVariables>;
export const EducationExperienceSectionDocument = gql`
    query EducationExperienceSection {
  me {
    id
    ... on CandidateV2 {
      coreDocuments {
        qualification {
          ...CoreDocumentsFields
        }
      }
      educationExperiences {
        id
        institutionName
        qualification
        grade
        startDate
        endDate
        description {
          content
        }
      }
      profileCompletion
    }
  }
}
    ${CoreDocumentsFieldsFragmentDoc}`;

/**
 * __useEducationExperienceSectionQuery__
 *
 * To run a query within a React component, call `useEducationExperienceSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEducationExperienceSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEducationExperienceSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useEducationExperienceSectionQuery(baseOptions?: Apollo.QueryHookOptions<EducationExperienceSectionQuery, EducationExperienceSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EducationExperienceSectionQuery, EducationExperienceSectionQueryVariables>(EducationExperienceSectionDocument, options);
      }
export function useEducationExperienceSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EducationExperienceSectionQuery, EducationExperienceSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EducationExperienceSectionQuery, EducationExperienceSectionQueryVariables>(EducationExperienceSectionDocument, options);
        }
export type EducationExperienceSectionQueryHookResult = ReturnType<typeof useEducationExperienceSectionQuery>;
export type EducationExperienceSectionLazyQueryHookResult = ReturnType<typeof useEducationExperienceSectionLazyQuery>;
export type EducationExperienceSectionQueryResult = Apollo.QueryResult<EducationExperienceSectionQuery, EducationExperienceSectionQueryVariables>;
export const CreateWorkExperienceDocument = gql`
    mutation CreateWorkExperience($input: CreateWorkExperienceInput!) {
  createWorkExperience(input: $input) {
    id
    careerExperiences {
      ...CareerExperienceFields
    }
    profileCompletion
    isExemptFromLanguageTest
  }
}
    ${CareerExperienceFieldsFragmentDoc}`;
export type CreateWorkExperienceMutationFn = Apollo.MutationFunction<CreateWorkExperienceMutation, CreateWorkExperienceMutationVariables>;

/**
 * __useCreateWorkExperienceMutation__
 *
 * To run a mutation, you first call `useCreateWorkExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkExperienceMutation, { data, loading, error }] = useCreateWorkExperienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkExperienceMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkExperienceMutation, CreateWorkExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkExperienceMutation, CreateWorkExperienceMutationVariables>(CreateWorkExperienceDocument, options);
      }
export type CreateWorkExperienceMutationHookResult = ReturnType<typeof useCreateWorkExperienceMutation>;
export type CreateWorkExperienceMutationResult = Apollo.MutationResult<CreateWorkExperienceMutation>;
export type CreateWorkExperienceMutationOptions = Apollo.BaseMutationOptions<CreateWorkExperienceMutation, CreateWorkExperienceMutationVariables>;
export const UpdateWorkExperienceDocument = gql`
    mutation UpdateWorkExperience($input: UpdateWorkExperienceInput!) {
  updateWorkExperience(input: $input) {
    id
    careerExperiences {
      ...CareerExperienceFields
    }
    profileCompletion
    isExemptFromLanguageTest
  }
}
    ${CareerExperienceFieldsFragmentDoc}`;
export type UpdateWorkExperienceMutationFn = Apollo.MutationFunction<UpdateWorkExperienceMutation, UpdateWorkExperienceMutationVariables>;

/**
 * __useUpdateWorkExperienceMutation__
 *
 * To run a mutation, you first call `useUpdateWorkExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkExperienceMutation, { data, loading, error }] = useUpdateWorkExperienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkExperienceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkExperienceMutation, UpdateWorkExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkExperienceMutation, UpdateWorkExperienceMutationVariables>(UpdateWorkExperienceDocument, options);
      }
export type UpdateWorkExperienceMutationHookResult = ReturnType<typeof useUpdateWorkExperienceMutation>;
export type UpdateWorkExperienceMutationResult = Apollo.MutationResult<UpdateWorkExperienceMutation>;
export type UpdateWorkExperienceMutationOptions = Apollo.BaseMutationOptions<UpdateWorkExperienceMutation, UpdateWorkExperienceMutationVariables>;
export const CreateCareerBreakDocument = gql`
    mutation CreateCareerBreak($input: CreateCareerBreakInput!) {
  createCareerBreak(input: $input) {
    id
    careerExperiences {
      ...CareerExperienceFields
    }
    profileCompletion
  }
}
    ${CareerExperienceFieldsFragmentDoc}`;
export type CreateCareerBreakMutationFn = Apollo.MutationFunction<CreateCareerBreakMutation, CreateCareerBreakMutationVariables>;

/**
 * __useCreateCareerBreakMutation__
 *
 * To run a mutation, you first call `useCreateCareerBreakMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCareerBreakMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCareerBreakMutation, { data, loading, error }] = useCreateCareerBreakMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCareerBreakMutation(baseOptions?: Apollo.MutationHookOptions<CreateCareerBreakMutation, CreateCareerBreakMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCareerBreakMutation, CreateCareerBreakMutationVariables>(CreateCareerBreakDocument, options);
      }
export type CreateCareerBreakMutationHookResult = ReturnType<typeof useCreateCareerBreakMutation>;
export type CreateCareerBreakMutationResult = Apollo.MutationResult<CreateCareerBreakMutation>;
export type CreateCareerBreakMutationOptions = Apollo.BaseMutationOptions<CreateCareerBreakMutation, CreateCareerBreakMutationVariables>;
export const UpdateCareerBreakDocument = gql`
    mutation UpdateCareerBreak($input: UpdateCareerBreakInput!) {
  updateCareerBreak(input: $input) {
    id
    careerExperiences {
      ...CareerExperienceFields
    }
    profileCompletion
  }
}
    ${CareerExperienceFieldsFragmentDoc}`;
export type UpdateCareerBreakMutationFn = Apollo.MutationFunction<UpdateCareerBreakMutation, UpdateCareerBreakMutationVariables>;

/**
 * __useUpdateCareerBreakMutation__
 *
 * To run a mutation, you first call `useUpdateCareerBreakMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCareerBreakMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCareerBreakMutation, { data, loading, error }] = useUpdateCareerBreakMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCareerBreakMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCareerBreakMutation, UpdateCareerBreakMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCareerBreakMutation, UpdateCareerBreakMutationVariables>(UpdateCareerBreakDocument, options);
      }
export type UpdateCareerBreakMutationHookResult = ReturnType<typeof useUpdateCareerBreakMutation>;
export type UpdateCareerBreakMutationResult = Apollo.MutationResult<UpdateCareerBreakMutation>;
export type UpdateCareerBreakMutationOptions = Apollo.BaseMutationOptions<UpdateCareerBreakMutation, UpdateCareerBreakMutationVariables>;
export const DeleteCareerExperienceDocument = gql`
    mutation DeleteCareerExperience($input: DeleteCareerExperienceInput!) {
  deleteCareerExperience(input: $input) {
    id
    careerExperiences {
      ...CareerExperienceFields
    }
    profileCompletion
    isExemptFromLanguageTest
  }
}
    ${CareerExperienceFieldsFragmentDoc}`;
export type DeleteCareerExperienceMutationFn = Apollo.MutationFunction<DeleteCareerExperienceMutation, DeleteCareerExperienceMutationVariables>;

/**
 * __useDeleteCareerExperienceMutation__
 *
 * To run a mutation, you first call `useDeleteCareerExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCareerExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCareerExperienceMutation, { data, loading, error }] = useDeleteCareerExperienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCareerExperienceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCareerExperienceMutation, DeleteCareerExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCareerExperienceMutation, DeleteCareerExperienceMutationVariables>(DeleteCareerExperienceDocument, options);
      }
export type DeleteCareerExperienceMutationHookResult = ReturnType<typeof useDeleteCareerExperienceMutation>;
export type DeleteCareerExperienceMutationResult = Apollo.MutationResult<DeleteCareerExperienceMutation>;
export type DeleteCareerExperienceMutationOptions = Apollo.BaseMutationOptions<DeleteCareerExperienceMutation, DeleteCareerExperienceMutationVariables>;
export const CreateEducationExperienceDocument = gql`
    mutation CreateEducationExperience($input: CreateEducationExperienceInput!) {
  createEducationExperience(input: $input) {
    id
    educationExperiences {
      id
      institutionName
      qualification
      grade
      startDate
      endDate
      description {
        content
      }
    }
    profileCompletion
  }
}
    `;
export type CreateEducationExperienceMutationFn = Apollo.MutationFunction<CreateEducationExperienceMutation, CreateEducationExperienceMutationVariables>;

/**
 * __useCreateEducationExperienceMutation__
 *
 * To run a mutation, you first call `useCreateEducationExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEducationExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEducationExperienceMutation, { data, loading, error }] = useCreateEducationExperienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEducationExperienceMutation(baseOptions?: Apollo.MutationHookOptions<CreateEducationExperienceMutation, CreateEducationExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEducationExperienceMutation, CreateEducationExperienceMutationVariables>(CreateEducationExperienceDocument, options);
      }
export type CreateEducationExperienceMutationHookResult = ReturnType<typeof useCreateEducationExperienceMutation>;
export type CreateEducationExperienceMutationResult = Apollo.MutationResult<CreateEducationExperienceMutation>;
export type CreateEducationExperienceMutationOptions = Apollo.BaseMutationOptions<CreateEducationExperienceMutation, CreateEducationExperienceMutationVariables>;
export const UpdateEducationExperienceDocument = gql`
    mutation UpdateEducationExperience($input: UpdateEducationExperienceInput!) {
  updateEducationExperience(input: $input) {
    id
    educationExperiences {
      id
      institutionName
      qualification
      grade
      startDate
      endDate
      description {
        content
      }
    }
    profileCompletion
  }
}
    `;
export type UpdateEducationExperienceMutationFn = Apollo.MutationFunction<UpdateEducationExperienceMutation, UpdateEducationExperienceMutationVariables>;

/**
 * __useUpdateEducationExperienceMutation__
 *
 * To run a mutation, you first call `useUpdateEducationExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEducationExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEducationExperienceMutation, { data, loading, error }] = useUpdateEducationExperienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEducationExperienceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEducationExperienceMutation, UpdateEducationExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEducationExperienceMutation, UpdateEducationExperienceMutationVariables>(UpdateEducationExperienceDocument, options);
      }
export type UpdateEducationExperienceMutationHookResult = ReturnType<typeof useUpdateEducationExperienceMutation>;
export type UpdateEducationExperienceMutationResult = Apollo.MutationResult<UpdateEducationExperienceMutation>;
export type UpdateEducationExperienceMutationOptions = Apollo.BaseMutationOptions<UpdateEducationExperienceMutation, UpdateEducationExperienceMutationVariables>;
export const DeleteEducationExperienceDocument = gql`
    mutation DeleteEducationExperience($input: DeleteEducationExperienceInput!) {
  deleteEducationExperience(input: $input) {
    id
    educationExperiences {
      id
      institutionName
      qualification
      grade
      startDate
      endDate
      description {
        content
      }
    }
    profileCompletion
  }
}
    `;
export type DeleteEducationExperienceMutationFn = Apollo.MutationFunction<DeleteEducationExperienceMutation, DeleteEducationExperienceMutationVariables>;

/**
 * __useDeleteEducationExperienceMutation__
 *
 * To run a mutation, you first call `useDeleteEducationExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEducationExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEducationExperienceMutation, { data, loading, error }] = useDeleteEducationExperienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEducationExperienceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEducationExperienceMutation, DeleteEducationExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEducationExperienceMutation, DeleteEducationExperienceMutationVariables>(DeleteEducationExperienceDocument, options);
      }
export type DeleteEducationExperienceMutationHookResult = ReturnType<typeof useDeleteEducationExperienceMutation>;
export type DeleteEducationExperienceMutationResult = Apollo.MutationResult<DeleteEducationExperienceMutation>;
export type DeleteEducationExperienceMutationOptions = Apollo.BaseMutationOptions<DeleteEducationExperienceMutation, DeleteEducationExperienceMutationVariables>;
export const CreateLanguageResultDocument = gql`
    mutation CreateLanguageResult($input: CreateLanguageResultInput!) {
  createLanguageResult(input: $input) {
    id
    languageResults {
      id
      awardingBody
      date
      listening
      reading
      writing
      speaking
    }
    meetsLanguageRequirements
    profileCompletion
  }
}
    `;
export type CreateLanguageResultMutationFn = Apollo.MutationFunction<CreateLanguageResultMutation, CreateLanguageResultMutationVariables>;

/**
 * __useCreateLanguageResultMutation__
 *
 * To run a mutation, you first call `useCreateLanguageResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLanguageResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLanguageResultMutation, { data, loading, error }] = useCreateLanguageResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLanguageResultMutation(baseOptions?: Apollo.MutationHookOptions<CreateLanguageResultMutation, CreateLanguageResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLanguageResultMutation, CreateLanguageResultMutationVariables>(CreateLanguageResultDocument, options);
      }
export type CreateLanguageResultMutationHookResult = ReturnType<typeof useCreateLanguageResultMutation>;
export type CreateLanguageResultMutationResult = Apollo.MutationResult<CreateLanguageResultMutation>;
export type CreateLanguageResultMutationOptions = Apollo.BaseMutationOptions<CreateLanguageResultMutation, CreateLanguageResultMutationVariables>;
export const UpdateLanguageResultDocument = gql`
    mutation UpdateLanguageResult($input: UpdateLanguageResultInput!) {
  updateLanguageResult(input: $input) {
    id
    languageResults {
      id
      awardingBody
      date
      listening
      reading
      writing
      speaking
    }
    meetsLanguageRequirements
    profileCompletion
  }
}
    `;
export type UpdateLanguageResultMutationFn = Apollo.MutationFunction<UpdateLanguageResultMutation, UpdateLanguageResultMutationVariables>;

/**
 * __useUpdateLanguageResultMutation__
 *
 * To run a mutation, you first call `useUpdateLanguageResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLanguageResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLanguageResultMutation, { data, loading, error }] = useUpdateLanguageResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLanguageResultMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLanguageResultMutation, UpdateLanguageResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLanguageResultMutation, UpdateLanguageResultMutationVariables>(UpdateLanguageResultDocument, options);
      }
export type UpdateLanguageResultMutationHookResult = ReturnType<typeof useUpdateLanguageResultMutation>;
export type UpdateLanguageResultMutationResult = Apollo.MutationResult<UpdateLanguageResultMutation>;
export type UpdateLanguageResultMutationOptions = Apollo.BaseMutationOptions<UpdateLanguageResultMutation, UpdateLanguageResultMutationVariables>;
export const DeleteLanguageResultDocument = gql`
    mutation DeleteLanguageResult($input: DeleteLanguageResultInput!) {
  deleteLanguageResult(input: $input) {
    id
    languageResults {
      id
      awardingBody
      date
      listening
      reading
      writing
      speaking
    }
    meetsLanguageRequirements
    profileCompletion
  }
}
    `;
export type DeleteLanguageResultMutationFn = Apollo.MutationFunction<DeleteLanguageResultMutation, DeleteLanguageResultMutationVariables>;

/**
 * __useDeleteLanguageResultMutation__
 *
 * To run a mutation, you first call `useDeleteLanguageResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLanguageResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLanguageResultMutation, { data, loading, error }] = useDeleteLanguageResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLanguageResultMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLanguageResultMutation, DeleteLanguageResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLanguageResultMutation, DeleteLanguageResultMutationVariables>(DeleteLanguageResultDocument, options);
      }
export type DeleteLanguageResultMutationHookResult = ReturnType<typeof useDeleteLanguageResultMutation>;
export type DeleteLanguageResultMutationResult = Apollo.MutationResult<DeleteLanguageResultMutation>;
export type DeleteLanguageResultMutationOptions = Apollo.BaseMutationOptions<DeleteLanguageResultMutation, DeleteLanguageResultMutationVariables>;
export const CreateQuestionResponseDocument = gql`
    mutation CreateQuestionResponse($input: CreateQuestionResponseInput!) {
  createQuestionResponse(input: $input) {
    id
    questionResponses {
      id
      question
      response
    }
    profileCompletion
  }
}
    `;
export type CreateQuestionResponseMutationFn = Apollo.MutationFunction<CreateQuestionResponseMutation, CreateQuestionResponseMutationVariables>;

/**
 * __useCreateQuestionResponseMutation__
 *
 * To run a mutation, you first call `useCreateQuestionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionResponseMutation, { data, loading, error }] = useCreateQuestionResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuestionResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionResponseMutation, CreateQuestionResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionResponseMutation, CreateQuestionResponseMutationVariables>(CreateQuestionResponseDocument, options);
      }
export type CreateQuestionResponseMutationHookResult = ReturnType<typeof useCreateQuestionResponseMutation>;
export type CreateQuestionResponseMutationResult = Apollo.MutationResult<CreateQuestionResponseMutation>;
export type CreateQuestionResponseMutationOptions = Apollo.BaseMutationOptions<CreateQuestionResponseMutation, CreateQuestionResponseMutationVariables>;
export const UpdateQuestionResponseDocument = gql`
    mutation UpdateQuestionResponse($input: UpdateQuestionResponseInput!) {
  updateQuestionResponse(input: $input) {
    id
    questionResponses {
      id
      question
      response
    }
    profileCompletion
  }
}
    `;
export type UpdateQuestionResponseMutationFn = Apollo.MutationFunction<UpdateQuestionResponseMutation, UpdateQuestionResponseMutationVariables>;

/**
 * __useUpdateQuestionResponseMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionResponseMutation, { data, loading, error }] = useUpdateQuestionResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionResponseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionResponseMutation, UpdateQuestionResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionResponseMutation, UpdateQuestionResponseMutationVariables>(UpdateQuestionResponseDocument, options);
      }
export type UpdateQuestionResponseMutationHookResult = ReturnType<typeof useUpdateQuestionResponseMutation>;
export type UpdateQuestionResponseMutationResult = Apollo.MutationResult<UpdateQuestionResponseMutation>;
export type UpdateQuestionResponseMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionResponseMutation, UpdateQuestionResponseMutationVariables>;
export const DeleteQuestionResponseDocument = gql`
    mutation DeleteQuestionResponse($input: DeleteQuestionResponseInput!) {
  deleteQuestionResponse(input: $input) {
    id
    questionResponses {
      id
      question
      response
    }
    profileCompletion
  }
}
    `;
export type DeleteQuestionResponseMutationFn = Apollo.MutationFunction<DeleteQuestionResponseMutation, DeleteQuestionResponseMutationVariables>;

/**
 * __useDeleteQuestionResponseMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionResponseMutation, { data, loading, error }] = useDeleteQuestionResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteQuestionResponseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuestionResponseMutation, DeleteQuestionResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuestionResponseMutation, DeleteQuestionResponseMutationVariables>(DeleteQuestionResponseDocument, options);
      }
export type DeleteQuestionResponseMutationHookResult = ReturnType<typeof useDeleteQuestionResponseMutation>;
export type DeleteQuestionResponseMutationResult = Apollo.MutationResult<DeleteQuestionResponseMutation>;
export type DeleteQuestionResponseMutationOptions = Apollo.BaseMutationOptions<DeleteQuestionResponseMutation, DeleteQuestionResponseMutationVariables>;
export const CreateRegistrationDetailDocument = gql`
    mutation CreateRegistrationDetail($input: CreateRegistrationDetailInput!) {
  createRegistrationDetail(input: $input) {
    id
    registrationDetails {
      id
      country
      countryInfo {
        name
      }
      referenceNumber
    }
    profileCompletion
  }
}
    `;
export type CreateRegistrationDetailMutationFn = Apollo.MutationFunction<CreateRegistrationDetailMutation, CreateRegistrationDetailMutationVariables>;

/**
 * __useCreateRegistrationDetailMutation__
 *
 * To run a mutation, you first call `useCreateRegistrationDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistrationDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistrationDetailMutation, { data, loading, error }] = useCreateRegistrationDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRegistrationDetailMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegistrationDetailMutation, CreateRegistrationDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegistrationDetailMutation, CreateRegistrationDetailMutationVariables>(CreateRegistrationDetailDocument, options);
      }
export type CreateRegistrationDetailMutationHookResult = ReturnType<typeof useCreateRegistrationDetailMutation>;
export type CreateRegistrationDetailMutationResult = Apollo.MutationResult<CreateRegistrationDetailMutation>;
export type CreateRegistrationDetailMutationOptions = Apollo.BaseMutationOptions<CreateRegistrationDetailMutation, CreateRegistrationDetailMutationVariables>;
export const UpdateRegistrationDetailDocument = gql`
    mutation UpdateRegistrationDetail($input: UpdateRegistrationDetailInput!) {
  updateRegistrationDetail(input: $input) {
    id
    registrationDetails {
      id
      country
      countryInfo {
        name
      }
      referenceNumber
    }
    profileCompletion
  }
}
    `;
export type UpdateRegistrationDetailMutationFn = Apollo.MutationFunction<UpdateRegistrationDetailMutation, UpdateRegistrationDetailMutationVariables>;

/**
 * __useUpdateRegistrationDetailMutation__
 *
 * To run a mutation, you first call `useUpdateRegistrationDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistrationDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistrationDetailMutation, { data, loading, error }] = useUpdateRegistrationDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegistrationDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegistrationDetailMutation, UpdateRegistrationDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegistrationDetailMutation, UpdateRegistrationDetailMutationVariables>(UpdateRegistrationDetailDocument, options);
      }
export type UpdateRegistrationDetailMutationHookResult = ReturnType<typeof useUpdateRegistrationDetailMutation>;
export type UpdateRegistrationDetailMutationResult = Apollo.MutationResult<UpdateRegistrationDetailMutation>;
export type UpdateRegistrationDetailMutationOptions = Apollo.BaseMutationOptions<UpdateRegistrationDetailMutation, UpdateRegistrationDetailMutationVariables>;
export const DeleteRegistrationDetailDocument = gql`
    mutation DeleteRegistrationDetail($input: DeleteRegistrationDetailInput!) {
  deleteRegistrationDetail(input: $input) {
    id
    registrationDetails {
      id
      country
      countryInfo {
        name
      }
      referenceNumber
    }
    profileCompletion
  }
}
    `;
export type DeleteRegistrationDetailMutationFn = Apollo.MutationFunction<DeleteRegistrationDetailMutation, DeleteRegistrationDetailMutationVariables>;

/**
 * __useDeleteRegistrationDetailMutation__
 *
 * To run a mutation, you first call `useDeleteRegistrationDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegistrationDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegistrationDetailMutation, { data, loading, error }] = useDeleteRegistrationDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRegistrationDetailMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegistrationDetailMutation, DeleteRegistrationDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegistrationDetailMutation, DeleteRegistrationDetailMutationVariables>(DeleteRegistrationDetailDocument, options);
      }
export type DeleteRegistrationDetailMutationHookResult = ReturnType<typeof useDeleteRegistrationDetailMutation>;
export type DeleteRegistrationDetailMutationResult = Apollo.MutationResult<DeleteRegistrationDetailMutation>;
export type DeleteRegistrationDetailMutationOptions = Apollo.BaseMutationOptions<DeleteRegistrationDetailMutation, DeleteRegistrationDetailMutationVariables>;
export const LanguageResultFormDocument = gql`
    query LanguageResultForm {
  me {
    id
    ... on CandidateV2 {
      coreDocuments {
        languageCertificate {
          ...CoreDocumentsFields
        }
      }
      languageResults {
        id
        awardingBody
        date
        listening
        reading
        writing
        speaking
      }
      meetsLanguageRequirements
      isExemptFromLanguageTest
      profileCompletion
    }
  }
  languageResultSchema {
    IELTS
    OET
  }
}
    ${CoreDocumentsFieldsFragmentDoc}`;

/**
 * __useLanguageResultFormQuery__
 *
 * To run a query within a React component, call `useLanguageResultFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageResultFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageResultFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useLanguageResultFormQuery(baseOptions?: Apollo.QueryHookOptions<LanguageResultFormQuery, LanguageResultFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LanguageResultFormQuery, LanguageResultFormQueryVariables>(LanguageResultFormDocument, options);
      }
export function useLanguageResultFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LanguageResultFormQuery, LanguageResultFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LanguageResultFormQuery, LanguageResultFormQueryVariables>(LanguageResultFormDocument, options);
        }
export type LanguageResultFormQueryHookResult = ReturnType<typeof useLanguageResultFormQuery>;
export type LanguageResultFormLazyQueryHookResult = ReturnType<typeof useLanguageResultFormLazyQuery>;
export type LanguageResultFormQueryResult = Apollo.QueryResult<LanguageResultFormQuery, LanguageResultFormQueryVariables>;
export const LanguageRequirementsLinkDocument = gql`
    query LanguageRequirementsLink {
  me {
    id
    ... on CandidateV2 {
      profession {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useLanguageRequirementsLinkQuery__
 *
 * To run a query within a React component, call `useLanguageRequirementsLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageRequirementsLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageRequirementsLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useLanguageRequirementsLinkQuery(baseOptions?: Apollo.QueryHookOptions<LanguageRequirementsLinkQuery, LanguageRequirementsLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LanguageRequirementsLinkQuery, LanguageRequirementsLinkQueryVariables>(LanguageRequirementsLinkDocument, options);
      }
export function useLanguageRequirementsLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LanguageRequirementsLinkQuery, LanguageRequirementsLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LanguageRequirementsLinkQuery, LanguageRequirementsLinkQueryVariables>(LanguageRequirementsLinkDocument, options);
        }
export type LanguageRequirementsLinkQueryHookResult = ReturnType<typeof useLanguageRequirementsLinkQuery>;
export type LanguageRequirementsLinkLazyQueryHookResult = ReturnType<typeof useLanguageRequirementsLinkLazyQuery>;
export type LanguageRequirementsLinkQueryResult = Apollo.QueryResult<LanguageRequirementsLinkQuery, LanguageRequirementsLinkQueryVariables>;
export const JobPreferencesOverviewCardDocument = gql`
    query JobPreferencesOverviewCard {
  me {
    id
    ...JobPreferencesApplicantProps
    ...JobPreferencesCandidateV2Props
  }
}
    ${JobPreferencesApplicantPropsFragmentDoc}
${JobPreferencesCandidateV2PropsFragmentDoc}`;

/**
 * __useJobPreferencesOverviewCardQuery__
 *
 * To run a query within a React component, call `useJobPreferencesOverviewCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPreferencesOverviewCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPreferencesOverviewCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobPreferencesOverviewCardQuery(baseOptions?: Apollo.QueryHookOptions<JobPreferencesOverviewCardQuery, JobPreferencesOverviewCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPreferencesOverviewCardQuery, JobPreferencesOverviewCardQueryVariables>(JobPreferencesOverviewCardDocument, options);
      }
export function useJobPreferencesOverviewCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPreferencesOverviewCardQuery, JobPreferencesOverviewCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPreferencesOverviewCardQuery, JobPreferencesOverviewCardQueryVariables>(JobPreferencesOverviewCardDocument, options);
        }
export type JobPreferencesOverviewCardQueryHookResult = ReturnType<typeof useJobPreferencesOverviewCardQuery>;
export type JobPreferencesOverviewCardLazyQueryHookResult = ReturnType<typeof useJobPreferencesOverviewCardLazyQuery>;
export type JobPreferencesOverviewCardQueryResult = Apollo.QueryResult<JobPreferencesOverviewCardQuery, JobPreferencesOverviewCardQueryVariables>;
export const ProfileOverviewCardDocument = gql`
    query ProfileOverviewCard {
  me {
    id
    forenames
  }
}
    `;

/**
 * __useProfileOverviewCardQuery__
 *
 * To run a query within a React component, call `useProfileOverviewCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileOverviewCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileOverviewCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileOverviewCardQuery(baseOptions?: Apollo.QueryHookOptions<ProfileOverviewCardQuery, ProfileOverviewCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileOverviewCardQuery, ProfileOverviewCardQueryVariables>(ProfileOverviewCardDocument, options);
      }
export function useProfileOverviewCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileOverviewCardQuery, ProfileOverviewCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileOverviewCardQuery, ProfileOverviewCardQueryVariables>(ProfileOverviewCardDocument, options);
        }
export type ProfileOverviewCardQueryHookResult = ReturnType<typeof useProfileOverviewCardQuery>;
export type ProfileOverviewCardLazyQueryHookResult = ReturnType<typeof useProfileOverviewCardLazyQuery>;
export type ProfileOverviewCardQueryResult = Apollo.QueryResult<ProfileOverviewCardQuery, ProfileOverviewCardQueryVariables>;
export const QuestionResponseFormDocument = gql`
    query QuestionResponseForm {
  me {
    id
    ... on CandidateV2 {
      questionResponses {
        id
        question
        response
      }
      profileCompletion
    }
  }
  profileQuestions
}
    `;

/**
 * __useQuestionResponseFormQuery__
 *
 * To run a query within a React component, call `useQuestionResponseFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionResponseFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionResponseFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuestionResponseFormQuery(baseOptions?: Apollo.QueryHookOptions<QuestionResponseFormQuery, QuestionResponseFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionResponseFormQuery, QuestionResponseFormQueryVariables>(QuestionResponseFormDocument, options);
      }
export function useQuestionResponseFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionResponseFormQuery, QuestionResponseFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionResponseFormQuery, QuestionResponseFormQueryVariables>(QuestionResponseFormDocument, options);
        }
export type QuestionResponseFormQueryHookResult = ReturnType<typeof useQuestionResponseFormQuery>;
export type QuestionResponseFormLazyQueryHookResult = ReturnType<typeof useQuestionResponseFormLazyQuery>;
export type QuestionResponseFormQueryResult = Apollo.QueryResult<QuestionResponseFormQuery, QuestionResponseFormQueryVariables>;
export const RegistrationDetailFormDocument = gql`
    query RegistrationDetailForm {
  me {
    id
    ... on CandidateV2 {
      registrationDetails {
        id
        country
        countryInfo {
          name
        }
        referenceNumber
      }
      profileCompletion
    }
  }
}
    `;

/**
 * __useRegistrationDetailFormQuery__
 *
 * To run a query within a React component, call `useRegistrationDetailFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationDetailFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationDetailFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegistrationDetailFormQuery(baseOptions?: Apollo.QueryHookOptions<RegistrationDetailFormQuery, RegistrationDetailFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegistrationDetailFormQuery, RegistrationDetailFormQueryVariables>(RegistrationDetailFormDocument, options);
      }
export function useRegistrationDetailFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegistrationDetailFormQuery, RegistrationDetailFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegistrationDetailFormQuery, RegistrationDetailFormQueryVariables>(RegistrationDetailFormDocument, options);
        }
export type RegistrationDetailFormQueryHookResult = ReturnType<typeof useRegistrationDetailFormQuery>;
export type RegistrationDetailFormLazyQueryHookResult = ReturnType<typeof useRegistrationDetailFormLazyQuery>;
export type RegistrationDetailFormQueryResult = Apollo.QueryResult<RegistrationDetailFormQuery, RegistrationDetailFormQueryVariables>;
export const ImportFromCvDocument = gql`
    query ImportFromCv {
  me {
    id
    ... on CandidateV2 {
      cv {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useImportFromCvQuery__
 *
 * To run a query within a React component, call `useImportFromCvQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportFromCvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportFromCvQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportFromCvQuery(baseOptions?: Apollo.QueryHookOptions<ImportFromCvQuery, ImportFromCvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportFromCvQuery, ImportFromCvQueryVariables>(ImportFromCvDocument, options);
      }
export function useImportFromCvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportFromCvQuery, ImportFromCvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportFromCvQuery, ImportFromCvQueryVariables>(ImportFromCvDocument, options);
        }
export type ImportFromCvQueryHookResult = ReturnType<typeof useImportFromCvQuery>;
export type ImportFromCvLazyQueryHookResult = ReturnType<typeof useImportFromCvLazyQuery>;
export type ImportFromCvQueryResult = Apollo.QueryResult<ImportFromCvQuery, ImportFromCvQueryVariables>;
export const UpdateCandidateCvCacheDocument = gql`
    query UpdateCandidateCVCache {
  me {
    id
    ... on CandidateV2 {
      cv {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useUpdateCandidateCvCacheQuery__
 *
 * To run a query within a React component, call `useUpdateCandidateCvCacheQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateCvCacheQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateCandidateCvCacheQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdateCandidateCvCacheQuery(baseOptions?: Apollo.QueryHookOptions<UpdateCandidateCvCacheQuery, UpdateCandidateCvCacheQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateCandidateCvCacheQuery, UpdateCandidateCvCacheQueryVariables>(UpdateCandidateCvCacheDocument, options);
      }
export function useUpdateCandidateCvCacheLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateCandidateCvCacheQuery, UpdateCandidateCvCacheQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateCandidateCvCacheQuery, UpdateCandidateCvCacheQueryVariables>(UpdateCandidateCvCacheDocument, options);
        }
export type UpdateCandidateCvCacheQueryHookResult = ReturnType<typeof useUpdateCandidateCvCacheQuery>;
export type UpdateCandidateCvCacheLazyQueryHookResult = ReturnType<typeof useUpdateCandidateCvCacheLazyQuery>;
export type UpdateCandidateCvCacheQueryResult = Apollo.QueryResult<UpdateCandidateCvCacheQuery, UpdateCandidateCvCacheQueryVariables>;
export const PassportSectionDocument = gql`
    query PassportSection {
  me {
    id
    ... on CandidateV2 {
      coreDocuments {
        passport {
          ...CoreDocumentsFields
        }
      }
    }
  }
}
    ${CoreDocumentsFieldsFragmentDoc}`;

/**
 * __usePassportSectionQuery__
 *
 * To run a query within a React component, call `usePassportSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePassportSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePassportSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function usePassportSectionQuery(baseOptions?: Apollo.QueryHookOptions<PassportSectionQuery, PassportSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PassportSectionQuery, PassportSectionQueryVariables>(PassportSectionDocument, options);
      }
export function usePassportSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PassportSectionQuery, PassportSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PassportSectionQuery, PassportSectionQueryVariables>(PassportSectionDocument, options);
        }
export type PassportSectionQueryHookResult = ReturnType<typeof usePassportSectionQuery>;
export type PassportSectionLazyQueryHookResult = ReturnType<typeof usePassportSectionLazyQuery>;
export type PassportSectionQueryResult = Apollo.QueryResult<PassportSectionQuery, PassportSectionQueryVariables>;
export const UpdateJobPreferencesDocument = gql`
    mutation UpdateJobPreferences($input: UpdateCurrentCandidateInput!) {
  updateCurrentCandidate(input: $input) {
    id
    ...JobPreferencesCandidateV2Props
  }
}
    ${JobPreferencesCandidateV2PropsFragmentDoc}`;
export type UpdateJobPreferencesMutationFn = Apollo.MutationFunction<UpdateJobPreferencesMutation, UpdateJobPreferencesMutationVariables>;

/**
 * __useUpdateJobPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateJobPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPreferencesMutation, { data, loading, error }] = useUpdateJobPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobPreferencesMutation, UpdateJobPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobPreferencesMutation, UpdateJobPreferencesMutationVariables>(UpdateJobPreferencesDocument, options);
      }
export type UpdateJobPreferencesMutationHookResult = ReturnType<typeof useUpdateJobPreferencesMutation>;
export type UpdateJobPreferencesMutationResult = Apollo.MutationResult<UpdateJobPreferencesMutation>;
export type UpdateJobPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateJobPreferencesMutation, UpdateJobPreferencesMutationVariables>;
export const SendMessageOptimisticAuthorDocument = gql`
    query SendMessageOptimisticAuthor {
  me {
    ...MessageAuthorFields
  }
}
    ${MessageAuthorFieldsFragmentDoc}`;

/**
 * __useSendMessageOptimisticAuthorQuery__
 *
 * To run a query within a React component, call `useSendMessageOptimisticAuthorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendMessageOptimisticAuthorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendMessageOptimisticAuthorQuery({
 *   variables: {
 *   },
 * });
 */
export function useSendMessageOptimisticAuthorQuery(baseOptions?: Apollo.QueryHookOptions<SendMessageOptimisticAuthorQuery, SendMessageOptimisticAuthorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendMessageOptimisticAuthorQuery, SendMessageOptimisticAuthorQueryVariables>(SendMessageOptimisticAuthorDocument, options);
      }
export function useSendMessageOptimisticAuthorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendMessageOptimisticAuthorQuery, SendMessageOptimisticAuthorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendMessageOptimisticAuthorQuery, SendMessageOptimisticAuthorQueryVariables>(SendMessageOptimisticAuthorDocument, options);
        }
export type SendMessageOptimisticAuthorQueryHookResult = ReturnType<typeof useSendMessageOptimisticAuthorQuery>;
export type SendMessageOptimisticAuthorLazyQueryHookResult = ReturnType<typeof useSendMessageOptimisticAuthorLazyQuery>;
export type SendMessageOptimisticAuthorQueryResult = Apollo.QueryResult<SendMessageOptimisticAuthorQuery, SendMessageOptimisticAuthorQueryVariables>;
export const GetAttachmentUploadTokenDocument = gql`
    query GetAttachmentUploadToken($input: GetAttachmentUploadTokenInput!) {
  getAttachmentUploadToken(input: $input) {
    token
    url
  }
}
    `;

/**
 * __useGetAttachmentUploadTokenQuery__
 *
 * To run a query within a React component, call `useGetAttachmentUploadTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentUploadTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentUploadTokenQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAttachmentUploadTokenQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentUploadTokenQuery, GetAttachmentUploadTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentUploadTokenQuery, GetAttachmentUploadTokenQueryVariables>(GetAttachmentUploadTokenDocument, options);
      }
export function useGetAttachmentUploadTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentUploadTokenQuery, GetAttachmentUploadTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentUploadTokenQuery, GetAttachmentUploadTokenQueryVariables>(GetAttachmentUploadTokenDocument, options);
        }
export type GetAttachmentUploadTokenQueryHookResult = ReturnType<typeof useGetAttachmentUploadTokenQuery>;
export type GetAttachmentUploadTokenLazyQueryHookResult = ReturnType<typeof useGetAttachmentUploadTokenLazyQuery>;
export type GetAttachmentUploadTokenQueryResult = Apollo.QueryResult<GetAttachmentUploadTokenQuery, GetAttachmentUploadTokenQueryVariables>;
export const UploadMessageDocument = gql`
    mutation UploadMessage($input: CreateMessageInput!) {
  createMessage(input: $input) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;
export type UploadMessageMutationFn = Apollo.MutationFunction<UploadMessageMutation, UploadMessageMutationVariables>;

/**
 * __useUploadMessageMutation__
 *
 * To run a mutation, you first call `useUploadMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMessageMutation, { data, loading, error }] = useUploadMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadMessageMutation(baseOptions?: Apollo.MutationHookOptions<UploadMessageMutation, UploadMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMessageMutation, UploadMessageMutationVariables>(UploadMessageDocument, options);
      }
export type UploadMessageMutationHookResult = ReturnType<typeof useUploadMessageMutation>;
export type UploadMessageMutationResult = Apollo.MutationResult<UploadMessageMutation>;
export type UploadMessageMutationOptions = Apollo.BaseMutationOptions<UploadMessageMutation, UploadMessageMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  me {
    ...UserHeaderFragment
    surname
    email
    account {
      id
      verified
    }
    isActive
    notificationsMutedUntil
    ... on CandidateV2 {
      hasSetPreferences
    }
  }
}
    ${UserHeaderFragmentFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($documentId: MigrateID!) {
  deleteDocument(id: $documentId) {
    id
  }
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const GetDocumentUploadTokenDocument = gql`
    query GetDocumentUploadToken($filename: String) {
  getDocumentUploadToken(input: {filename: $filename}) {
    token
    url
  }
}
    `;

/**
 * __useGetDocumentUploadTokenQuery__
 *
 * To run a query within a React component, call `useGetDocumentUploadTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentUploadTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentUploadTokenQuery({
 *   variables: {
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGetDocumentUploadTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentUploadTokenQuery, GetDocumentUploadTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentUploadTokenQuery, GetDocumentUploadTokenQueryVariables>(GetDocumentUploadTokenDocument, options);
      }
export function useGetDocumentUploadTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentUploadTokenQuery, GetDocumentUploadTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentUploadTokenQuery, GetDocumentUploadTokenQueryVariables>(GetDocumentUploadTokenDocument, options);
        }
export type GetDocumentUploadTokenQueryHookResult = ReturnType<typeof useGetDocumentUploadTokenQuery>;
export type GetDocumentUploadTokenLazyQueryHookResult = ReturnType<typeof useGetDocumentUploadTokenLazyQuery>;
export type GetDocumentUploadTokenQueryResult = Apollo.QueryResult<GetDocumentUploadTokenQuery, GetDocumentUploadTokenQueryVariables>;
export const UploadDocumentDocument = gql`
    mutation UploadDocument($input: UploadDocumentInput!) {
  uploadDocument(input: $input) {
    id
    fileMetadata {
      filename
      size
      createdAt
    }
    url
    type
    typeProps {
      name
    }
  }
}
    `;
export type UploadDocumentMutationFn = Apollo.MutationFunction<UploadDocumentMutation, UploadDocumentMutationVariables>;

/**
 * __useUploadDocumentMutation__
 *
 * To run a mutation, you first call `useUploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentMutation, { data, loading, error }] = useUploadDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadDocumentMutation, UploadDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDocumentMutation, UploadDocumentMutationVariables>(UploadDocumentDocument, options);
      }
export type UploadDocumentMutationHookResult = ReturnType<typeof useUploadDocumentMutation>;
export type UploadDocumentMutationResult = Apollo.MutationResult<UploadDocumentMutation>;
export type UploadDocumentMutationOptions = Apollo.BaseMutationOptions<UploadDocumentMutation, UploadDocumentMutationVariables>;